export const messages = {
  it: {
    AdminOperatorsList: {
      abilita_tooltip: "Abilita utenza",
      abilita_utenza_titolo: "Abilitare utenza operatore",
      abilita_utenza_testo: "Confermi l'abilitazione di questa utenza?",
      nome: "Nome",
      email: "Email",
      ruolo: "Ruolo",
      operatore: "operatore",
      abilitazione_successo: "Utenza abilitata",
      abilitazione_errore: "Errore durante l'abilitazione dell'utenza"
    },
    ArchivioSanitarioComponent: {
      aria_tablist_label: "Sezioni profilo sanitario",
      tab_parametri: "Parametri",
      tab_esami: "Esami",
      tab_referti: "Referti",
      tab_altri_file: "Altri file",
      tab_questionari: "Questionari",
      tab_sessioni: "Sessioni",
      aria_selector_parametri: "Seleziona sezione Parametri",
      aria_selector_esami: "Seleziona sezione Esami",
      aria_selector_referti: "Seleziona sezione Referti",
      aria_selector_altri_file: "Seleziona sezione Altri file",
      aria_selector_scores: "Seleziona sezione Scores",
      aria_selector_questionari: "Seleziona sezione Questionari",
      aria_selector_sessioni: "Seleziona sezione Sessioni",
    },
    SessionDetailModal: {
      dettaglio_sessione: "Dettaglio sessione",
      questionari_nella_sessione: "Questionari nella sessione",
      vedi: "Vedi",
    },
    SchedaPaziente: {
      archivio_sanitario: "Archivio sanitario",
      apri_archivio_sanitario: "Apri archivio sanitario",
    },
    PatientArchive: {
      titolo: "Archivio sanitario",
      carica_documento: "carica documento",
      annulla_caricamento: "Annulla caricamento",
      caricamento_contenuti: "Caricamento contenuti...",
      nessun_documento: "Nessun documento disponibile",
      nome_documento: "Documento",
      data_caricamento: "Data caricamento",
      azioni: "Azioni",
      archivia: "Archivia",
      ripristina: "Ripristina",
      elimina: "Elimina",
    },
    PatientArchiveCittadino: {
      titolo: "Archivio sanitario",
      nuovo_documento: "nuovo file",
      modal_upload_titolo: "Carica nuovo documento",
      visualizza: "Visualizza",
      scarica: "Scarica",
      elimina_risorsa: "Elimina risorsa",
      conferma_eliminazione_titolo: "Conferma eliminazione",
      conferma_eliminazione_testo: "Sei sicuro di voler eliminare definitivamente questo documento?",
      nessun_documento: "Nessun documento disponibile",
      caricato_da: "Caricato da",
      aria_visualizza: "Visualizza {name}",
      aria_scarica: "Scarica {name}",
      aria_elimina: "Elimina {name}"
    },
    welcome: "Benvenuto",
    logout: "Esci",
    profile: "Profilo",
    hello: "Ciao",
    richieste_prenotazione: "Richieste di prenotazione",
    esci: "Esci",
    seleziona_lingua: "Seleziona lingua",
    non_verificato_email: "Non hai ancora verificato il tuo indirizzo email",
    tooltip_email: "Per potere utilizzare la piattaforma è necessario verificare l'indirizzo email",
    non_verificato_telefono: "Non hai ancora verificato il tuo numero di telefono",
    tooltip_telefono: "Per potere utilizzare la piattaforma è necessario verificare il numero di telefono",
    non_compilata_anagrafica: "Non hai ancora compilato la tua anagrafica",
    tooltip_anagrafica: "Per usufruire a pieno di tutti i servizi messi a disposizione da questa piattaforma è necessario compilare la propria scheda anagrafica",
    titolo_informativa: "Termini e Condizioni e Informativa Privacy",
    testo_informativa:
      "Per concludere la registrazione è necessario confermare la presa visione delle",
    condizioni_generali: "condizioni generali di contratto",
    informativa_privacy: "Informativa Privacy",
    ho_letto_privacy: "Ho letto e accetto la",
    non_accetto: "Non accetto",
    ho_letto_termini: "Ho letto e accetto",
    termini_uso: "Termini e Condizioni d'uso del servizio",
    accetto_esplicitamente: "Ai sensi dell'articolo 1341 e ss c.c. accetto espressamente le previsioni di cui agli articoli 2, 7, 8, 10, 12 dei presenti",
    titolo_marketing: "Autorizzazione alle comunicazioni commerciali",
    acconsento_marketing:
      "Acconsento alla ricezione di comunicazioni commerciali per finalità promozionali come da",
    conferma_scelte: "Conferma le mie scelte",
    registrati: "Registrati",
    numero_supporto: "800.770.272",
    placeholder_email: "email@mail.it",
    placeholder_password: "Password",
    dimenticato_password: "Ho dimenticato la password",
    credenziali_errate: "Credenziali errate.",
    accedi: "Accedi",
    recupera_password: "Recupera password",
    testo_recupera_password: "Inserisci l'indirizzo email utilizzato in fase di registrazione.",
    placeholder_inserisci_email: "Inserisci email...",
    alert_demo_cie_spid: "Accesso con CIE e SPID non disponibile in ambiente demo",
    mail_inviata: "Mail inviata! Controlla la tua posta elettronica.",
    email_non_valida: "Indirizzo non valido",
    invia: "Invia",
    hai_bisogno_aiuto: "Hai bisogno di aiuto?",
    contattaci: "Contattaci",
    indietro: "Indietro",
    registrazione: "Registrazione",
    registrati_descrizione: "Registrati gratuitamente alla nostra piattaforma per entrare nel mondo ConCura e ricevere un servizio su misura, rapido e sempre al tuo fianco per prenderti cura della tua salute.",
    numero_supporto: "800.770.272",
    step: "Step",
    sono_cittadino: "Sono un cittadino",
    sono_operatore: "Sono un operatore sanitario",
    consulta_informativa_privacy: "Consulta Informativa Privacy",
    utenza_disabilitata: "Utenza disabilitata",
    messaggio_utenza_disabilitata: "La tua utenza è stata disabilitata",
    reimposta_password_titolo: "Reimposta la tua password",
    reimposta_password_descrizione_1: "La nuova password deve contenere almeno 8 caratteri, di cui almeno un numero, una maiuscola, una minuscola ed un",
    reimposta_password_carattere_speciale: "carattere speciale",
    tooltip_password_special_chars: "Devi usare almeno un carattere tra ! @ # $ % ^ & * ) ( + = . _ -",
    placeholder_nuova_password: "Password...",
    placeholder_conferma_password: "Conferma password...",
    credenziali_errate: "Credenziali errate.",
    salva: "Salva",
    salva_nuova_password: "Salva nuova password",
  manuali_uso: "Manuali d'uso",
  video_tutorial: "Video Tutorial",
  scarica_versione_aggiornata: "Scarica la versione aggiornata",
  scarica_versione_inglese: "Scarica la versione inglese",
  ultima_versione: "Ultima versione",
  altre_versioni: "Altre versioni",
  nessun_manuale: "Nessun manuale disponibile",
  scarica_selezionato: "Scarica versione selezionata",
    recupera_password: "Recupera la tua password",
    mail_inviata_controlla: "Mail inviata! Controlla la tua posta elettronica.",
    non_ho_ricevuto_email: "Non ho ricevuto l'email",
    inserisci_email_registrazione: "Inserisci l'indirizzo email utilizzato in fase di registrazione.",
    placeholder_email: "email@ ...",
    annulla: "Annulla",
    chiudi: "Chiudi",
    crea_sessione: "Crea sessione",
    crea_sessione: "Crea sessione",
    salva_modifiche: "Salva modifiche",
    si_elimina: "Sì, elimina",
    si_conferma: "Sì, conferma",
    si_procedi: "Sì, procedi",
    no_annulla: "No, annulla",
    conferma_eliminazione: "Conferma eliminazione",
    rimuovi: "Rimuovi",
    invia: "Invia",
    non_ricordo_email: "Non ricordo l'indirizzo email",
    sms_inviato_cf: "Abbiamo inviato un sms contenente il link per ripristinare la password al numero di telefono indicato per questo codice fiscale.\nAttendi qualche istante.",
    non_ho_ricevuto_sms: "Non ho ricevuto l'sms",
    inserisci_codice_fiscale: "Inserisci il tuo codice fiscale.",
    placeholder_cf: "CODICE FISCALE...",
    sms_inviato_telefono_riserva: "Un sms contenente il link per ripristinare la password è stato inviato al numero di telefono di riserva, se impostato. Attendi qualche istante.",
    nessun_link_contatta_assistenza: "Se non lo hai impostato o non hai ricevuto nessun link e non sei quindi riuscito a recuperare l'accesso,",
    invia_richiesta_supporto: "invia una richiesta di supporto in assistenza",
    torna_login: "Torna alla pagina di login",
    invia_numero_riserva: "Invia al numero di riserva",
    registrazione_successo: "Registrazione avvenuta con successo!",
    benvenuto: "Benvenuto",
    email_confermata_successo: "Grazie per aver confermato il tuo indirizzo email.",
    vai_homepage: "Vai alla Homepage",
    email_gia_verificata: "Email già verificata.",
    email_gia_verificata_descrizione: "Hai già confermato il tuo indirizzo email. Se non lo hai ancora fatto, procedi con la compilazione della tua scheda anagrafica.",
    vai_scheda_anagrafica: "Scheda anagrafica",
    conferma_email: "Conferma la tua email",
    link_non_valido: "Il link utilizzato non è più valido.",
    email_non_ricevuta_controlla_spam: "Se non hai ricevuto la mail di conferma controlla nella cartella spam della tua casella di posta elettronica oppure",
    richiedi_nuova_mail: "richiedi una nuova mail di conferma",
    invia_nuova_mail: "Invia nuova mail",
    verifica_numero_telefono: "Verifica il tuo numero di telefono",
    verifica_istruzioni_1: "Per utilizzare la piattaforma è necessario completare la procedura di registrazione verificando il numero di telefono indicato.",
    verifica_istruzioni_link: "Controlla il numero indicato.",
    verifica_istruzioni_2: 'Clicca su "invia codice di verifica" per inviare il codice OTP di accesso via SMS al numero indicato.',
    inserisci_numero_telefono: "Inserisci il tuo numero di telefono",
    inserisci_istruzioni: "Per utilizzare la piattaforma è necessario inserire e verificare il numero di telefono.",
    etichetta_numero_telefono: "Numero di telefono:",
    placeholder_numero: "1234...",
    salva_numero: "Salva numero",
    invia_codice_verifica: "Invia codice di verifica",
    verifica_fuori_piattaforma: "Verifica numero di telefono fuori piattaforma",
    verifica_otp: "Verifica OTP",
    codice_verificato: "Codice verificato correttamente!",
    prosegui_istruzioni: "Grazie per aver completato la procedura. Clicca su 'Chiudi' per proseguire.",
    sms_inviato: "Abbiamo inviato via SMS il codice di verifica al numero {numero}",
    inserisci_codice: "Inserisci il codice numerico ricevuto via SMS:",
    otp_status_0: "Codice di verifica inviato",
    otp_status_minus1: "Errore di sistema",
    otp_status_1: "Codice verificato correttamente",
    otp_status_2: "Codice errato",
    otp_status_3: "Codice scaduto",
    otp_status_4: "Codice già verificato",
    otp_status_5: "Codice cancellato",
    codice_scade: "Il codice inviato scadrà tra",
    secondi: "secondi",
    codice_scaduto: "Codice scaduto",
    non_ricevuto: "Non hai ricevuto il codice?",
    invia_nuovo_codice: "Invia nuovo codice",
    alternativa: "In alternativa,",
    invia_otp_riserva: "invia OTP al numero di riserva (se disponibile).",
    chiudi: "Chiudi",
    verifica: "Verifica",
    verifica_non_completata: "Non è stato possibile completare la verifica.",
    verifica_controlla_assistenza: "Controlla che il numero memorizzato in anagrafica sia corretto. In caso di difficoltà, contatta l'assistenza.",
    verifica_manuale: "Verifica Manuale",
    manuale_istruzioni: "Per favore, chiama il numero dell'utente per verificare il contatto.",
    chiama: "Chiama",
    annulla: "Annulla",
    contrassegna_verificato: "Contrassegna numero come verificato",
    non_possibile_effettuare_procedura: "Non è stato possibile effettuare la procedura.",
    numero_verificato_successo: "Numero contrassegnato come verificato.",
    errore_verifica_numero: "Si è verificato un errore durante la verifica del numero.",
    vai_homepage: "Vai alla Homepage",
    errore_salvataggio_pagamento: "Errore salvataggio pagamento. Verificare nella propria area privata.",
    effettua_login: "Effettua il login",
    richieste_prenotazione: "Richieste di prenotazione",
    visite_prestazioni: "Visite e prestazioni",
    farmaci: "Farmaci",
    teleconsulti: "Teleconsulti",
    teleconsulto_rapido: "Teleconsulto rapido",
    errore_recupero_prenotazioni: "Non è stato possibile recuperare le prenotazioni recenti",
    buongiorno: "Buongiorno",
    buon_pomeriggio: "Buon pomeriggio",
    buona_sera: "Buona sera",
    attesa_pagamento: "attesa pagamento",
    vai_alla_prenotazione: "Vai alla prenotazione",
    vedi_dettagli_prenotazione: "Vedi dettagli prenotazione",
    nessuna_prenotazione_oggi: "Nessuna prenotazione per oggi.",
    vedi_tutte_sottoscrizioni: "Vedi tutte le sottoscrizioni",
    piano_attivo: "Piano attivo",
    durata_minima: "Durata minima",
    si_rinnova_il: "Si rinnova il",
    scadra_il: "Scadrà il",
    leggi_di_piu: "Leggi di più",
    cosa_prevede_sottoscrizione: "Cosa prevede la tua sottoscrizione",
    prestazioni_disponibili: "Prestazioni disponibili",
    ordine_farmaci_disponibili: "Ordine farmaci disponibili",
    effettua_upgrade_sottoscrizione: "Effettua l'upgrade della sottoscrizione",
    gratis: "GRATIS",
    errore_operazione: "Non è stato possibile completare l'operazione.",
    piani: "Piani",
    mese: "mese",
    anno: "anno",
    subscriptionDetail: {
      base: "Sottoscrizioni Base",
      advanced: "Sottoscrizioni Avanzate",
      monitoring: "Sottoscrizioni Monitoraggio"
    },
    CompilazioneQuestionario: {
      otp_verifica_titolo: "Invia OTP all'operatore",
      otp_verifica_testo: "Invia il codice OTP all'operatore per validare la compilazione.",
      invio_successo: "Questionario inviato correttamente."
    },
    successUpdate: "Anagrafica aggiornata con successo!",
    convenzioni: "Convenzioni",
    richiedi_voucher: "Richiedi il voucher",
    richiedi_teleconsulto_rapido: "Richiedi Teleconsulto Rapido",
    teleconsulto_rapido: "Teleconsulto Rapido",
    medico_contatto_entro_60_minuti: "Un medico ti contatterà entro 60 minuti dalla richiesta.",
    durata_massima_15_minuti: "Il Teleconsulto Rapido ha una durata massima di 15 minuti.",
    motivo_richiesta: "Motivo della richiesta",
    scrivi_motivo: "Scrivi il motivo",
    costo_prestazione: "Costo della prestazione",
    iva_inclusa: "IVA inclusa",
    iva_esclusa: "+ IVA",
    riprova: "Riprova",
    annulla: "Annulla",
    nessun_operatore_disponibile: "Nessun operatore disponibile in questo momento. Riprova più tardi.",
    in_attesa_di_risposta: "In attesa di risposta",
    medico_presto_disponibile: "A breve il medico prenderà in carico la tua richiesta",
    rimani_collegato: "Rimani collegato",
    programmato_ore: "Programmato per le ore",
    avvia_ora: "Avvia ora",
    clicca_per_pagamento_nexi: "Clicca su 'Completa Acquisto' per avviare la sessione sicura di pagamento Nexi e finalizzare il tuo acquisto.",
    clicca_per_privacy_nexi: "Clicca",
    carte_accettate: "Carte accettate:",
    errore_pagamento_link: "Non è stato possibile inizializzare il pagamento. Contattare l'assistenza",
    errore_salvataggio_pagamento_semplice: "Errore salvataggio pagamento",
    link_pagamento_inviato: "Un link per il pagamento è stato inviato al tuo indirizzo email.",
    completa_acquisto: "Completa Acquisto",
    link_pagamento_inviato: "Un link per il pagamento è stato inviato al tuo indirizzo email.",
    errore_pagamento_link: "Non è stato possibile inizializzare il pagamento. Contattare l'assistenza",
    errore_salvataggio_pagamento_semplice: "Errore salvataggio pagamento",
    non_puoi_lasciare_pagina_pagamento: "Non puoi uscire da questa pagina durante la procedura di pagamento.",
    richiedi_tc_pediatrico: "Richiedi Teleconsulto Pediatrico",
    teleconsulto_pediatrico: "Teleconsulto Pediatrico",
    tc_pediatrico_descrizione_1: "Un medico ti contatterà entro 60 minuti dalla richiesta.",
    tc_pediatrico_descrizione_2: "Il Teleconsulto Pediatrico ha una durata massima di 15 minuti.",
    scegli_familiare: "Scegli familiare (facoltativo)",
    motivo_richiesta: "Motivo della richiesta",
    placeholder_motivo: "Scrivi il motivo",
    costo_prestazione: "Costo della prestazione",
    iva_inclusa: "IVA inclusa",
    piu_iva: "+ iva {percentuale} %",
    in_attesa_risposta: "In attesa di risposta",
    tc_medico_in_carico: "A breve il medico prenderà in carico la tua richiesta",
    rimani_collegato: "Rimani collegato",
    programmato_per_ore: "Programmato per le ore",
    avvia_ora: "Avvia ora",
    errore_info_pagamento: "Non è stato possibile recuperare le informazioni relative al pagamento",
    errore_inoltro_richiesta: "Non è stato possibile inoltrare la richiesta",
    nessun_operatore_disponibile: "Nessun operatore disponibile in questo momento",
    transazione_non_finalizzata: "Transazione non finalizzata",
    errore_operazione: "Non è stato possibile effettuare l'operazione",
    errore_recupero_informazioni: "Non è stato possibile recuperare le informazioni richieste",
    registra_familiare: "Registra Familiare",
    scegli_familiare: "Scegli familiare",
    titolo_nuovo_familiare: "Nuovo familiare",
    nome: "Nome",
    placeholder_nome: "Nome...",
    cognome: "Cognome",
    placeholder_cognome: "Cognome...",
    codice_fiscale: "Codice fiscale",
    placeholder_cf: "Codice fiscale...",
    numero_tessera_sanitaria: "Numero Tessera Sanitaria",
    placeholder_ts_number: "Numero tessera...",
    fascia_eta: "Fascia d'età",
    seleziona_fascia_eta: "Seleziona fascia d'età",
    relazione: "Relazione",
    seleziona_relazione: "Seleziona relazione",
    genere: "Genere",
    maschile: "Maschile",
    femminile: "Femminile",
    campi_obbligatori: "*Campi obbligatori",
    salva: "Salva",
    nuovo_familiare_successo: "Nuovo familiare inserito con successo!",
    errore_salvataggio_familiare: "Non è stato possibile salvare le informazioni.",
    familiari: "Familiari",
    tutti: "Tutti",
    nuovo: "Nuovo",
    paziente_non_trovato: "Paziente non trovato",
    data_di_nascita: "Data di nascita",
    non_indicata: "Non indicata",
    i_tuoi_familiari: "I tuoi familiari",
    aggiungi: "Aggiungi",
    tooltip_familiari_1: "Le persone non registrate in piattaforma che hai inserito come tuoi familiari.",
    tooltip_familiari_2: "Clicca sul \"+\" per creare nuovi membri: una volta aggiunti potrai prenotare farmaci e servizi per loro.",
    i_tuoi_assistiti: "I tuoi assistiti",
    tooltip_assistiti: "Le persone che ti hanno scelto come loro caregiver. Queste persone ti hanno dato il permesso di prenotare farmaci e servizi per conto loro.",
    nessun_assistito_registrato: "Non ci sono assistiti registrati per questa utenza.",
    i_tuoi_caregiver: "I tuoi caregiver",
    tooltip_caregivers: "Le persone che si occupano di te. I soggetti di seguito elencati possono prenotare farmaci e servizi per conto tuo.",
    nessun_caregiver_registrato: "Non ci sono caregivers registrati per questa utenza.",
    vuoi_abilitare: "Vuoi abilitare",
    vuoi_disabilitare: "Vuoi disabilitare",
    come_tuo_caregiver: "come tuo caregiver?",
    conferma_informativa: "Per procedere alla conferma è necessario confermare la presa visione dell'informativa.",
    ho_letto_informativa: "Ho letto e compreso l'informativa privacy",
    acconsento_trattamento_dati: "Acconsento al trattamento dei miei dati personali per le finalità indicate nell'informativa",
    no_annulla: "No, Annulla",
    si_conferma: "Sì, Conferma",
    nessun_utente_selezionato: "Nessun utente selezionato",
    errore_recupero_informazioni: "Non è stato possibile recuperare le informazioni.",
    caregiver_abilitato: "Caregiver abilitato",
    caregiver_disabilitato: "Caregiver disabilitato",
    abilita_caregiver: "Abilita caregiver",
    disabilita_caregiver: "Disabilita caregiver",
    registrazione_step: "Step {n}",
    titolo: "Titolo",
    nome: "Nome",
    cognome: "Cognome",
    codice_azienda: "Codice azienda",
    tooltip_codice_azienda: "Il codice azienda si trova nella sezione impostazioni dell'operatore amministratore di struttura",
    inserisci_codice_azienda: "Inserisci il codice di 10 cifre fornito dalla tua azienda.",
    codice_fiscale: "Codice fiscale",
    data_nascita: "Data di nascita",
    genere: "Genere",
    uomo: "uomo",
    donna: "donna",
    nazione_nascita: "Nazione di nascita",
    indirizzo: "Indirizzo e numero civico",
    cap: "CAP",
    email: "Email",
    telefono: "Numero di telefono",
    telefono_fisso: "Telefono fisso",
    aderisco_progetto: "Aderisco al progetto",
    ordine: "Ordine",
    id_albo: "ID Iscrizione Albo",
    specializzazione: "Specializzazione",
    specializzazione_placeholder: "Specializzazione medica...",
    password: "Password",
    conferma_password: "Conferma password",
    consulta_informativa_privacy: "Consulta Informativa Privacy",
    consulta_termini: "Consulta Termini e Condizioni d'uso del servizio",
    non_accetto: "Non accetto",
    completa: "Completa",
    informativa_commerciale: "Autorizzazione alle comunicazioni commerciali",
    accetta_informativa: "Ho letto e accetto l'Informativa Privacy",
    accetta_termini: "Ho letto e accetto i Termini e Condizioni d'uso del servizio",
    accetta_articoli: "Ai sensi dell'articolo 1341 e ss c.c. accetto espressamente le previsioni di cui agli articoli 2, 7, 8, 10, 12 dei presenti Termini e Condizioni d'uso",
    acconsento_marketing: "Acconsento alla ricezione di comunicazioni commerciali per finalità promozionali",
    avanti: "Avanti",
    regione_residenza: "Regione di residenza",
    regione: "Regione",
    provincia_residenza: "Provincia di residenza",
    provincia: "Provincia",
    comune: "Comune",
    comune_residenza: "Comune di residenza",
    indirizzo_numero_civico: "Indirizzo e numero civico",
    cap: "CAP",
    seleziona_regione: "Seleziona Regione",
    seleziona_provincia: "Seleziona Provincia",
    seleziona_comune: "Seleziona Comune",
    placeholder_indirizzo: "Indirizzo",
    placeholder_cap: "CAP",
    email: "Email",
    numero_telefono: "Numero di telefono",
    telefono_fisso: "Telefono fisso",
    aderisco_progetto: "Aderisco al progetto",
    nessun_progetto: "Nessun progetto",
    nessuna_selezione: "--",
    password: "Password",
    conferma_password: "Conferma password",
    password_requisiti:
      "La password non può includere il nome né il cognome e deve contenere almeno 8 caratteri, di cui almeno un numero, una maiuscola, una minuscola ed un",
    carattere_speciale: "carattere speciale",
    tooltip_carattere_speciale:
      "Devi usare almeno un carattere tra ! @ # $ % ^ & * ) ( + = . _ -",
    termini_condizioni_privacy: "Termini e Condizioni e Informativa Privacy",
    concludi_registrazione_testo:
      "Per concludere la registrazione è necessario confermare la presa visione",
    termini_condizioni_link: "condizioni generali di contratto",
    informativa_privacy_link: "Informativa Privacy",
    accetto_informativa_privacy: "Ho letto e accetto la Informativa Privacy",
    accetto_termini_condizioni:
      "Ho letto e accetto Termini e Condizioni d'uso del servizio",
    accetto_comunicazioni_commerciali:
      "Acconsento alla ricezione di comunicazioni commerciali per finalità promozionali come da Informativa Privacy",
    non_accetto: "Non accetto",
    e: "e",
    progetto_selezionato_testo:
      "**Selezionando il progetto {projectName}, la struttura sanitaria coinvolta nel progetto verrà inserita nel tuo circolo di cura",
    consulta_informativa_privacy: "Consulta Informativa Privacy",
    accetto_termini_condizioni: "Ho letto e accetto",
    termini_condizioni_uso: "Termini e Condizioni d'uso del servizio",
    non_accetto: "Non accetto",
    e: "e",
    accetto_articoli_cc: "Ai sensi dell'articolo 1341 e ss c.c. accetto espressamente le previsioni di cui agli articoli 2, 7, 8, 10, 12 dei presenti",
    autorizzazione_marketing: "Autorizzazione alle comunicazioni commerciali",
    accetto_marketing: "Acconsento alla ricezione di comunicazioni commerciali per finalità promozionali come da",
    scheda: {
      rilevazioni: "Rilevazioni",
      patologie: "Patologie",
      terapie: "Terapie",
      note: "Note",
      dispositivi: "Dispositivi",
      genere: "Genere",
      regione: "Regione",
      indirizzo: "Indirizzo",
      data_nascita: "Data di nascita",
      provincia: "Provincia",
      telefono: "Telefono",
      codice_fiscale: "Codice Fiscale",
      comune: "Comune",
      email: "Email",
      non_indicato: "Non indicato",
      utente_non_trovato: "Utente non trovato",
      alert_recupero_errore: "Non è stato possibile recuperare le informazioni.",
    },
    familiari: {
      nessun_familiare: "Non ci sono familiari registrati per questa utenza.",
      familiari: "Familiari",
      nome: "Nome",
      nome_placeholder: "Nome...",
      cognome: "Cognome",
      cognome_placeholder: "Cognome...",
      cf: "Codice fiscale",
      cf_placeholder: "Codice fiscale...",
      ts: "Numero Tessera Sanitaria",
      ts_placeholder: "Numero tessera...",
      fascia_eta: "Fascia d'età",
      fascia_eta_seleziona: "Seleziona fascia d'età",
      relazione: "Relazione",
      relazione_seleziona: "Seleziona relazione",
      genere: "Genere",
      campi_obbligatori: "*Campi obbligatori",
      annulla: "Annulla",
      salva: "Salva",
      nessun_elemento_selezionato: "Nessun elemento selezionato",
      alert_recupero_errore: "Non è stato possibile recuperare le informazioni richieste.",
      alert_creazione_successo: "Familiare aggiunto con successo",
      alert_creazione_errore: "Non è stato possibile invitare il familiare",
      alert_invito_successo: "Familiare invitato con successo",
      alert_salvataggio_successo: "Informazioni aggiornate con successo",
      alert_salvataggio_errore: "Non è stato possibile aggiornare le informazioni.",
      maschile: "Maschile",
      femminile: "Femminile",
      eta_pediatrica: "età pediatrica",
      adulto: "adulto",
      anziano: "anziano",
      figlio: "figlio",
      genitore: "genitore",
      coniuge: "coniuge",
      convivente: "convivente",
      nipote: "nipote",
      altro_parente: "altro(parente)",
      altro_non_parente: "altro(non parente)",
      fascia_eta: "Fascia d'età",
      ts: "Tessera Sanitaria",
      ts_non_inserita: "Non inserita",
      genere: "Genere",
      relazione: "Relazione",
      cf: "Codice fiscale",
      seleziona_tipo_inserimento: "Seleziona il tipo di inserimento",
      inserimento_semplice: "Inserimento semplice",
      inserimento_semplice_descrizione: "Inserisci manualmente un utente non presente nel sistema",
      utente_registrato: "Utente registrato",
      utente_registrato_descrizione: "Se l'utente è presente nella piattaforma puoi inserirlo tramite codice utente",
      nuovo_familiare: "Nuovo familiare",
      condivisione_dati: "I dati identificativi del tuo familiare saranno condivisi con i professionisti sanitari del tuo circolo di cura",
      nome: "Nome",
      nome_placeholder: "Nome...",
      cognome: "Cognome",
      cognome_placeholder: "Cognome...",
      cf: "Codice fiscale",
      cf_placeholder: "Codice fiscale...",
      ts: "Numero Tessera Sanitaria",
      ts_placeholder: "numero tessera...",
      fascia_eta: "Fascia d'età",
      fascia_eta_seleziona: "seleziona fascia d'età",
      relazione: "Relazione",
      relazione_seleziona: "Seleziona relazione",
      genere: "Genere",
      autorizzazione_dichiarazione: "* Secondo il DPR n.445/2000, dichiaro di essere autorizzato, dalla legge o dal mio familiare, ad utilizzare i servizi ConCura per gestire i dati medici per suo conto",
      campi_obbligatori: "*Campi obbligatori",
      richiesta_codice_descrizione: "Ricerca un tuo parente o un tuo assistito tramite codice utente - visualizzabile nella sezione \"Impostazioni\", sotto \"Codice utente personale\" - ed invitalo a far parte della tua famiglia. L'utente invitato riceverà una email tramite la quale potrà accettare il tuo invito e designarti come proprio caregiver.",
      label_codice: "Inserisci codice utente",
      placeholder_codice: "Codice utente...",
      bottone_cerca: "Cerca",
      utente_trovato: "Trovato un utente:",
      domanda_inviare_richiesta: "Inviare richiesta?",
      invia_richiesta: "Invia richiesta",
      invita: "Invita",
      utente_non_trovato: "Nessun utente trovato.",
      alert_codice_non_trovato: "Codice utente non associato a nessun utente",

    },
    informativa: {
      titolo: "INFORMATIVA SUL TRATTAMENTO DEI DATI PERSONALI PER I SERVIZI DI PRENOTAZIONI, ORDINI E SERVIZI DI TELECONSULTO GESTITI DA FAMILIARI E CAREGIVER",
      sottotitolo: "(art. 14 Reg. UE 679/2016)",
      blocco_1: `
    <h6 class="text-center bg-sec-4 py-2 border-bottom border-dark">Chi tratta i dati del mio familiare/assistito?</h6>
    <p class="px-1 mb-0 border-bottom border-dark">
      Il Titolare del trattamento è la società/ente sanitario aderente a <b>{{ appName }}</b> che tratta i Suoi dati personali per tutte le finalità di seguito precisate,
      della quale può visualizzare i dati di riferimento nella sezione <span class="text-prim-grad-1 fw-bolder">"Il mio circolo di cura"</span> della sua area riservata.
    </p>
  `,
      quali_dati: `
    <h6 class="text-center">1. QUALI MIEI DATI VENGONO TRATTATI?</h6>
    <p>Il Titolare tratterà i Suoi seguenti dati personali:</p>
    <ul>
      <li>Nome e cognome</li>
      <li>Codice fiscale</li>
      <li>Numero tessera sanitaria (facoltativo)</li>
      <li>Fascia di età di appartenenza</li>
      <li>Relazione con il Suo familiare/caregiver</li>
      <li>Tipologia di prestazione, data e ora della prestazione</li>
      <li>Prodotto per cui viene effettuato l'ordine</li>
      <li>Codice NRE e codice REV della ricetta</li>
      <li>Ricetta in formato PDF (facoltativo)</li>
      <li>Patologia per la quale viene richiesto il teleconsulto</li>
      <li>Data e ora del teleconsulto</li>
    </ul>
  `,
      finalita: `
    <h6 class="text-center">2. PER QUALI FINALITÀ SONO TRATTATI I MIEI DATI E PERCHÉ IL TRATTAMENTO È LEGITTIMO?</h6>
    <p>Il Titolare tratta i Suoi dati per consentirLe di prenotare tramite un Suo familiare/caregiver:</p>
    <ul>
      <li>prestazioni presso la farmacia;</li>
      <li>ordini presso la farmacia;</li>
      <li>servizi di teleconsulto presso la farmacia.</li>
    </ul>
    <p>Questo trattamento è legittimo perché:</p>
    <ul>
      <li>per i dati comuni (es. anagrafici), è necessario per dare esecuzione a un contratto di cui Lei è parte;</li>
      <li>per i dati di salute, è basato sul consenso che Lei può manifestare tramite il Suo familiare/caregiver.</li>
    </ul>
  `,
      comunicazioni: `
    <h6 class="text-center">3. A CHI SONO COMUNICATI I MIEI DATI?</h6>
    <p>I Suoi dati sono comunicati:</p>
    <ul>
      <li>alla società Qwince Innovation S.r.l. per la gestione della Piattaforma;</li>
      <li>ai soggetti a cui Lei deciderà di rendere conoscibili i Suoi dati (es. familiari/caregiver).</li>
    </ul>
    <p>
      L'elenco completo è disponibile scrivendo a <a href="mailto:assistenza@concura.online">assistenza@concura.online</a>. I Suoi dati non saranno diffusi.
    </p>
  `,
      trasferimenti: `
    <h6 class="text-center">4. I MIEI DATI SONO TRASFERITI FUORI DALL'UNIONE EUROPEA?</h6>
    <p>No, i Suoi dati non vengono trasferiti al di fuori dell'Unione Europea.</p>
  `,
      conservazione: `
    <h6 class="text-center">5. PER QUANTO TEMPO SONO CONSERVATI I MIEI DATI?</h6>
    <p>
      I dati sono conservati per tutta la durata dell'attività dell'account. Alla disattivazione, saranno cancellati definitivamente o anonimizzati.
    </p>
  `,
      profilazione: `
    <h6 class="text-center">6. SARÒ SOTTOPOSTO A PROFILAZIONE?</h6>
    <p>
      No, i Suoi dati non saranno utilizzati per profilazione né decisioni automatizzate.
    </p>
  `,
      diritti: `
    <h6 class="text-center">7. QUALI SONO I MIEI DIRITTI?</h6>
    <p>Lei ha i seguenti diritti:</p>
    <ul>
      <li><b>Accesso:</b> ottenere conferma e accesso ai dati trattati.</li>
      <li><b>Rettifica:</b> correggere dati inesatti o incompleti.</li>
      <li><b>Cancellazione:</b> in caso di dati non più necessari, trattati illecitamente o obblighi di legge.</li>
      <li><b>Limitazione:</b> in attesa di verifica, opposizione o per motivi giudiziari.</li>
      <li><b>Portabilità:</b> ricevere i dati in formato leggibile e trasferirli ad altro titolare.</li>
      <li><b>Opposizione a decisioni automatizzate:</b> diritto a non essere sottoposto a profilazione automatizzata.</li>
    </ul>
    <p>Può esercitare i Suoi diritti scrivendo al Titolare. Risponderemo entro 30 giorni.</p>
  `,
      raccolta: `
    <h6 class="text-center">8. COME SONO STATI RACCOLTI I MIEI DATI DAL TITOLARE?</h6>
    <p>I Suoi dati sono stati forniti dal Suo familiare/caregiver.</p>
  `,
      reclamo: `
    <h6 class="text-center">9. COME POSSO PRESENTARE RECLAMO?</h6>
    <p>
      Può proporre reclamo all'Autorità Garante per la protezione dei dati personali, secondo le modalità su
      <a href="https://www.garanteprivacy.it" target="_blank">www.garanteprivacy.it</a>.
    </p>
  `
    },
    utente_non_trovato: "Utente non trovato",
    misurazioni: {
      parametri: "Parametri",
      esami: "Esami",
      referti: "Referti",
      nuovo_parametro_btn: "nuova rilevazione parametro",
      nuovo_parametro_title: "Nuova rilevazione parametro",
      trova_parametro: "Trova parametro",
      nuovo_esame_btn: "nuova rilevazione esame",
      nuovo_esame_title: "Nuova rilevazione esame",
      nuovo_referto_btn: "nuovo referto",
      nuovo_referto_title: "Nuovo referto",
      referto_carica_da_file: "Carica referto a partire da file",
      referto_scrivi: "Scrivi referto",
      referto_carica_desc: "Carica un PDF o immagine già pronto",
      referto_scrivi_desc: "Compila il referto con Valutazione, Prescrizione e allegati",
      referto_modal_question: "Come vuoi creare il referto?",
      cerca: "Cerca...",
      data_ora: "Data e Ora Rilevazione",
      inserisci_data: "Inserisci data",
      inserisci_ora: "Inserisci ora",
      visibile_solo_a_me: "visibile solo a me**",
      storico: "Storico",
      anno: "Anno",
      mese: "Mese",
      giorno: "Giorno",
      valori_rilevati: "Valori rilevati",
      scarica: "Scarica",
      referto_seen: "scaricato",
      referto_unseen: "non ancora scaricato",
      nessuna_altra_rilevazione: "Non ci sono altre rilevazioni",
      modifica_valore: "Modifica Valore",
      valore_placeholder: "Valore*",
      conferma: "Conferma",
      si_elimina: "Sì, elimina",
      no_annulla: "No, annulla",
      data_ora: "Data e Ora Rilevazione",
      valori_riferimento: "Valori di riferimento",
      annotazioni: "Annotazioni",
      parametro_osservato: "Il parametro è sotto osservazione.",
      parametro_non_osservato: "Parametro non osservato.",
      visualizza_soglie: "Visualizza soglie",
      imposta_soglie: "Imposta soglie",
      tutti: "tutti",
      referti_richiedono_sottoscrizione: "Per caricare referti occorre avere una sottoscrizione attiva.",
      errore_generico: "Qualcosa è andata storta",
      inserimento_successo: "Misurazione inserita correttamente",
      inserimento_errore: "Non è stato possibile inserire la misurazione",
      aggiornamento_successo: "Misurazione aggiornata correttamente",
      aggiornamento_errore: "Non è stato possibile aggiornare la misurazione",
      eliminazione_successo: "Misurazione eliminata correttamente",
      eliminazione_errore: "Non è stato possibile eliminare la misurazione",
      download_errore: "Non è stato possibile scaricare la risorsa",
      referto: "questo referto",
      esame: "questo esame",
      rilevazione: "questa rilevazione",
      visibileSoloMe: "**se selezioni questa opzione soltanto tu potrai vedere",
      scarica: "Scarica",
      aggiungi: "aggiungi",
      salva_modifiche: "Salva modifiche",
      cancel_title: "Annulla",
      soglie_parametro: "Soglie sul parametro {parametro}",
      elimina_valore: "Vuoi eliminare questo valore di",
      mesi: {
        gennaio: 'Gennaio',
        febbraio: 'Febbraio',
        marzo: 'Marzo',
        aprile: 'Aprile',
        maggio: 'Maggio',
        giugno: 'Giugno',
        luglio: 'Luglio',
        agosto: 'Agosto',
        settembre: 'Settembre',
        ottobre: 'Ottobre',
        novembre: 'Novembre',
        dicembre: 'Dicembre',
      }
    },
    uploader: {
      caricamento_completato: "Caricamento completato",
      placeholder: "Seleziona file...",
      carica: "Carica",
      errore_caricamento: "Errore durante il caricamento del file",
    },
    soglie: {
      valori_soglia_per_parametro: "Valori di soglia sul parametro",
      descrizione_soglie_custom: "Configurando le soglie di criticità dei valori su un parametro...",
      valori_default_parametro: "Valori di default per il parametro",
      descrizione_valori_default: "Di seguito i valori-soglia disponibili per il parametro...",
      usa_default: "Utilizza valori di default per il monitoraggio",
      nessun_valore_default: "Non ci sono valori di default per il parametro",
      soglie_personalizzate: "soglie personalizzate",
      errore_generico: "Qualcosa è andata storta",
      valori_modificati_successo: "Valori modificati correttamente",
      errore_modifica_valori: "Non è stato possibile modificare il valore",
      note_aggiornate: "Note aggiornate correttamente",
      errore_note: "Non è stato possibile aggiornare le note",
      soglia_eliminata: "Soglia eliminata correttamente",
      errore_eliminazione: "Non è stato possibile eliminare il valore",
      valori_impostati: "Valori impostati correttamente",
      conferma_operazione: "Conferma operazione",
      si_elimina: "Sì, elimina",
      no_annulla: "No, annulla",
      sicuro_eliminare: "Sei sicuro di voler eliminare questa soglia?",
      modifica_note: "Modifica note",
      note_soglia: "Note soglia",
      note_titolo: "Note di soglia",
      note_descrizione: "In questi spazi puoi inserire delle note per indicare, in caso di rilevazione del parametro nella soglia selezionata, eventuali azioni da suggerire o intraprendere ai fini diagnostici (Protocollo diagnostico) e/o operativi (Protocollo operativo). Valorizzare uno solo oppure entrambi i campi.",
      protocollo_diagnostico: "Protocollo diagnostico:",
      protocollo_operativo: "Protocollo operativo:",
      placeholder_diagnostico: "Si raccomanda l'indagine per, il consulto con...",
      placeholder_operativo: "Si raccomanda il controllo di, l'assunzione di, l'interruzione di...",
      annulla: "Annulla",
      salva_note: "Salva note"
    },
    FrequenzeRilevazioni: {
      titleAdd: "Nuova frequenza monitoraggio",
      titleUpdate: "Modifica impostazione",
      titleDelete: "Modifica operazione",
      titleConfirm: "Conferma operazione",
      labelEvery: "È necessario rilevare il parametro ogni",
      labelFrequency: "Frequenza rilevazione: una misurazione ogni",
      labelSuspended: "Rilevazione sospesa",
      labelDeleteQuestion: "Vuoi eliminare questa frequenza di monitoraggio?",
      labelEnableQuestion: "Vuoi attivare questa frequenza di monitoraggio?",
      labelDisableQuestion: "Vuoi disattivare questa frequenza di monitoraggio?",
      buttonSetFrequency: "Imposta frequenza rilevazione",
      buttonSave: "Salva frequenza",
      buttonCancel: "Annulla",
      buttonConfirm: "Conferma",
      buttonEdit: "Salva modifiche",
      buttonDeleteYes: "Sì, elimina",
      buttonDeleteNo: "No, annulla",
      everyPlural: {
        0: "mesi",
        1: "settimane",
        2: "giorni",
        3: "ore",
        4: "minuti",
      },
      everySingular: {
        0: "mese",
        1: "settimana",
        2: "giorno",
        3: "ora",
        4: "minuto",
      },
      error_generic: "Qualcosa è andata storta",
      success_saved: "Valori impostati correttamente",
      success_updated: "Impostazione di frequenza modificata correttamente",
      error_update: "Non è stato possibile modificare la frequenza",
      success_deleted: "Impostazione di frequenza eliminata correttamente",
      error_delete: "Non è stato possibile eliminare la frequenza",
      months: "mesi",
      month: "mese",
      weeks: "settimane",
      week: "settimana",
      days: "giorni",
      day: "giorno",
      hours: "ore",
      hour: "ora",
      minutes: "minuti",
      minute: "minuto"
    },
    PatologieComponent: {
      title: "Patologie",
      new: "nuova patologia",
      create: "Crea terapia per",
      searchTitle: "Cerca patologia",
      searchPlaceholder: "Cerca patologia per nome o codice...",
      searchDescription: "*fonte: classificazione ICD-10 aggiornata",
      selectPatologia: "Seleziona patologia",
      nomePatologia: "Nome patologia*",
      tipo: "Tipologia*",
      inizio: "Data di inizio",
      fine: "Data di fine",
      visibileSoloAMe: "visibile solo a me**",
      visibilitaDescrizione: "**se selezioni questa opzione soltanto tu potrai vedere questa patologia",
      annotazioni: "Annotazioni",
      campiObbligatori: "*Campi obbligatori",
      annulla: "Annulla",
      salva: "Salva",
      modifica: "Modifica",
      inseritaIl: "inserita il",
      codicePatologia: "Codice Patologia (ICD-10):",
      vedi: "Vedi",
      successSave: "Patologia memorizzata con successo!",
      failSave: "Non è stato possibile salvare la patologia",
      successUpdate: "Modifiche memorizzate con successo!",
      failUpdate: "Non è stato possibile salvare le modifiche",
      failFetch: "Non è stato possibile recuperare le patologie",
      cronica: "cronica",
      acuta: "acuta",
      stagionale: "stagionale",
      data_inizio: "inizio",
      dal: "dal",
      al: "al"
    },
    IndiceAderenza: {
      title: "Indice di Aderenza",
      references: "Riferimenti:",
      level0: "non determinabile",
      level1: "scarso",
      level2: "medio",
      level3: "ottimale"
    },
    TerapieComponent: {
      activeTitle: "Terapie in atto",
      newTherapy: "nuova terapia",
      downloadProspetto: "Prospetto Terapie",
      suspended: "Sospesa",
      until: "Fino al",
      since: "Dal",
      finished: "Terminata il",
      historyTitle: "Storico terapie",
      noHistory: "Nessun elemento nello storico",
      edit: "Modifica",
      resume: "Riprendi",
      suspend: "Sospendi",
      downloadReminder: "Scarica promemoria",
      createdAt: "Data di inserimento:",
      deleteConfirmTitle: "Conferma eliminazione",
      deleteConfirmText: "Confermi di voler eliminare la terapia?",
      downloadError: "Non è stato possibile scaricare il prospetto.",
      fetchError: "Non è stato possibile recuperare le terapie",
      suspended: "sospesa",
      resumed: "ripresa",
      therapy: "Terapia",
      operationFailed: "Non è stato possibile eseguire l'operazione",
      deleted: "Terapia eliminata!",
      deleteError: "Non è stato possibile eliminare la terapia",
      downloadReminderError: "Non è stato possibile scaricare il promemoria",
      si_conferma: "Si, Conferma",
      no_annulla: "No, Annulla",
      scaricaProspetto: "Scarica Prospetto Terapie",
      nuovaTerapia: "Nuova Terapia",
      elimina: "Elimina",
      vedi: "Vedi",
      conferma: "Conferma",
      testoConfermaSospensione: "Confermi di voler {azione} la terapia?",
      azioneSospendere: "sospendere",
      azioneRiprendere: "riprendere"
    },
    RecapTherapy: {
      pathology: "patologia",
      indicazione: "Indicazione",
      noPathology: "Patologia non indicata",
      dosage: "Posologia",
      of: "di",
      byRoute: "per via",
      toTake: "Da assumere:",
      duration: "Durata",
      from: "Da",
      until: "fino a",
      followEvery: "La terapia va seguita ogni",
      for: "per",
      startingFrom: "a partire da",
      undefined: "indeterminata",
      notes: "Annotazioni",
      noNotes: "nessuna nota",
      details: "Dettagli",
      prescriber: "Prescrittore",
      source: "Fonte informativa",
      sideEffects: "Effetti collaterali",
      allergicReactions: "Reazioni allergiche",
      interactions: "Interazioni",
      notIndicated: "non indicato",
      reminder: "Promemoria",
      tenMinutesBefore: "10 minuti prima della somministrazione",
      adherenceIndex: "Indice di Aderenza",
      selectDrug: "Seleziona farmaco",
      searchDrug: "Cerca farmaco per nome..",
      notFound: "Prodotto non trovato",
      frequency: "Frequenza",
      frequencyAndDosage: "Frequenza, modalità e dosaggio somministrazione",
      daily: "al dì",
      asNeeded: "al bisogno",
      every: "ogni",
      onlyOneIntakeTime: "Con questa frequenza è possibile selezionare al massimo un momento di assunzione",
      morning: "Mattina",
      midMorning: "Meta mattina",
      lunch: "Pranzo",
      afternoon: "Pomeriggio",
      evening: "Sera",
      night: "Notte",
      prescriberSelect: "indica chi ha prescritto la terapia",
      sourceSelect: "indica fonte informativa",
      sideEffectsPlaceholder: "eventuali effetti collaterali attribuite al farmaco..",
      allergicReactionsPlaceholder: "eventuali reazioni allergiche attribuite al farmaco..",
      interactionsPlaceholder: "possibili interazioni con farmaci o alimenti individuate..",
      privateInfoNote: "**se selezioni questa opzione soltanto tu potrai vedere questa terapia",
      visibleOnlyToMe: "visibile solo a me**",
      cancel: "Annulla",
      saveChanges: "Salva modifiche",
      saveSuccess: "Nuova terapia salvata",
      saveError: "Si è verificato un errore durante il salvataggio",
      startDate: "A partire dal",
      endDate: "Fino al",
      unitsSing: {
        mese: "mese",
        settimana: "settimana",
        giorno: "giorno"
      },
      unitsPlur: {
        mesi: "mesi",
        settimane: "settimane",
        giorni: "giorni",
        ore: "ore"
      },
      unit: {
        compressa: "compressa",
        capsula: "capsula",
        goccia: "goccia",
        inalazione: "inalazione",
        busta: "busta",
        supposta: "supposta",
        scatola: "scatola",
        cerotto: "cerotto",
        fiala: "fiala",
        fleboclisi: "fleboclisi",
        ovulo: "ovulo",
        sacca: "sacca",
        flacone: "flacone",
        confezione: "confezione",
        kilogrammo: "kilogrammo",
        kit: "kit",
        millilitro: "millilitro",
        milligrammo: "milligrammo",
        applicazione: "applicazione",
        UI: "UI"
      },
      vias: {
        orale: "Orale",
        transdermica: "Transdermica",
        nasale: "Nasale",
        endovena: "Endovena",
        intramuscolo: "Intramuscolo",
        oftalmica: "Oftalmica",
        rettale: "Rettale",
        uretale: "Uretale",
        vaginale: "Vaginale",
        sottocute: "Sottocute"
      }
    },
    EditTherapy: {
      Annotazioni: 'Annotazioni',
      Annulla: 'Annulla',
      Farmaco_indicato: 'Farmaco indicato',
      Mattina: 'Mattina',
      Meta_mattina: 'Meta mattina',
      Notte: 'Notte',
      Ore: 'Ore',
      Pomeriggio: 'Pomeriggio',
      Pranzo: 'Pranzo',
      Prodotto_non_trovato: 'Prodotto non trovato',
      Salva_modifiche: 'Salva modifiche',
      Sera: 'Sera',
      al_bisogno: 'al bisogno',
      al_di: 'al dì',
      giorni: 'giorni',
      indica_prescrittore: 'indica chi ha prescritto la terapia',
      indica_fonte: 'indica fonte informativa',
      indica_patologia: 'indica patologia',
      mesi: 'mesi',
      non_indicare_patologia: 'non indicare patologia',
      occasionale: 'occasionale',
      ogni: 'ogni',
      ore: 'ore',
      giorni: 'giorni',
      per_sempre: 'per sempre',
      periodica: 'periodica',
      settimane: 'settimane',
      ikey_descrizione: '{{ ikey.descrizione }}',
      prod_Nome: '{{ prod.Nome }}',
      dosaggio: 'dosaggio',
      durata_terapia: "Durata terapia"
    },
    Common: {
      genericError: "Si è verificato un errore."
    },
    nuovaPrenotazioneSalvata: {
      prenotazionePassata: "prenotazione passata",
      testoIstruzioni: "Seleziona una prestazione, una data e una fascia oraria per cui inserire una prestazione già eseguita.",
      prestazione: "Prestazione da inserire*",
      dataInserimento: "Data di inserimento*",
      labelHelp: "Utilizza i cursori per navigare tra le date",
      fasciaOraria: "Fascia oraria*",
      placeholderData: "Seleziona una data",
      selezionaFascia: "Seleziona una fascia oraria",
      mattina: "mattina",
      pomeriggio: "pomeriggio",
      sera: "sera",
      modalTitle: "Nuova prenotazione passata",
      success: "Prenotazione inserita con successo",
      error: "Errore nell'inserimento della prenotazione"
    },
    SelectCompanyHealthService: {
      loading: "Caricamento in corso...",
      empty: "Non ci sono prestazioni attive e disponibili",
      choose: "scegli prestazione",
      loadError: "Errore nel caricamento delle prestazioni sanitarie"
    },
    PatientAnnotations: {
      title: "Note",
      new: "nuova nota sanitaria",
      info: "Inserisci una nota sanitaria nella scheda del paziente. Questa nota non sarà mostrata al paziente.",
      month: "Mese",
      year: "Anno",
      all: "Tutti",
      yours: "Le tue note",
      noneForMonth: "Nessuna nota per questo mese.",
      noneForFilters: "Nessuna nota con questi criteri.",
      loadError: "Non è stato possibile recuperare le note",
      months: {
        january: "gennaio",
        february: "febbraio",
        march: "marzo",
        april: "aprile",
        may: "maggio",
        june: "giugno",
        july: "luglio",
        august: "agosto",
        september: "settembre",
        october: "ottobre",
        november: "novembre",
        december: "dicembre"
      }
    },
    ClinicalReportGenerator: {
      emit: "Emetti Referto",
      modalTitle: "Genera referto firmato",
      placeholder: "Le tue annotazioni...",
      authorizeAndEmit: "Autorizza ed emetti referto",
      otpInstruction: "La struttura richiede che l'operazione venga confermata con la verifica di un codice OTP inviato al tuo numero di telefono.\n\nClicca su \"invia codice di verifica\" per inviare il codice OTP.",
      or: "oppure",
      cancel: "Annulla operazione",
      serviceNotAvailable: "Servizio non attivo per la struttura.",
      contactSupport: "Contattaci per avere informazioni",
      emitSuccess: "Report emesso correttamente",
      emitError: "Errore elaborazione report",
      downloadError: "Non è stato possibile scaricare la risorsa"
    },
    singleAnnotationComponent: {
      visible: "Visibile al paziente",
      notVisible: "Non visibile al paziente",
      soapLabel: "nota sanitaria",
      subjective: "Soggettivo",
      objective: "Obiettivo",
      assessment: "Valutazione",
      plan: "Piano",
      other: "Altro",
      saveChanges: "Salva modifiche",
      cancelChanges: "Annulla modifiche",
      modalTitle: "Conferma eliminazione",
      cancelDelete: "No, Annulla",
      confirmDelete: "Sì, Conferma",
      confirmDeleteText: "Confermi di voler eliminare la nota?",
      updateSuccess: "Nota aggiornata correttamente",
      updateError: "Errore nell'aggiornamento della nota",
      deleteSuccess: "Nota eliminata correttamente",
      deleteError: "Errore nell'eliminazione della nota"
    },
    NewAnnotationComponent: {
      placeholder: "Aggiungi nota semplice",
      visibilityLabel: "Visibilità Paziente",
      notVisible: "Non visibile al paziente",
      visible: "Visibile al paziente",
      save: "Salva nota",
      cancel: "Annulla",
      success: "Nota inserita correttamente",
      error: "Errore nell'inserimento della nota"
    },
    NewSoapAnnotationComponent: {
      subjective: "Soggettivo",
      objective: "Obiettivo",
      assessment: "Valutazione",
      plan: "Piano",
      other: "Altro",
      subjectivePlaceholder: "Impressioni, sintomi riportati dal paziente, storia familiare...",
      objectivePlaceholder: "Segni, esame obbiettivo, indagini strumentali...",
      assessmentPlaceholder: "Valutazione, diagnosi, progressi...",
      planPlaceholder: "Raccomandazioni, procedure o trattamenti indicati, variazioni al piano...",
      otherPlaceholder: "Altre osservazioni rilevanti...",
      save: "Salva nota",
      cancel: "Annulla",
      success: "Nota inserita correttamente",
      error: "Errore nell'inserimento della nota"
    },
    ScoresComponent: {
      title: "Questionari",
      new: "nuova rilevazione questionario",
      newBtn: "nuova rilevazione questionario",
      newTitle: "Nuova rilevazione questionario",
      history: "Storico",
      lastScore: "Ultimo punteggio registrato",
      year: "Anno",
      month: "Mese",
      day: "Giorno",
      all: "tutti",
      values: "Valori rilevati",
      noValues: "Nessun valore registrato",
      findByScore: "Trova questionario con punteggio",
      add: "aggiungi",
      back: "indietro",
      complete: "completa questionario",
      error: "qualcosa è andata storta",
      placeholder: "Cerca...",
      esito_title: "Esito questionario",
      vediQuestioniario: "Vedi questionario",
      esito: "Esito"
    },
    FrequenzaValutazioneScore: {
      frequencyPer: "Frequenza rilevazione: una valutazione ogni",
      suspended: "Valutazione sospesa",
      setFrequency: "Imposta frequenza valutazione",
      parameterNeeded: "È necessario rilevare il parametro ogni",
      toggleQuestion: "Vuoi {{ selectedFrequency.enabled ? 'disattivare' : 'attivare' }} questa frequenza di monitoraggio?",
      confirmDeleteQuestion: "Vuoi eliminare questa frequenza di monitoraggio?",
      modificaTitle: "modifica",
      sospendiTitle: "sospendi",
      riprendiTitle: "riprendi",
      eliminaTitle: "elimina",
      deleteTitle: "Modifica operazione",
      updateTitle: "Modifica impostazione",
      confirmTitle: "Conferma operazione",
      deleteConfirm: "Sì, elimina",
      saveChanges: "Salva modifiche",
      cancel: "Annulla",
      confirm: "Conferma",
      genericError: "Qualcosa è andata storta",
      setSuccess: "Valori impostati correttamente",
      updateSuccess: "Impostazione di frequenza modificate correttamente",
      updateError: "Non è stato possibile modificare la frequenza",
      deleteSuccess: "Impostazione di frequenza eliminata correttamente",
      deleteError: "Non è stato possibile eliminare la frequenza",
      sing: {
        mese: "mese",
        settimana: "settimana",
        giorno: "giorno",
        ora: "ora",
        minuto: "minuto"
      },
      plur: {
        mesi: "mesi",
        settimane: "settimane",
        giorni: "giorni",
        ore: "ore",
        minuti: "minuti"
      }
    },
    PatientDevices: {
      title: "Dispositivi",
      newDevice: "nuovo dispositivo",
      noneAssociated: "Nessun dispositivo associato all'utente.",
      newDeviceTitle: "Nuovo dispositivo Utente",
      searchDevice: "Trova dispositivo",
      searchPlaceholder: "Cerca...",
      noneAvailable: "Nessun dispositivo disponibile per l'assegnazione.",
      codePlaceholder: "Inserisci codice*",
      back: "Indietro",
      save: "Salva",
      addSuccess: "Dispositivo aggiunto correttamente",
      addError: "Non è stato possibile aggiungere il dispositivo",
      removeSuccess: "Dispositivo rimosso correttamente",
      removeError: "Non è stato possibile rimuovere il dispositivo",
      updateCodeSuccess: "Codice prodotto aggiornato correttamente",
      updateCodeError: "Non è stato possibile aggiornare il codice prodotto",
      enabled: "abilitato",
      disabled: "disabilitato",
      examStatusUpdated: "Esame {status} correttamente",
      examStatusError: "Non è stato possibile aggiornare lo stato dell'esame",
      updateRequested: "Aggiornamento richiesto. Riceverai una notifica ad operazione completata",
      updateRequestError: "Non è stato possibile richiedere l'aggiornamento"
    },
    DeviceCard: {
      requestUpdate: "Richiedi aggiornamento dati",
      noExams: "Nessun esame abilitato su questo dispositivo.",
      confirmTitle: "Conferma operazione",
      confirmOk: "Sì, conferma",
      confirmCancel: "No, annulla",
      confirmMessage: "Vuoi dismettere il dispositivo",
  editTitle: "Modifica Dispositivo {name}",
      parameters: "Parametri",
      enabled: "Abilitato",
      disabled: "Disabilitato",
      productCode: "Codice Prodotto",
      edit: "Modifica",
      save: "Salva",
      cancel: "Annulla",
      close: "Chiudi",
      productCodePlaceholder: "Codice Prodotto"
    },
    EsenzioniComponent: {
      title: "Esenzioni",
      new: "nuova esenzione",
      none: "Nessuna esenzione inserita",
      modalTitle: "Aggiungi esenzione",
      choose: "scegli",
      requiredField: "*Campo obbligatorio",
      cancel: "Annulla",
      save: "Salva",
      deleteTitle: "Confermi di voler eliminare l'esenzione?",
      deleteOk: "Sì, elimina",
      cancelDelete: "No, annulla",
      saveSuccess: "Esenzione memorizzata con successo!",
      saveError: "Non è stato possibile salvare l'esenzione",
      deleteSuccess: "Esenzione eliminata con successo!",
      deleteError: "Non è stato possibile eliminare l'esenzione",
      pathologiesError: "Non è stato possibile prelevare la lista di patologie",
      loadError: "Non è stato possibile recuperare le esenzioni"
    },
    ProfiloAnagraficoAssistito: {
      title: "Anagrafica Paziente",
      subtitle: "Scheda paziente",
      loadError: "Non è stato possibile recuperare le informazioni."
    },
    AnagraficaPazienteComponent: {
      profile: "Profilo",
      title: "Titolo",
      titlePlaceholder: "Sig...",
      firstName: "Nome*",
      firstNamePlaceholder: "Nome...",
      lastName: "Cognome*",
      lastNamePlaceholder: "Cognome...",
      birthDate: "Data di nascita*",
      gender: "Genere",
      male: "uomo",
      female: "donna",
      taxCode: "Codice fiscale*",
      taxCodePlaceholder: "Codice fiscale...",
      healthCard: "Numero Tessera Sanitaria",
      healthCardPlaceholder: "Numero tessera...",
      birthCountry: "Nazione di nascita*",
      gp: "Medico di base",
      gpPlaceholder: "Medico di base...",
      localHealthAuthority: "Asl/Asp/Ats di riferimento",
      selectAuthority: "Scegli azienda sanitaria locale",
      cancel: "Annulla",
      save: "Salva Modifiche",
      residence: "Residenza",
      region: "Regione*",
      regionPlaceholder: "Regione...",
      province: "Provincia*",
      provincePlaceholder: "Provincia...",
      city: "Comune*",
      cityPlaceholder: "Comune...",
      selectRegion: "Seleziona Regione",
      selectProvince: "Seleziona Provincia",
      selectCity: "Seleziona Comune",
      address: "Indirizzo e numero civico*",
      addressPlaceholder: "Indirizzo...",
      zip: "CAP*",
      zipPlaceholder: "CAP...",
      contacts: "Contatti",
      phone: "Numero di telefono",
      phonePlaceholder: "Telefono...",
      homePhone: "Telefono Domicilio",
      homePhonePlaceholder: "Telefono domicilio...",
      backupPhone: "Telefono di Riserva",
      backupPhonePlaceholder: "Telefono di riserva ...",
      deleteImageTitle: "Conferma eliminazione",
      confirm: "Sì, Conferma",
      confirmDeleteImage: "Confermi di voler eliminare l'immagine del profilo?",
      selectCountry: "Seleziona Nazione",
      titleOptions: {
        sig: "Sig.",
        sigRa: "Sig.ra",
        dott: "Dott.",
        dottSsa: "Dott.ssa"
      },
      invalidPhone: "Numero di telefono non valido",
      success: "Modifiche effettuate correttamente",
      genericError: "Non è stato possibile completare l'operazione"
    },
    UploadComponent: {
      uploadSuccess: "caricato correttamente!",
      uploadNew: "Carica nuovo file",
      codeDetected: "Codice rilevato correttamente!",
      codeNotDetected:
        "Non è stato possibile rilevare il codice dalla ricetta caricata. Si prega di provare a scannerizzare il codice tramite videocamera o inserire manualmente il codice nell'apposito campo.",
      placeholder: "seleziona file...",
      upload: "Carica",
      invalidFile: "File non valido o di dimensioni eccessive (max8Mb)"
    },
    ContattiEmergenza: {
      title: "Contatti Utili",
      none: "Nessun contatto inserito.",
      newContact: "nuovo contatto",
      modalTitle: "Aggiungi contatto utile",
      cancel: "Annulla",
      save: "Salva contatto",
      loadError: "Non è stato possibile recuperare le informazioni."
    },
    NewEmergencyContact: {
      type: "Tipo di contatto",
      firstName: "Nome*",
      firstNamePlaceholder: "Nome...",
      lastName: "Cognome*",
      lastNamePlaceholder: "Cognome...",
      organization: "Denominazione*",
      relation: "Relazione contatto*",
      selectRelation: "Seleziona tipo relazione",
      region: "Regione*",
      selectRegion: "Seleziona Regione",
      province: "Provincia*",
      selectProvince: "Seleziona Provincia",
      city: "Comune*",
      selectCity: "Seleziona Comune",
      address: "Indirizzo e numero civico",
      addressPlaceholder: "Indirizzo...",
      zip: "CAP",
      zipPlaceholder: "CAP...",
      phone: "Numero di telefono*",
      phonePlaceholder: "Telefono...",
      cancel: "Annulla",
      save: "Salva Contatto",
      success: "Contatto aggiunto correttamente",
      error: "Errore nel salvataggio del contatto",
      relations: {
        family: "familiare",
        friend: "amico",
        assistance: "assistenza",
        medicalStaff: "personale medico",
        healthStaff: "personale sanitario",
        other: "altro"
      },
      contactTypes: {
        person: "persona fisica",
        place: "luogo"
      },
      cityPlaceholder: "Comune...",
      delete: "Elimina",
      edit: "Modifica",
      cancel: "Annulla",
      save: "Salva",
      confirm: "Sì, Conferma",
      confirmDeleteTitle: "Conferma eliminazione",
      confirmDeleteText: "Sei sicuro di voler eliminare il contatto di emergenza per",
      updateSuccess: "Contatto aggiornato correttamente",
      updateError: "Errore nel salvataggio delle modifiche",
      deleteSuccess: "Contatto eliminato correttamente",
      deleteError: "Non è stato possibile eliminare il contatto"
    },
    PrenotazioniCittadinoMain: {
      newRequest: "Nuova richiesta di prenotazione",
      pending: "In sospeso",
      confirmed: {
        plural: "Confermate",
        singular: "Confermati"
      },
      history: "Storico",
      inactiveService: "Servizio non attivo."
    },
    UserReservations: {
      myBookings: "Le mie prenotazioni",
      assistiti: "Assistiti",
      noReservations: "Nessuna prenotazione.",
      loadError: "Non è stato possibile recuperare le prenotazioni recenti",
      updateSuccess: "Richiesta aggiornata con successo",
      genericError: "Non è stato possibile effettuare l'operazione",
      downloadError: "Non è stato possibile scaricare il promemoria",
      sendSuccess: "Richiesta inviata con successo"
    },
    DettaglioPrenotazioneCittadino: {
      cost: "costo {costo}",
      productRequest: "Richiesta prodotti",
      teleconsulto: "Teleconsulto",
      estimatedDate: "DATA E ORA (STIMATA)",
      toConfirm: "Da confermare",
      requestCode: "CODICE RICHIESTA",
      forWho: "Per conto di",
      status: "STATO",
      nameSurname: "NOME E COGNOME",
      taxCode: "CODICE FISCALE",
      booking: "Prenotazione",
      location: "PRESSO",
      details: "Dettagli",
      operationDate: "DATA OPERAZIONE",
      yourNotes: "LE TUE NOTE",
      purchase: "Acquista",
      date: "DATA"
    },
    UserDetailPrestazione: {
      attachments: "ALLEGATI",
      prescription: "RICETTA",
      download: "Scarica",
      questionnaireToFill: "QUESTIONARIO DA COMPILARE",
      completeQuestionnaire: "Completa questionario",
      questionnaire: "QUESTIONARIO",
      questionnaireMin: "Questionario",
      openQuestionnaire: "apri questionario",
      downloadPdf: "scarica in formato pdf",
      notes: "NOTE PRESTAZIONE:",
      operatorNotes: "NOTE DELL'OPERATORE",
      confirmBooking: "Conferma Prenotazione",
      rejectChanges: "Rifiuta Modifiche",
      cancelBooking: "Annulla Appuntamento",
      confirmCancelTitle: "Conferma Annullamento",
      confirmCancelMessage: "Sei sicuro di voler annullare questo appuntamento?",
      confirm: "Sì, Conferma",
      cancel: "Annulla",
      loadQuestionnaireError: "Non è stato possibile recuperare il questionario",
      downloadError: "Non è stato possibile scaricare la risorsa"
    },
    FilledSurveyShower: {
      totalScore: "Punteggio totalizzato:",
      questions: "Domande",
      noFile: "--- nessun file caricato",
      information: "Informativa"
    },
    ImageShower: {
      downloadAttachment: "scarica allegato",
      downloadError: "non è stato possibile recuperare l'allegato"
    },
    PickMessageForm: {
      attachMessage: "Allega un messaggio per l'utente:",
      noMessage: "Nessun messaggio",
      placeholder: "Scrivi messaggio...",
      cancel: "No, chiudi",
      confirm: "Sì, procedi"
    },
    UserDetailTeleconsulto: {
      expectedDuration: "DURATA PREVISTA",
      actualDuration: "DURATA EFFETTIVA",
      minutes: "minuti",
      prescription: "RICETTA",
      download: "Scarica",
      questionnaire: "QUESTIONARIO",
      openQuestionnaire: "apri questionario",
      downloadPdf: "scarica in formato pdf",
      toFillQuestionnaire: "QUESTIONARIO DA COMPILARE",
      completeQuestionnaire: "Completa questionario",
      teleconsultation: "TELECONSULTO",
      goToTeleconsultation: "vai al Teleconsulto",
      operatorNotes: "NOTE DELL'OPERATORE",
      notes: "NOTE",
      saveChanges: "Salva Modifiche",
      confirmBooking: "Conferma Prenotazione",
      rejectChanges: "Rifiuta Modifiche",
      cancelBooking: "Annulla Prenotazione",
      confirmCancelTitle: "Conferma Annullamento",
      confirmCancelMessage: "Sei sicuro di voler annullare questo appuntamento?",
      confirm: "Sì, Conferma",
      cancel: "Annulla",
      questionnaireError: "Non è stato possibile recuperare il questionario",
      downloadError: "Non è stato possibile scaricare la risorsa"
    },
    UserDetailProdotto: {
      medicalPrescription: "RICETTA MEDICA",
      vetPrescription: "RICETTA VETERINARIA",
      productsAvailable: "I prodotti in ricetta sono disponibili",
      productsNotAvailable: "I prodotti in ricetta non sono disponibili",
      reminder: "Ricorda di portare con te il pin della ricetta quando vai a ritirare l'ordine!",
      requestedProducts: "PRODOTTI RICHIESTI",
      generic: "GENERICO",
      prescription: "Prescrizione",
      prescriptionNeeded: "necessaria",
      prescriptionNotNeeded: "non necessaria",
      product: "Prodotto",
      available: "disponibile",
      notAvailable: "non disponibile",
      orderNotes: "NOTE SULL'ORDINE",
      prescriptionShort: "RICETTA",
      noPrescriptionAttached: "Nessuna ricetta allegata",
      operatorNotes: "NOTE DELL'OPERATORE",
      saveChanges: "Salva Modifiche",
      confirmOrder: "Conferma Ordine",
      rejectChanges: "Rifiuta Modifiche",
      cancelOrder: "Annulla Ordine",
      confirmCancelTitle: "Conferma Annullamento",
      confirmCancelMessage: "Sei sicuro di voler annullare questo appuntamento?",
      confirm: "Sì, Conferma",
      cancel: "Annulla",
      downloadError: "Non è stato possibile scaricare la risorsa",
      download: "Scarica"
    },
    UpdateNotesComponent: {
      title: "Aggiorna le tue note di prenotazione",
      description: "In questo spazio puoi inserire informazioni o comunicazioni rilevanti per questa specifica prenotazione.",
      newNote: "Nuova nota:",
      cancel: "Annulla",
      save: "Salva",
      updateError: "Non è stato possibile aggiornare le note"
    },
    UpdateReservationDate: {
      reschedule: "Rischedula",
      modalTitle: "Richiedi modifica data/ora",
      currentDateTime: "Data e ora attualmente previste:",
      selectNewDate: "Scegli nuova data ed ora*:",
      updateNotes: "Aggiorna note",
      cancel: "Annulla",
      submit: "Invia",
      fetchError: "Non è stato possibile prelevare la richiesta",
      submitError: "Non è stato possibile inoltrare la richiesta"
    },
    DatetimeSelection: {
      selectDateTime: "Scegli data ed ora",
      month: "Mese",
      year: "Anno",
      prev: "Precedente",
      next: "Successiva",
      noAvailabilityThisWeek: "Nessuna disponibilità per questa settimana. Prova a verificare le disponibilità per le prossime settimane.",
      noAvailabilityThisWeekMsg: "Nessuna disponibilità per la settimana e la prestazione scelta",
      noAvailabilityForService: "Non è stato possibile trovare disponibilità per questo servizio",
      infoNoAvailability: "La prestazione scelta non ha nessuna disponibilità per la settimana corrente",
      teleconsultDurationError: "Errore nel recupero della durata del teleconsulto. Riprova più tardi.",
      months: {
        january: "Gennaio",
        february: "Febbraio",
        march: "Marzo",
        april: "Aprile",
        may: "Maggio",
        june: "Giugno",
        july: "Luglio",
        august: "Agosto",
        september: "Settembre",
        october: "Ottobre",
        november: "Novembre",
        december: "Dicembre"
      }
    },
    PreferenzeSelection: {
      selectPreferences: "Seleziona giorni e orari di preferenza",
      noPreference: "Non ho particolari preferenze",
      hasPreference: "Voglio indicare le preferenze",
      preferredDate: "Data di preferenza*",
      preferredTimeSlot: "Fascia oraria di preferenza*",
      datePlaceholder: "Scegli una data",
      labelHelp: "Utilizza i cursori per navigare tra le date",
      addPreference: "Aggiungi preferenza",
      saveAndContinue: "Salva e procedi",
      saveSelection: "Salva selezione",
      timeOptions: {
        morning: "mattina",
        afternoon: "pomeriggio",
        evening: "sera",
        allDay: "tutto il giorno"
      }
    },
    ChatComponent: {
      startChat: "Chatta",
      viewConversation: "Vedi conversazione",
      title: "Conversazione",
      connectionError: "Non è stato possibile collegarsi",
      messageSendError: "non è stato possibile inoltrare il messaggio",
      updateError: "non è stato possibile aggiornare la conversazione",
      fetchMessagesError: "non è stato possibile recuperare i messaggi precedenti",
      downloadError: "Non è stato possibile scaricare la risorsa",
      loadingError: "Impossibile caricare il modulo di chat",
      utenteConnesso: "...connesso."
    },
    CardPrenotazioneCittadino: {
      waitingForPayment: "attesa pagamento",
      waitingForConfirmation: "attesa conferma",
      location: "Presso:",
      scheduledFor: "Prenotazione effettuata per:",
      costOnSite: "Costo in sede:",
      memo: "Promemoria",
      calendar: "Calendar",
      view: "Visualizza",
      pay: "Paga",
      ore: "ore"
    },
    NuovoOrdineCittadino: {
      need: "Di cosa hai bisogno",
      forWhom: "Per chi",
      at: "Presso",
      date: "Data",
      cancel: "Annulla",
      confirm: "Conferma",
      summary: "Riepilogo",
      noFacilities: "Nessuna struttura disponibile per la prenotazione.",
      tryOtherFilters: "Prova a cambiare i filtri di ricerca.",
      saveAndProceed: "Salva e procedi",
      backToFacilities: "Torna alle strutture",
      selectCompanyPreference: "Seleziona una preferenza tra le strutture convenzionate",
      availabilityPrompt: "INDICA LE TUE DISPONIBILITÀ",
      selectedDates: "Date selezionate:",
      fillQuestionnaire: "Compila il questionario",
      service: "Servizio:",
      generic: "generico",
      reminder: "Ricorda di portare con te il pin della ricetta quando vai a ritirare l'ordine.",
      assignedStructureChoice: "Scelta struttura affidata a",
      preferenzeOrLocation: "Preferenza struttura",
      preferenzeFallback: "Presso",
      dateTimeSelected: "Data ed ora selezionate:",
      dateTimeEstimated: "Data ed ora(stimata):",
      selectedPreferences: "Preferenze scelte:",
      attachedPrescription: "Ricetta allegata:",
      serviceFee: "Costo gestione del servizio:",
      vatExcluded: "iva {iva}% esclusa",
      totalDue: "Totale dovuto:",
      free: "Gratuito",
      operatorNote: "Se vuoi, aggiungi una nota per l'operatore",
      operatorNoteProduct: "Se vuoi, aggiungi una nota per l'operatore (per esempio un indirizzo di consegna diverso da quello di residenza)",
      confirmInstruction: 'Cliccando su "procedi" inoltrerai la richiesta di prenotazione.',
      waitForOperator: "Attendi che",
      operatorWillContactWithPayment: "un operatore ti contatti per la conferma della prenotazione e pagamento del servizio.",
      operatorWillContact: "un operatore ti contatti per la conferma della prenotazione.",
      readPolicy: "Per procedere alla conferma dell'ordine è necessario",
      acknowledgePolicy: "confermare la presa visione dell'informativa",
      autoAssignProduct: "Affidati a {app} per scelta della struttura",
      autoAssignHealth: "Affidati a {app} per la scelta della struttura sanitaria",
      vatExcluded: "iva {iva}% esclusa",
      informRead: "Ho letto e compreso",
      informativeLink: "l'informativa privacy",
      informConsent: "Acconsento al trattamento dei miei dati personali per le finalità indicate nell'informativa",
      proceed: "Procedi",
      viewReservation: "Visualizza prenotazione",
      downloadCalendar: "scarica calendar",
      downloadReminder: "scarica promemoria",
      purchaseCompleted: "Acquisto completato",
      purchasePending: "Acquisto in attesa di pagamento",
      informativaProdotto: "informativa prodotto",
      informativaPrestazione: "informativa prestazione",
      informativaTeleconsulto: "informativa teleconsulto",
      genericError: "Non è stato possibile completare l'operazione.",
      preferencesUpdated: "Preferenze aggiornate correttamente!",
      updatePreferencesError: "Non è stato possibile aggiornare le preferenze",
      noAvailabilityThisWeek: "La prestazione scelta non ha nessuna disponibilità per la settimana corrente",
      noAvailabilityThisService: "Non è stato possibile trovare disponibilità per questo servizio",
      noAvailabilityWeek: "Nessuna disponibilità per la settimana corrente",
      bookingSuccess: "Prenotazione inviata con successo!",
      bookingError: "Non è stato possibile inviare la richiesta",
      reminderDownloadError: "Non è stato possibile scaricare il promemoria",
      questionnaireSendError: "Non è stato possibile inviare il questionario",
      paymentInfoError: "Non è stato possibile recuperare le informazioni relative al pagamento",
      companyNotFound: "Non è stato possibile trovare aziende per il servizio richiesto",
      downloadFailed: "Non è stato possibile scaricare la risorsa",
      costo: "costo",
      timeSlots: {
        morning: 'mattina',
        afternoon: 'pomeriggio',
        allday: 'tutto il giorno'
      },
      preferenzaStruttura: "Preferenza struttura",
      presso: "Presso",
      preferenzeScelte: "Preferenze Scelte",
      informativa: "Informativa"
    },
    CalendarioDisponibilitaGiornalieraCittadino: {
      chooseDateTime: "Scegli data e ora tra le disponibilità",
      labelHelp: "Utilizza i cursori per navigare tra le date",
      day: "giorno",
      noAvailability: "Nessuna disponibilità per il giorno selezionato"
    },
    SearchCompany: {
      back: "Torna indietro",
      noResults: "Nessun risultato con questi parametri di ricerca.",
      rangeHelp: 'Utilizza il campo "range" per aumentare o diminuire il raggio di ricerca',
      geolocWarning: "Per utilizzare questa funzionalità devi acconsentire alla condivisione della tua posizione.",
      allowConsent: "Concedi consenso",
      meters: "metri",
      repeatSearch: "Ripeti ricerca",
      searchByPosition: "Cerca utilizzando la mia posizione attuale",
      searchHelp: 'Compila uno o più campi e premi su "cerca" per visualizzare i risultati della ricerca',
      labelRegion: "Regione*",
      selectRegion: "Seleziona Regione",
      labelProvince: "Provincia*",
      selectProvince: "Seleziona Provincia",
      labelMunicipality: "Comune*",
      selectMunicipality: "Seleziona Comune",
      labelName: "Denominazione",
      placeholderName: "Denominazione...",
      requiredFields: "*parametri obbligatori",
      clearFields: "Pulisci campi",
      search: "Cerca",
      increaseRange: "Aumenta il raggio di ricerca",
      clickToSetPreferredFromHome: 'Clicca sulla sede che vuoi impostare come nuova preferita e conferma la scelta premendo su "Conferma Scelta"',
      clickToSetPreferred: 'Clicca sulla sede di tua preferenza e conferma la scelta premendo su "Conferma Scelta"',
      setAsPreferred: "Imposta come Preferito",
      cancel: "Annulla",
      confirm: "Conferma Scelta",
      noResultsSearch: "Nessun risultato per questa ricerca",
      successPreferences: "preferenze aggiornate correttamente!",
      errorPreferences: "non è stato possibile aggiornare le preferenze"
    },
    FeverPrivacy: {
      titolo: "Informativa Privacy Fever",
      logo_alt: "Logo Fever",
      pdf_title: "Documento PDF informativa privacy Fever",
      pdf_aria_label: "Visualizzatore PDF per informativa privacy Fever",
      scarica_pdf: "Scarica PDF",
      scarica_aria_label: "Scarica l'informativa privacy Fever in formato PDF",
      indietro_aria_label: "Torna alla pagina precedente"
    },
    FillSurvey: {
      privacyIntro: "Maggiori dettagli saranno reperibili alla",
      privacyPolicy: "Informativa Privacy",
      termsIntro: "Le condizioni di utilizzo sono consultabili",
      termsLink: "qui",
      okProceed: "Ok, Procedi",
      back: "Torna indietro",
      next: "Procedi",
      thankYou: "Grazie per aver compilato il questionario!",
      canContinueBooking: "Puoi proseguire con la prenotazione.",
      continue: "Prosegui",
      skip: "Salta"
    },
    SurveyUploader: {
      filesUploaded: "File caricati correttamente!",
      fileUploaded: "File caricato correttamente!",
      remove: "Rimuovi",
      upload: "Carica",
      select_file: "seleziona file...",
      select_more_file: "seleziona uno o più file..."
    },
    NewSubjectSelection: {
      forMe: "Per me",
      forFamilyMember: "Per un mio familiare",
      forAssisted: "Per un mio assistito",
      chooseFamilyMember: "scegli familiare",
      chooseAssisted: "scegli assistito",
      noneRegistered: "Non hai registrato alcun",
      continueToRegister: "Prosegui per registrarlo",
      registerNow: "registralo ora",
      selectFamilyMember: "Seleziona familiare",
      selectAssisted: "Seleziona assistito",
      cannotFetchInfo: "Non è stato possibile recuperare le informazioni richieste",
      cannotFetchInfoShort: "Non è stato possibile recuperare le informazioni."
    },
    ProductSelection: {
      productSelectionTitle: "Selezione prodotti",
      searchInstruction: "Cerca nel prontuario i prodotti che ti servono digitando qui sotto almeno 3 caratteri:",
      searchLabel: "Cerca prodotto",
      searchPlaceholder: "Cerca prodotto...",
      noProductFound: "Nessun prodotto trovato",
      for: "per",
      selectOneOrMore: "Seleziona uno o più prodotti da prontuario",
      selectProductsOption: "Seleziona prodotti...",
      selectProductOption: "Seleziona prodotto...",
      selectedProductsTitle: "Elenco prodotti selezionati",
      quantityLabel: "Quantità:",
      generic: "Generico",
      cannotFindProduct: "Non trovo il prodotto che cerco",
      insertManualProduct: "Inserisci prodotto fuori prontuario",
      manualProductLabel: "Nome prodotto*:",
      manualProductPlaceholder: "Inserisci nome prodotto...",
      add: "Aggiungi",
      prescriptionExplanation: "Se vuoi effettuare un ordine per una ricetta medica o veterinaria compila uno dei campi sottostanti. Non è necessario inserire manualmente i prodotti previsti dalla ricetta.",
      insertNRECode: "Inserisci il codice qui sotto",
      nreLabel: "Inserisci codice NRE ricetta",
      nrePlaceholder: "Inserisci NRE ricetta...",
      insertREVCode: "Se veterinaria, inserisci il codice qui sotto",
      revLabel: "Inserisci codice REV ricetta",
      revDescription: "*13 caratteri. Non inlcudere il pin.",
      revPlaceholder: "Inserisci REV ricetta...",
      pdfUploadAlt: "In alternativa, puoi caricare la ricetta in formato PDF",
      pdfUploadInstruction: "Carica la ricetta in formato pdf: il sistema leggerà il codice NRE dal file e lo inserirà nell'apposito campo. I file caricati qui non vengono salvati nel sistema. La lettura del codice è valida solo per le ricette NRE, per le ricette veterinarie si prega di inserire il codice manualmente nell'apposito campo.",
      scanWithCamera: "Oppure Scannerizzare il codice ricetta NRE tramite la videocamera",
      saveOrder: "Salva ordine",
      prodotto: "Prodotto:"
    },
    BarcodeComponent: {
      instructions:
        "Premi il tasto qui sotto per attivare lo scanner. Una volta attivo, inquadra i due codici a barre presente in alto a destra nella ricetta, uno alla volta nell'ordine da sinistra a destra (prima il codice più breve e poi quello più lungo). Una volta rilevato il codice completo, conferma se corrisponde a quello scritto sulla richiesta.",
      scanWithCamera: "Rileva codice tramite la videocamera del dispositivo",
      cancelOperation: "Annulla Operazione",
      codeDetected: "Codice Rilevato:",
      invalidCode: "Codice non valido",
      confirm: "Conferma",
      retry: "Riprova"
    },
    NewPrestazioneSelection: {
      searchLabel: "Cerca la visita o la prestazione di cui hai bisogno",
      searchPlaceholder: "Inserisci il nome della prestazione",
      skip_payment_label: "Richiedo che per questa prenotazione non venga richiesto un pagamento"
    },
    PickHealthServiceFromCompany: {
      skip_payment_label: "Richiedo che per questa prenotazione non venga richiesto un pagamento"
    },
    SkipPaymentCheckbox: {
      title: "Richiedo prenotazione senza pagamento",
      section_title: "La prenotazione:",
      standard_label: "segue le regole di pagamento standard",
      skip_label: "deve essere senza pagamento",
      standard_description: "Verrà applicato il pagamento in base alla sottoscrizione del paziente, alle eventuali prestazioni gratuite disponibili o alle impostazioni dei progetti a cui il paziente è iscritto",
      skip_description: "Non verrà richiesto alcun pagamento, anche in assenza di sottoscrizione attiva e con prestazioni gratuite ancora disponibili",
      section_label: "Attiva o disattiva la richiesta di prenotazione senza pagamento"
    },
    TeleconsultoSurveySelection: {
      reasonLabel: "Per quale motivo richiedi il consulto?",
      fetchError: "Non è stato possibile recuperare i questionari"
    },
    StepperButtons: {
      remainingFreeBookings: "Prenotazioni gratuite rimanenti",
      goBack: "Torna Indietro",
      continue: "Continua"
    },
    PrivacyInfoComponent: {
      title: "INFORMATIVA SUL TRATTAMENTO DEI DATI PERSONALI ORDINI PER ME/PER I FAMILIARI/ASSISTITI",
      controllerLabel: "Il responsabile del trattamento è:",
      controllerAddress: "Sede legale:",
      controllerEmail: "Email:",
      controllerDPO: "Dati di contatto del Data Protection Officer (DPO):",
      whoProcessesData: "Chi tratta i miei dati?",
      whoProcessesDataContent: `
    <p class="px-1 mb-0 border-bottom border-dark">
      Il Titolare del trattamento è Qwince Innovation S.R.L.
    </p>
    <p class="px-1 mb-0 border-bottom border-dark">
      Sede legale:
    </p>
    <p class="px-1 mb-0 border-bottom border-dark">
      Indirizzo mail: info@concura.online / PEC: qwince.legalmail.it
    </p>
    <p class="px-1 mb-0">
      Dati di contatto del Data Protection Officer (DPO): dpo@qwince.com.
    </p>
  `,
      controller: "Responsabile del trattamento",
      controllerContent: `
    <p>Il responsabile del trattamento è:</p>
    <p>Sede legale:</p>
    <p>Email:</p>
    <p v-if="company.contatto_dpo" class="px-1 mb-0">
      Dati di contatto del Data Protection Officer (DPO): {{ company.contatto_dpo }}
    </p>
  `,
      section1Title: "1. PER QUALI FINALITÀ SONO TRATTATI I MIEI DATI/ I DATI DEL MIO FAMILIARE/ASSISTITO E PERCHÉ IL TRATTAMENTO È LEGITTIMO?",
      section1Content: `
    <p>Il Titolare tratta i dati per consentirLe di prenotare per Lei o per un Suo familiare/assistito ordini presso la propria struttura. Questo trattamento è legittimo perché:</p>
    <ul>
      <li>per quanto riguarda i dati comuni (es. anagrafici) il trattamento è necessario per dare esecuzione a un contratto;</li>
      <li>per quanto riguarda i dati di salute il trattamento è basato sul consenso che Lei può manifestare spuntando l'apposita casella situata prima del tasto di invio dei dati per effettuare il singolo ordine.</li>
    </ul>
  `,
      section2Title: "2. A CHI SONO COMUNICATI I MIEI DATI/ I DATI DEL MIO FAMILIARE/ASSISTITO?",
      section2Content: `
    <p>I Suoi dati sono comunicati a una società di consulenza informatica e a Qwince Innovation Srl per la gestione della Piattaforma. Lei può richiedere l'elenco completo dei destinatari dei Suoi dati personali scrivendo all'indirizzo mail <a href="mailto:assistenza@concura.online" class="text-secondary">assistenza@concura.online</a>. In ogni caso i Suoi dati personali non saranno diffusi.</p>
  `,
      section3Title: "3. I MIEI DATI/ I DATI DEL MIO FAMILIARE/ASSISTITO SONO TRASFERITI FUORI DALL'UNIONE EUROPEA?",
      section3Content: `
    <p>I dati non vengono trasferiti al di fuori dell'Unione Europea.</p>
  `,
      section4Title: "4. PER QUANTO TEMPO SONO CONSERVATI I MIEI DATI/ I DATI DEL MIO FAMILIARE/ASSISTITO?",
      section4Content: `
    <p>Il Titolare conserverà i dati personali per un periodo di tempo non superiore a quello necessario a conseguire le finalità per le quali li sta trattando. Nello specifico i Suoi dati saranno conservati per tutto il tempo in cui il profilo rimarrà attivo e pertanto fino alla disattivazione del Suo profilo. Al termine di tale periodo, salvo obblighi di legge, il Titolare cancellerà i dati in maniera irreversibile – tramite metodi di distruzione o cancellazione sicura – o li conserverà in una forma anonima che non consenta, neanche indirettamente, la Sua identificazione.</p>
  `,
      section5Title: "5. SARÒ SOTTOPOSTO A PROFILAZIONE?",
      section5Content: `
    <p>I dati non verranno in nessun caso utilizzati per ottenere informazioni relative alle Sue preferenze o al Suo comportamento né Lei sarà sottoposto ad alcuna decisione basata unicamente sul trattamento automatizzato dei Suoi dati personali.</p>
  `,
      section6Title: "6. QUALI SONO I MIEI DIRITTI?",
      section6Content: `
    <p>Lei ha i seguenti diritti:</p>
    <ul>
      <li><b>Diritto di accesso ai dati:</b> ottenere conferma che sia in corso un trattamento, accedere ai dati e ricevere informazioni sul trattamento.</li>
      <li><b>Diritto di rettifica:</b> ottenere la rettifica o l'integrazione dei dati inesatti o incompleti.</li>
      <li>
        <b>Diritto alla cancellazione:</b> ottenere la cancellazione dei dati personali senza ingiustificato ritardo se:
        <ul>
          <li>i dati non sono più necessari;</li>
          <li>sono stati trattati illecitamente;</li>
          <li>devono essere cancellati per obbligo legale;</li>
          <li>sono stati raccolti per servizi della società dell'informazione.</li>
        </ul>
      </li>
      <li>
        <b>Diritto alla limitazione del trattamento:</b> nei casi in cui:
        <ul>
          <li>contesta l'esattezza dei dati;</li>
          <li>il trattamento è illecito ma si oppone alla cancellazione;</li>
          <li>i dati sono necessari per un diritto in sede giudiziaria;</li>
          <li>si oppone al trattamento in attesa della verifica della prevalenza dei suoi interessi.</li>
        </ul>
      </li>
      <li><b>Diritto alla portabilità:</b> ricevere i dati in formato strutturato e trasmetterli a un altro titolare.</li>
      <li><b>Diritto di non essere sottoposto a decisione automatizzata:</b> incluso la profilazione che produca effetti giuridici significativi.</li>
    </ul>
    <p>Può esercitare i Suoi diritti scrivendo al Titolare. Riceverà risposta entro 30 giorni.</p>
  `,
      section7Title: "7. SONO OBBLIGATO A FORNIRE I MIEI DATI/ I DATI DEL MIO FAMILIARE/ASSISTITO?",
      section7Content: `
    <p>Lei è libero di non fornire i dati, ma se non li fornisce non Le sarà possibile procedere ad effettuare l'ordine.</p>
  `,
      section8Title: "8. COME POSSO PRESENTARE RECLAMO?",
      section8Content: `
    <p>Se desidera proporre un reclamo in merito al trattamento dei dati o alla gestione di un reclamo già presentato, può farlo direttamente all'Autorità di controllo secondo le modalità indicate sul sito <a href="https://www.garanteprivacy.it" target="_blank">www.garanteprivacy.it</a>.</p>
  `
    },
    RiepilogoPrenotazione: {
      service: "Servizio:",
      generic: "generico",
      rememberPin: "Ricorda di portare con te il pin della ricetta quando vai a ritirare l'ordine.",
      structureAssigned: "Scelta struttura affidata a",
      selectedDateTime: "Data ed ora selezionate:",
      estimatedDateTime: "Data ed ora (stimata):",
      downloadableDocs: "Documenti Scaricabili",
      docsNote: "Sono presenti documenti correlati a questa prenotazione, puoi visualizzarli cliccando su ciascuno di essi. I documenti contenenti campi da compilare vanno scaricati, stampati, compilati e presentati in sede di appuntamento.",
      recommendations: "Raccomandazioni",
      thankYou: "Grazie",
      forRequest: "per la richiesta di prenotazione.",
      forBooking: "per la prenotazione.",
      confirmationMessage: "A breve riceverai una comunicazione da parte di un nostro operatore per la conferma della prenotazione.",
      structurePreference: "Preferenza Struttura Sanitaria:"
    },
    PickNuovaPrenotazioneType: {
      ricerca_per_visita: "Ricerca per visita o prestazione",
      ricerca_per_centro: "Ricerca per centro erogatore",
      skip_payment_label: "Richiedo che per questa prenotazione non venga richiesto un pagamento",
      skip_payment_help: "La prenotazione verrà contrassegnata come gratuita"
    },
    PickCompanyOperator: {
      labelAssign: "Operatore da assegnare alla prenotazione",
      labelPreference: "Preferenza Operatore Sanitario",
      noPreference: "Nessuna Preferenza",
      emailDocumentiFirmatiInfo: "L'operatore selezionato riceverà le email dei documenti firmati durante la prestazione."
    },
    qui: "QUI",
    NewPreferenzeSelection: {
      insertAtLeast3: "Inserisci almeno 3 preferenze e relative fasce orarie.",
      saveAndProceed: "Salva e procedi",
      saveSelection: "Salva selezione",
      selectDaysAndTimes: "Seleziona giorni e orari di preferenza",
      noPreference: "Non ho particolari preferenze",
      wantToSpecify: "Voglio indicare le preferenze",
      labelHelp: "Utilizza i cursori per navigare tra le date",
      datePlaceholder: "Scegli una data",
      timeSlotLabel: "Fascia oraria di preferenza*",
      addPreference: "Aggiungi preferenza",
      timeOptions: {
        morning: "mattina",
        afternoon: "pomeriggio",
        evening: "sera",
        allday: "tutto il giorno"
      },
      dateLabel: "Data di preferenza*",
    },
    PreferenzePicker: {
      morning: "Mattina",
      afternoon: "Pomeriggio",
      allday: "Tutto il giorno",
      days: {
        long: {
          monday: "Lunedì",
          tuesday: "Martedì",
          wednesday: "Mercoledì",
          thursday: "Giovedì",
          friday: "Venerdì",
          saturday: "Sabato",
          sunday: "Domenica"
        },
        short: {
          monday: "L",
          tuesday: "M",
          wednesday: "M",
          thursday: "G",
          friday: "V",
          saturday: "S",
          sunday: "D"
        }
      },
      scegliFasciaOraria: "Scegli la fascia oraria che preferisci"
    },
    SearchCompanyFilters: {
      searchCenter: "Cerca centro erogatore",
      namePlaceholder: "Denominazione",
      type: "Tipologia",
      region: "Regione",
      province: "Provincia",
      municipality: "Comune",
      zip: "CAP",
      zipPlaceholder: "CAP"
    },
    CittadinoAgenda: {
      title: "Calendario",
      serviceInactive: "Servizio non attivo."
    },
    CalendarioCittadino: {
      month: "Mese",
      year: "Anno",
      previous: "Precedente",
      next: "Successiva",
      showMondayOnly: "mostra solo lunedì",
      showTuesdayOnly: "mostra solo martedì",
      showWednesdayOnly: "mostra solo mercoledì",
      showThursdayOnly: "mostra solo giovedì",
      showFridayOnly: "mostra solo venerdì",
      showSaturdayOnly: "mostra solo sabato",
      showSundayOnly: "mostra solo domenica",
      noRequests: "Nessuna richiesta qui.",
      teleconsulto: "Teleconsulto",
      ordine: "Ordine",
      prestazioneSanitaria: "Prestazione sanitaria",
      evento: "Evento",
      statusConfirmed: "Confermato",
      statusCompleted: "Evaso/Concluso",
      statusForwarded: "Inoltrato/In attesa di risposta",
      statusError: "Errore/Rifiutato/Annullato",
      fetchError: "non è stato possibile recuperare le prenotazioni",
      updateSuccess: "Richiesta aggiornata con successo",
      genericError: "non è stato possibile effettuare l'operazione",
      downloadError: "non è stato possibile scaricare il promemoria",
      months: {
        january: "Gennaio",
        february: "Febbraio",
        march: "Marzo",
        april: "Aprile",
        may: "Maggio",
        june: "Giugno",
        july: "Luglio",
        august: "Agosto",
        september: "Settembre",
        october: "Ottobre",
        november: "Novembre",
        december: "Dicembre"
      },
      daysShort: {
        mon: "lun",
        tue: "mar",
        wed: "mer",
        thu: "gio",
        fri: "ven",
        sat: "sab",
        sun: "dom"
      },
      rangeDate: "{start} - {end}"
    },
    Eventi: {
      nuovoEvento: "nuovo evento",
      nomeLabel: "Nome Evento*",
      luogoLabel: "Luogo*",
      dataLabel: "Data*",
      dataPlaceholder: "Seleziona una data",
      oraLabel: "Ora*",
      noteLabel: "Note",
      notePlaceholder: "Aggiungi delle note (facoltativo)",
      parametriObbligatori: "*parametri obbligatori",
      salva: "Salva",
      salvaModifiche: "Salva Modifiche",
      modifica: "Modifica Evento",
      elimina: "Elimina Evento",
      annullaModifiche: "Annulla Modifiche",
      confermaElimina: "Confermi di voler eliminare l'evento?",
      okElimina: "Sì, elimina",
      annullaElimina: "No, annulla",
      testoConfermaElimina: `Se confermi, l'evento "{{titolo}}" verrà eliminato definitivamente.`,
      titoloNuovo: "Nuovo Evento",
      titoloModifica: "Modifica Evento",
      titoloDettagli: "Dettagli Evento",
      successoModifica: "Evento modificato con successo",
      erroreModifica: "Errore durante la modifica dell'evento",
      successoCreazione: "Evento creato con successo",
      erroreCreazione: "Errore durante la creazione dell'evento",
      successoEliminazione: "Evento eliminato con successo",
      erroreEliminazione: "Errore durante l'eliminazione dell'evento"
    },
    CalendarioCittadinoMobile: {
      labelHelp: "Utilizza i cursori per navigare tra le date",
      day: "giorno",
      loading: "caricamento",
      noRequests: "Nessuna richiesta qui.",
      teleconsulto: "Teleconsulto",
      ordine: "Ordine",
      prestazioneSanitaria: "Prestazione sanitaria",
      evento: "Evento",
      statusConfirmed: "Confermato",
      statusCompleted: "Evaso/Concluso",
      statusForwarded: "Inoltrato/In attesa di risposta",
      statusError: "Errore/Rifiutato/Annullato",
      fetchError: "non è stato possibile recuperare le prenotazioni",
      updateSuccess: "Richiesta aggiornata con successo",
      operationError: "non è stato possibile effettuare l'operazione",
      downloadError: "non è stato possibile scaricare il promemoria",
      requestSuccess: "richiesta inviata con successo"
    },
    PreviewConsultoCittadino: {
      avvia: "Avvia",
      termina: "Termina",
      consulto: "Consulto",
      status: "stato",
      questionario: "Il tuo questionario",
      tempoRimanente: "Tempo rimanente",
      durata: "Durata",
      consultoConcluso: "Consulto concluso.",
      vaiAiReferti: "Vai ai tuoi referti",
      consultiPrevisti: "Consulti previsti per oggi",
      ora: "Ore",
      con: "con",
      durataPrevista: "durata prevista",
      minuti: "minuti",
      nessunConsulto: "Nessun consulto previsto per oggi",
      abbonamentoNonAttivo: "Purtroppo non è possibile effettuare il consulto: la farmacia selezionata non ha più l'abbonamento attivo per il servizio.",
      erroreRichieste: "non è stato possibile prelevare le richieste",
      connessione: {
        attesa: "Attesa connessione...",
        inCorso: "Connessione in corso...",
        connesso: "Connesso.",
        fallita: "Connessione non riuscita. Termina e riavvia la connessione.",
        abbandonato: "L'utente ha abbandonato il consulto."
      },
      documentiDaFirmare: {
        titolo: "Documento da firmare",
        titoloMultipli: "Documenti da firmare",
        caricamentoDocumenti: "Caricamento documenti...",
        firmato: "Firmato",
        firma: "Firma",
        documentiCompletati: "Documenti firmati!",
        tuttiDocumentiFirmati: "Tutti i documenti sono stati firmati con successo",
        riduzioneAutomatica: "Riduzione automatica",
        firmati: "Firmati",
        documentiFirmati: "Documenti firmati",
        firmatoIl: "firmato il"
      }
    },
    DocumentSigningModal: {
      firmaDocumento: "Firma Documento",
      caricamentoDocumento: "Caricamento documento...",
      leggiAttentamente: "Leggi attentamente il documento prima di procedere con la firma digitale.",
      scorriFineFondo: "Scorri fino in fondo al documento per abilitare la firma.",
      puoiProcedere: "Hai letto l'intero documento. Puoi procedere con la firma.",
      scarica: "Scarica",
      scaricamento: "Scaricamento...",
      scorriDocumento: "Scorri il documento per abilitare la firma",
      scorriAbilitare: "Scorri tutto il documento per abilitare la firma",
      scorriPercentuale: "Scorri documento ({percentuale}%)",
      documentoFirmato: "Documento firmato con successo",
      caricamentoDatiUtente: "Caricamento dati utente...",
      erroreFirma: "Errore nella firma del documento",
      erroreCaricamento: "Errore nel caricamento del documento",
      erroreDownload: "Errore nel download del documento",
      documentoFirmatoSuccesso: "Documento firmato con successo",
      emailInviata: "Una email con il documento firmato è stata inviata a te e al personale sanitario"
    },
    VideoCaller: {
      attesaCollegamento: "In attesa che l'altro utente si colleghi...",
      reteAssente: "Segnale rete internet assente.",
      connectionStatus: {
        1: "Apertura nuovo canale di connessione sicura...",
        2: "Connessione sicura inizializzata...",
        3: "Connessione in corso...",
        4: "Connesso!",
        5: "Errore durante il collegamento, connessione canale sicuro in chiusura...",
        6: "Errore durante il collegamento, connessione canale sicuro chiusa.",
        7: "L'utente ha abbandonato il consulto. Teleconsulto concluso.",
        8: "L'utente ha abbandonato il consulto. Teleconsulto concluso."
      },
      clientStatus: {
        1: "Nuovo client",
        2: "Client connesso ad internet",
        3: "Connessione internet interrotta. Verificare la connettività del proprio dispositivo."
      },
      connessioneFallita: "Non è stato possibile collegarsi",
      avvioMediaFallito: "Non è stato possibile avviare fotocamera e/o microfono",
      connessioneNonRiuscita: 'Non è stato possibile connettersi. Clicca su "Termina" e riavvia la sessione.',
      connessioneStabilita: "Connessione stabilita.",
      connessioneSconosciuta: "Stato connessione sconosciuto",
      connessioneInstabile: "Non è stato possibile stabilire una connessione stabile. Terminare e riavviare il consulto.",
    },
    MessagingComponent: {
      chat: "Chat",
      invio: "invio",
      connessioneFallita: "Non è stato possibile collegarsi",
      connesso: "...connesso alla chat",
    },
    PrenotazioniTeleconsultoCittadino: {
      nuovaRichiesta: "Nuova richiesta di prenotazione",
      inSospeso: "In sospeso",
      confermati: "Confermati",
      confermate: "Confermate",
      storico: "Storico",
      servizioNonAttivo: "Servizio non attivo."
    },
    RichiesteEmergenzaCittadinoMain: {
      titolo: "Le mie richieste",
      aggiornamento: "Aggiornamento in corso...",
      nessunaRichiesta: "Nessuna richiesta qui.",
      modalTitle: "Teleconsulto Rapido",
      modalTitlePed: "Teleconsulto Rapido",
      modalOk: "Avvia ora",
      programmato: "Programmato per le",
      servizioNonAttivo: "Servizio non attivo.",
      erroreRichieste: "non è stato possibile prelevare le richieste"
    },
    DettaglioRichiestaEmergenza: {
      attesaRisposta: "in attesa di risposta",
      terminato: "Terminato",
      programmato: "Programmato",
      annullato: "Annullato",
      dataRichiesta: "Data richiesta",
      orarioRichiesta: "Orario richiesta",
      teleconsultoCon: "Teleconsulto con",
      prenotazionePer: "Prenotazione effettuata per",
      avviaOra: "Avvia ora"
    },
    CircoloCura: {
      titolo: "Il tuo circolo di cura",
      aggiungiNuovo: "aggiungi nuovo",
      consigliati: "Consigliati per te",
      nessunElemento: "Nessun elemento nel tuo circolo di cura.",
      area: "Area",
      sede: "sede",
      mioCircolo: "Il mio circolo di cura",
      contatti: "Contatti",
      email: "email",
      telefono: "telefono",
      apertura: "Apertura",
      chiuso: "Chiuso",
      nonInseriti: "Non inseriti",
      prenota: "Prenota",
      impostaPreferito: "Imposta come preferito",
      rimuoviCircolo: "Rimuovi dal mio circolo di cura",
      rimossoSuccesso: "Elemento rimosso correttamente!",
      rimossoErrore: "non è stato possibile rimuovere l'elemento selezionato",
      preferenzeAggiornate: "preferenze aggiornate correttamente!",
      preferenzeErrore: "non è stato possibile aggiornare le preferenze",
      infoErrore: "non è stato possibile recuperare le informazioni",
      aggiungiTooltip: "Aggiungi al tuo circolo di cura"
    },
    AddMedicoModal: {
      invitaMedico: "invita il mio medico",
      titleTooltip: "Invita il tuo medico su ",
      nomeLabel: "Nome*",
      nomePlaceholder: "Nome...",
      cognomeLabel: "Cognome*",
      cognomePlaceholder: "Cognome...",
      cittaLabel: "Città*",
      cittaPlaceholder: "Città...",
      emailLabel: "Email",
      emailPlaceholder: "Email...",
      campiObbligatori: "*Campi obbligatori",
      invia: "Invita",
      successo: "Medico invitato correttamente!",
      erroreInvito: "non è stato possibile invitare il medico"
    },
    SottoscrizioniCittadinoMain: {
      acquisti: "Acquisti",
      acquisto: "acquisto",
      gestione: "Gestione",
      storico: "Storico",
      sottoscriviAbbonamento: "Sottoscrivi abbonamento",
      acquistaAbbonamento: "Acquista abbonamento",
      acquistaPrenotazione: "Acquista prenotazione",
      storicoAcquisti: "Storico acquisti",
      riepilogo: "Riepilogo",
      abbonamento: "Abbonamento",
      sottoscrizione: "Sottoscrizione",
      ivaInclusa: "IVA inclusa",
      ivaEsclusa: "+ iva",
      mese: "Mese",
      mesi: "Mesi",
      anno: "Anno",
      servizio: "Servizio",
      costiServizio: "Costi di gestione del servizio",
      codiceSconto: "Codice Sconto",
      voucher: "Codice sconto voucher",
      totale: "Totale",
      imponibile: "Imponibile",
      iva: "IVA",
      sottoscrivi: "Sottoscrivi",
      rinnovoAutomatico: "*L'abbonamento si rinnova automaticamente",
      ogniMese: "ogni mese",
      ogni: "ogni",
      riprova: "Riprova",
      attesaPagamento: "Acquisto in attesa di pagamento",
      homepage: "Homepage",
      completata: "Sottoscrizione abbonamento completata",
      ore: "ore",
      interrompibile: "Il rinnovo automatico può essere interrotto in qualsiasi momento.",
      completed: "completata",
      erroreGenerico: "Non è stato possibile completare l'operazione.",
      errorePagamento: "Non è stato possibile recuperare le informazioni relative al pagamento",
      sottoscrizioneSuccesso: "Sottoscrizione completata",
      erroreSottoscrizione: "Non è stato possibile completare la sottoscrizione",
    },
    PianiTerapeuticiScheda: {
      titolo: "Piani Terapeutici",
      nuovoPiano: "nuovo piano terapeutico",
      nessunRisultato: "La ricerca non ha prodotto risultati.",
      piano: "Piano Terapeutico",
      validoDal: "valido dal",
      al: "al",
      dal: "dal",
      somministraQuestionario: "Somministra questionario",
      pianoInvalidato: "Il piano è stato invalidato dall'Asl.",
      rinnovoRifiutato: "Il rinnovo fornitura è stato rifiutato dall'Asl.",
      motivazioni: "Motivazioni:",
      pacchetto: "Pacchetto",
      stato: "Stato",
      il: "il",
      etichetta: "Etichetta:",
      contenuto: "Contenuto:",
      quantità: "Quantità:",
      lotto: "Lotto:",
      scadenza: "Scadenza:",
      noteAsl: "Note Asl:",
      nessunPacchetto: "Ancora nessun pacchetto previsto per questo piano.",
      nessunElemento: "Nessun elemento tra i piani",
      caricaPiano: "Carica nuovo Piano Terapeutico",
      annulla: "Annulla",
      salva: "Salva",
      ricordaInserimento: "Ricorda di inserire e verificare tra le terapie i farmaci prescritti prima di caricare il Piano Terapeutico. Si ricorda che per ottenere il rinnovo fornitura su piani terapeutici precedentemente caricati ed ancora in corso di validità occorre non caricare un nuovo piano ma utilizzare la funzione \"rinnovo fornitura\" sulla riga piano terapeutico completato.",
      istruzioniCaricamento: "Ad ogni nuovo Piano Terapeutico emesso e portato in farmacia, verificare ed aggiornare la scheda del paziente con particolare attenzione alle terapie, sezione nella quale vanno inseriti i farmaci prescritti nel Piano Terapeutico. Dopo aver aggiornato la scheda del paziente, procedere al caricamento del Piano Terapeutico; in seguito al caricamento del documento sarà necessario indicare le date di validità del Piano e selezionare il/i farmaci inclusi nel piano dal selettore \"seleziona terapie\". Clicca su \"salva piano\" per concludere l'operazione: l'ufficio Asl di competenza riceverà una notifica e prenderà in carico il Piano. Quando il farmaco sarà pronto per la consegna al paziente, l'Asl inoltrerà una notifica agli operatori della farmacia ed al paziente.",
      documento: "Documento",
      fileCaricato: "File caricato correttamente.",
      validitàPiano: "Validità del Piano Terapeutico",
      farmaciInclusi: "Farmaci inclusi nel piano",
      selezionaTerapie: "Seleziona terapie*",
      scegliTerapie: "Scegli terapie",
      annotazioni: "Annotazioni",
      inserisciNote: "Inserisci eventuali note relative al Piano Terapeutico",
      salvaPiano: "Salva Piano",
      confermaOperazione: "Conferma Operazione",
      noAnnulla: "No, Annulla",
      siElimina: "Sì, elimina",
      seiSicuro: "Sei sicuro di voler eliminare questo piano?",
      conferma: "Conferma",
      rinnovoPerFarmaci: "Per quali farmaci vuoi richiedere il rinnovo?",
      questionarioPaziente: "Questionario per il paziente",
      informativaPaziente: "Informativa per il paziente",
      consentoInformativa: "Ho consegnato/comunicato l'informativa al cittadino",
      procedi: "Procedi",
      operazioneCompletata: "Operazione completata.",
      descrizioneScarica: "Cliccando sul tasto \"scarica pdf per il paziente\" puoi scaricare il questionario appena compilato in versione stampabile, comprensivo di informativa (laddove presente) e di spazio dedicato per la firma. Potrai comunque scaricare il pdf per il paziente e il questionario in altri formati accedendo alla reportistica dedicata al questionario.",
      chiudiFinestra: "chiudi finestra",
      scaricaPdf: "scarica pdf per il paziente",
      servizioNonAbilitato: "Servizio non abilitato",
      placeholderCerca: "Cerca identificativo...",
      rinnovoFornitura: "Rinnovo fornitura",
      somministraQuestionario: "Somministra questionario",
      caricaNuovoPiano: "Carica nuovo Piano Terapeutico",
      annulla: "Annulla",
      noAnnulla: "No, Annulla",
      salva: "Salva",
      siElimina: "Sì, elimina",
      conferma: "Conferma",
      confermaOperazione: "Conferma Operazione",
    },
    CambiaStatoConsegna: {
      cambia: "Cambia",
      aggiorna: "Aggiorna",
      stato: "stato",
      title: "Aggiorna stato pacchetto consegna",
      ok: "Conferma",
      annulla: "Annulla",
      selezionaStato: "Seleziona il nuovo stato del pacchetto",
      inPreparazione: "in preparazione",
      prontoRitiro: "pronto per il ritiro",
      ritiratoProntoConsegna: "ritirato, pronto per la consegna al paziente",
      consegnato: "consegnato al paziente",
      reso: "reso dal paziente",
      successo: "Stato pacchetto modificato correttamente",
      errore: "Non è stato possibile modificare lo stato del pacchetto"
    },
    CompilaQuestionarioOperatore: {
      domandaOperatore: "- domanda per l'operatore",
      scegliOpzioni: "scegli una o più opzioni...",
      aggiungiAltro: "aggiungi altro",
      placeholderAltro: "altra opzione personalizzata",
      invia: "Invia"
    },
    GestioneSottoscrizioni: {
      titolo: "Gestione Sottoscrizioni",
      visualizzaTutte: "Visualizza tutte le sottoscrizioni",
      pianoAttivo: "Piano attivo",
      durataMinima: "Durata minima:",
      mese: "mese",
      anno: "anno",
      siRinnovaIl: "Si rinnova il",
      scadraIl: "Scadrà il",
      leggiDiPiu: "Leggi di più",
      prestazioniDisponibili: "Prestazioni disponibili:",
      ordineFarmaci: "Ordine farmaci disponibili:",
      teleconsultoRapido: "Teleconsulto Rapido:",
      teleconsultoPediatrico: "Teleconsulto Pediatrico:",
      gratis: "GRATIS",
      altreSottoscrizioni: "Altre Sottoscrizioni",
      contattaci: "Contattaci",
      acquista: "Acquista",
      completaAcquisto: "Completa l'acquisto",
      elimina: "Elimina",
      confermaAnnullamento: "Confermi di voler annullare la sottoscrizione",
      siCancella: "Sì, cancella",
      noAnnulla: "No, annulla",
      piani: "Piani",
      erroreGenerico: "Non è stato possibile completare l'operazione.",
      sottoscrizioneEliminata: "Sottoscrizione eliminata con successo.",
      dataFineModificata: "Data fine sottoscrizione modificata con successo.",
      rinnovoStatoSuccesso: "Rinnovo sottoscrizione {{stato}} con successo.",
      attivato: "attivato",
      disattivato: "disattivato"
    },
    SendHelpRequest: {
      titolo: "Assistenza",
      descrizione: "Seleziona tra le opzioni quella che descrive meglio l'oggetto della tua richiesta, e dopo aver compilato il messaggio clicca su \"invia richiesta\": il sistema inoltrerà una email al centro assistenza che prenderà in carico la richiesta nel più breve tempo possibile. In base alla richiesta potrai ricevere riscontro via email oppure essere contattato da un operatore per via telefonica.",
      campiObbligatori: "*Campi obbligatori",
      inviaRichiesta: "Invia Richiesta",
      titoloModale: "Richiesta di Assistenza",
      oggettoLabel: "Oggetto*",
      messaggioLabel: "Messaggio*",
      selezionaOggetto: "Seleziona un oggetto",
      richiestaInformazioni: "Richiesta informazioni",
      richiestaImplementazione: "Richiesta implementazione",
      malfunzionamento: "Malfunzionamento",
      correzioneDati: "Correzione dati errati",
      successo: "Richiesta di assistenza inviata con successo",
      errore: "Non è stato possibile inviare la richiesta",
      testoRichiestaFullMonitor: "Vorrei sapere di più sulla sottoscrizione ConCura Full Monitor"
    },
    EditSubscription: {
      titolo: "Modifica Sottoscrizione",
      infoInizio: "É possibile impostare una data di fine per la sottoscrizione, oppure disabilitare il rinnovo automatico",
      infoGiaImpostata: "Hai già impostato una data di fine sottoscrizione.",
      infoModificaVincolo: "É possibile modificare lo stato del rinnovo automatico, solo se non sono state impostate date di fine sottoscrizione.",
      infoAzzeraPerModificare: "Per procedere con l'annullamento del rinnovo automatico, azzera prima la data di fine sottoscrizione.",
      infoRiabilitaPerDataFine: "É possibile impostare una data di fine sottoscrizione solo se il rinnovo automatico è abilitato. Riabilita il rinnovo automatico per impostare una data di fine per la sottoscrizione.",
      rinnovoIl: "La sottoscrizione si rinnoverà il",
      scadraIl: "La sottoscrizione scadrà il",
      attivaProssimoPagamento: "La sottoscrizione è attiva e il prossimo pagamento è previsto per il",
      gestisciRinnovo: "Gestisci il Rinnovo Automatico",
      rinnovoAutomatico: "Rinnovo automatico",
      impostaDataFine: "Imposta una data di fine sottoscrizione",
      descrizioneDataFine: "Per le sottoscrizioni con rinnovo automatico abilitato, è possibile impostare una data di fine rinnovo. Da quella data in poi la sottoscrizione non verrà rinnovata automaticamente.",
      nessunaData: "Nessuna data di fine impostata.",
      impostaData: "Imposta una data di fine",
      modificaData: "Hai già impostato una data di fine per la sottoscrizione. Se vuoi, puoi modificarla o azzerarla.",
      selezionaPeriodo: "Seleziona",
      unMeseE: "un mese e",
      unAnno: "un anno per la data di fine sottoscrizione",
      annoFine: "Anno di fine",
      imposta: "Imposta data",
      azzera: "Azzera",
      validazioneData: "La data di fine deve essere successiva alla data di prossimo pagamento",
      gennaio: "Gennaio",
      febbraio: "Febbraio",
      marzo: "Marzo",
      aprile: "Aprile",
      maggio: "Maggio",
      giugno: "Giugno",
      luglio: "Luglio",
      agosto: "Agosto",
      settembre: "Settembre",
      ottobre: "Ottobre",
      novembre: "Novembre",
      dicembre: "Dicembre",
      meseFine: "Mese di fine",
    },
    StoricoAcquisti: {
      nessunAcquisto: "Nessun acquisto effettuato.",
      visualizzaAcquisti: "Visualizza Acquisti",
      mostraProforma: "Mostra Proforma Fattura",
      descrizione: "Descrizione",
      stato: "Stato",
      erroreGenerico: "Non è stato possibile completare l'operazione.",
      idTransazione: "ID Transazione",
      importo: "Importo",
      esito: "Esito",
      dataPagamento: "Data Pagamento",
      azioni: "Azioni",
      acquisti:"Acquisti"
      
    },
    SubscriptionVoucherValidator: {
      labelCodice: "Hai un codice sconto? Inseriscilo qui:",
      conferma: "Conferma",
      voucherNonValido: "Voucher non valido"
    },
    ProgettiMain: {
      servizioNonAbilitato: "Servizio non abilitato",
      contattaci: "Contattaci",
      perAbilitare: "per saperne di più o per abilitare il servizio",
      confermaEliminazione: "Confermi di voler eliminare il post selezionato?",
      siElimina: "Sì, elimina",
      noAnnulla: "No, annulla",
      caricaArticolo: "Carica un articolo",
      modificaArticolo: "Modifica articolo",
      inserisci: "Inserisci un",
      modifica: "Modifica",
      webinar: "Webinar",
      video: "Video",
      servizioNonAttivo: "Servizio non attivo.",
      erroreServizi: "Errore nel recupero dei servizi",
      errorePost: "Errore nel recupero dei post",
      postCreato: "Post creato con successo",
      erroreCreazione: "Errore nella creazione del post",
      postModificato: "Post modificato con successo",
      erroreModifica: "Errore nella modifica del post",
      postEliminato: "Post eliminato con successo",
      erroreEliminazione: "Errore nell'eliminazione del post"
    },
    ProjectPanoramica: {
      benvenuto: "Benvenuto/a nel Blog di",
      articoli: "Articoli",
      vediTutti: "Vedi tutti",
      nuovoArticolo: "nuovo articolo",
      nessunArticolo: "Non ci sono articoli disponibili al momento.",
      video: "Video",
      nuovoVideo: "nuovo video",
      nessunVideo: "Non ci sono video disponibili al momento.",
      nuovoWebinar: "nuovo webinar",
      nessunWebinar: "Non ci sono webinar disponibili al momento.",
      videoTipoWebinar: "Video di tipo webinar"
    },
    ProjectDetail: {
      tornaIndietro: "Torna indietro",
      nuovo: "nuovo",
      cerca: "Cerca",
      nessunElemento: "Non ci sono elementi da mostrare",
      nonCiSono: "Non ci sono",
      daMostrare: "da mostrare",
      cercaPerTitolo: "Cerca per Titolo",
      cercaPerData: "Cerca per Data",
      subsection: {
        articolo: "articoli",
        video: "video",
        webinar: "webinar",
        evento: "eventi",
      }
    },
    CreateEditArticle: {
      immagineCopertina: "Immagine di copertina",
      titolo: "Titolo*",
      placeholderTitolo: "Scrivi il titolo dell'articolo",
      contenuto: "Contenuto*",
      placeholderContenuto: "Contenuto dell'articolo",
      data: "Data",
      abilitato: "Abilitato",
      disabilitato: "Disabilitato",
      campiObbligatori: "* campi obbligatori",
      salva: "Salva",
      modifiche: "modifiche",
      nuovoArticolo: "nuovo articolo"
    },
    CreateEditVideo: {
      immagineCopertina: "Immagine di copertina*",
      erroreCopertina: "Inserisci un'immagine di copertina",
      titolo: "Titolo*",
      placeholderTitolo: "Scrivi il titolo del video",
      abilitato: "Abilitato",
      disabilitato: "Disabilitato",
      categoriaWebinar: "Categoria Webinar",
      tipoWebinar: "Il video è di tipo Webinar",
      tipoNonWebinar: "Il video non è di tipo Webinar",
      campiObbligatori: "* campi obbligatori",
      salva: "Salva",
      modifiche: "modifiche",
      nuovoVideo: "nuovo video"
    },
    ProfiloSanitarioMain: {
      archivioSanitario: "Archivio sanitario",
      patologie: "Patologie",
      terapie: "Terapie",
      piani: "Piani Terapeutici",
      note: "Note",
      dispositivi: "Dispositivi",
      accessi: "Attività registrate",
      servizioNonAttivo: "Servizio non attivo.",
      errore: "Non è stato possibile completare l'operazione.",
      anamnesi: "Anamnesi"
    },
    LineChart: {
      gennaio: "Gennaio",
      febbraio: "Febbraio",
      marzo: "Marzo",
      aprile: "Aprile",
      maggio: "Maggio",
      giugno: "Giugno",
      luglio: "Luglio",
      agosto: "Agosto",
      settembre: "Settembre",
      ottobre: "Ottobre",
      novembre: "Novembre",
      dicembre: "Dicembre",
      ordiniAlMese: "Ordini al mese"
    },
    ArmadiettoComponent: {
      terapieInAtto: "Terapie in atto",
      prospettoTerapie: "Prospetto Terapie",
      nuovaTerapia: "nuova terapia",
      sospesa: "Sospesa",
      finoAl: "Fino al",
      dal: "Dal",
      elimina: "Elimina",
      vedi: "Vedi",
      storicoTerapie: "Storico Terapie",
      terminataIl: "Terminata il",
      nessunElemento: "Nessun elemento nello storico",
      modificaTerapia: "Modifica terapia",
      dettaglioTerapia: "Dettaglio terapia",
      perPatologia: "per patologia",
      patologia: "patologia",
      modifica: "Modifica",
      riprendi: "Riprendi",
      sospendi: "Sospendi",
      scaricaPromemoria: "Scarica promemoria",
      inseritaIl: "Inserita il",
      conferma: "Conferma",
      noAnnulla: "No, Annulla",
      siConferma: "Sì, Conferma",
      confermiSospRipr: "Confermi di voler",
      sospendere: "sospendere",
      riprendere: "riprendere",
      laTerapia: "la terapia?",
      confermaEliminazione: "Conferma eliminazione",
      confermiEliminazione: "Confermi di voler eliminare la terapia?",
      erroreRecupero: "Non è stato possibile recuperare le terapie",
      terapia: "Terapia",
      sospesa: "sospesa",
      ripresa: "ripresa",
      erroreOperazione: "Non è stato possibile eseguire l'operazione",
      eliminata: "Terapia eliminata!",
      erroreEliminazione: "Non è stato possibile eliminare la terapia",
      erroreDownloadPromemoria: "Non è stato possibile scaricare il promemoria",
      erroreDownloadProspetto: "Non è stato possibile scaricare il prospetto.",
      mattina: "mattina",
      meta_mattina: "metà mattina",
      pranzo: "pranzo",
      pomeriggio: "pomeriggio",
      sera: "sera",
      notte: "notte"
    },
    RecapTherapyModal: {
      posologia: "Posologia",
      di: "di",
      perVia: "per via",
      daAssumere: "Da assumere",
      durata: "Durata",
      terapiaOgni: "La terapia va seguita ogni",
      per: "per",
      daFinoA: "Da {{start}} fino a {{end}}",
      aPartireDa: "a partire da",
      cronica: "cronica",
      prescrittore: "Prescrittore",
      effettiCollaterali: "Effetti Collaterali",
      reazioniAllergiche: "Reazioni Allergiche",
      interazioni: "Interazioni",
      annotazioni: "Annotazioni",
      non_indicata: "non indicata",
      non_indicate: "Non indicate",
      non_indicato: "non indicato",
      non_indicati: "non indicati",
      nessuna_nota: "nessuna nota",
      typesMap: {
        Compresse: "compressa",
        Capsule: "capsula",
        Gocce: "goccia",
        Inalazioni: "inalazione",
        Buste: "busta",
        Supposte: "supposta",
        Scatole: "scatola",
        Cerotti: "cerotto",
        Fiale: "fiala",
        Fleboclisi: "fleboclisi",
        Ovuli: "ovulo",
        Sacche: "sacca",
        Flaconi: "flacone",
        Confezioni: "confezione",
        Kilogrammi: "kilogrammo",
        Kit: "kit",
        Millilitri: "millilitro",
        Milligrammi: "milligrammo",
        Applicazioni: "applicazione",
        UI: "UI"
      },
      forEveryUmsSing: {
        0: "mese",
        1: "settimana",
        2: "giorno"
      },
      forEveryUmsPlur: {
        0: "mesi",
        1: "settimane",
        2: "giorni"
      },
      assunzioni: {
        mattina: "mattina",
        meta_mattina: "metà mattina",
        pranzo: "pranzo",
        pomeriggio: "pomeriggio",
        sera: "sera",
        notte: "notte"
      }
    },
    NuovaTerapiaCittadino: {
      profiloSanitario: "Profilo sanitario",
      riepilogo: "Riepilogo",
      scaricaPromemoria: "Scarica promemoria",
      erroreDownloadPromemoria: "Non è stato possibile scaricare il promemoria"
    },
    NewTherapy: {
      titoloPatologia: "Patologia per cui è stata indicata la terapia",
      indicaPatologia: "indica patologia",
      nonIndicare: "non indicare",
      farmacoIndicato: "Farmaco indicato",
      labelCercaFarmaco: "Cerca farmaco",
      placeholderCercaFarmaco: "Cerca per nome o aic..",
      labelSelezionaFarmaco: "Seleziona farmaco*",
      prodottoNonTrovato: "Prodotto non trovato",
      frequenzaModalitaDosaggio: "Frequenza, modalità e dosaggio somministrazione",
      dosaggio: "Dosaggio*",
      frequenza: "Frequenza*",
      alDi: "al dì",
      alBisogno: "al bisogno",
      ogni: "ogni",
      ore: "ore",
      giorni: "giorni",
      daAssumere: "Da assumere",
      mattina: "Mattina",
      metaMattina: "Meta mattina",
      pranzo: "Pranzo",
      pomeriggio: "Pomeriggio",
      sera: "Sera",
      notte: "Notte",
      maxUnoAssunzione: "Con questa frequenza è possibile selezionare al massimo un momento di assunzione",
      inviaAlert: "Invia un promemoria 10 minuti prima la somministrazione",
      durataTerapia: "Durata della terapia",
      indeterminata: "indeterminata",
      periodica: "periodica/ciclica",
      occasionale: "occasionale",
      mesi: "mesi",
      settimane: "settimane",
      giorni: "giorni",
      ogni: "Ogni ",
      aPartireDal: "A partire dal*",
      finoAl: "Fino al*",
      visibileSoloMe: "**se selezioni questa opzione soltanto tu potrai vedere questa terapia",
      dettagli: "Dettagli",
      prescrittore: "Prescrittore terapia*",
      indicaPrescrittore: "indica chi ha prescritto la terapia",
      fonte: "Fonte informativa*",
      indicaFonte: "indica fonte informativa",
      effettiCollaterali: "Effetti collaterali",
      placeholderEffetti: "eventuali effetti collaterali attribuite al farmaco..",
      reazioniAllergiche: "Reazioni allergiche",
      placeholderAllergie: "eventuali reazioni allergiche attribuite al farmaco..",
      interazioni: "Interazioni",
      placeholderInterazioni: "possibili interazioni con farmaci o alimenti individuate..",
      annotazioni: "Annotazioni",
      salva: "Salva terapia",
      visibileSoloMe: "**se selezioni questa opzione soltanto tu potrai vedere questa terapia",
      posologyTypes: {
        Compresse: "Compresse",
        Capsule: "Capsule",
        Gocce: "Gocce",
        Inalazioni: "Inalazioni",
        Buste: "Buste",
        Supposte: "Supposte",
        Scatole: "Scatole",
        Cerotti: "Cerotti",
        Fiale: "Fiale",
        Fleboclisi: "Fleboclisi",
        Ovuli: "Ovuli",
        Sacche: "Sacche",
        Flaconi: "Flaconi",
        Confezioni: "Confezioni",
        Kilogrammi: "Kilogrammi",
        Kit: "Kit",
        Millilitri: "Millilitri",
        Milligrammi: "Milligrammi"
      },
      posologyVias: {
        Orale: "Orale",
        Transdermica: "Transdermica",
        Nasale: "Nasale",
        Endovena: "Endovena",
        Intramuscolo: "Intramuscolo",
        Oftalmica: "Oftalmica",
        Rettale: "Rettale",
        Uretale: "Uretale",
        Vaginale: "Vaginale",
        Sottocute: "Sottocute"
      },
      everyUms: {
        0: "mesi",
        1: "settimane",
        2: "giorni"
      },
      everyPosologyTypes: {
        0: "dì",
        1: "ore",
        2: "bisogno"
      },
      everyPosologyUms: {
        1: "ore",
        2: "giorni"
      },
      successSalvataggio: "Nuova terapia salvata",
      erroreSalvataggio: "Si è verificato un errore durante il salvataggio",
      erroreGenerico: "Si è verificato un errore."
    },
    AccessLogs: {
      titolo: "Attività registrate sul tuo profilo sanitario",
      mese: "mese",
      anno: "Anno",
      nessunAccessoMese: "Nessuna attività nel mese selezionato.",
      nessunAccessoAnno: "Nessuna attività nell'anno selezionato.",
      nessunaAzione: "Nessuna azione nel periodo selezionato",
      erroreNote: "Non è stato possibile recuperare le note",
      filtro_elementi: "Elementi per pagina",
      take_label: "Elementi per pagina",
      day_label: "Giorno",
      month_label: "Mese",
      year_label: "Anno",
      tutti_giorni: "Tutti",
      opzione_elementi: "Mostra {count} elementi",
      azione_label: "Attività registrata",
      data_label: "Data e ora",
      azienda_label: "Struttura",
      operatore_sconosciuto: "Operatore non disponibile",
      company_missing: "Dato non disponibile",
      azione_sconosciuta: "Attività non specificata",
      mesi: {
        "01": "gennaio",
        "02": "febbraio",
        "03": "marzo",
        "04": "aprile",
        "05": "maggio",
        "06": "giugno",
        "07": "luglio",
        "08": "agosto",
        "09": "settembre",
        10: "ottobre",
        11: "novembre",
        12: "dicembre"
      }
    },
    nessunaImpostazione: "Nessuna impostazione per questa utenza",
    AccessoEPermessi: {
      datiAccesso: "Dati di Accesso",
      modificaPasswordTemporanea: "Modifica la tua password temporanea",
      passwordScaduta: "La tua password è scaduta: aggiornala per proseguire.",
      username: "Username",
      password: "Password",
      cambiaPassword: "Cambia Password",
      terminiEPrivacy: "Termini e Condizioni e Informativa Privacy",
      visioneTermini: "Hai preso visione dei",
      revocaTermini: "Hai revocato il consenso a",
      titoloTermini: "Termini e Condizioni d'uso del servizio",
      modifica: "Modifica",
      visionePrivacy: "Hai preso visione dell'",
      revocaPrivacy: "Hai revocato il consenso a",
      titoloPrivacy: "Informativa Privacy",
      visionati1341: "Hai espressamente preso visione, ai sensi dell'articolo 1341 e ss c.c., delle previsioni di cui agli articoli 2, 7, 8, 10, 12 dei presenti del",
      revocati1341: "Hai revocato il consenso agli articoli 2, 7, 8, 10, 12 dei presenti del",
      acconsentoComunicazioni: "Hai acconsentito alla ricezione di comunicazioni commerciali per finalità promozionali come da",
      nonAcconsentoComunicazioni: "Non hai acconsentito alla ricezione di comunicazioni commerciali per finalità promozionali come da",
      titleConsensoComunicazioni: "Consenso comunicazioni commerciali",
      acconsento: "Acconsento alla ricezione di comunicazioni commerciali per finalità promozionali come da Informativa Privacy",
      nonAccetto: "Non accetto",
      annulla: "Annulla",
      salva: "Salva modifiche",
      titleModificaPassword: "Modifica la tua password",
      passwordAttuale: "Password Attuale*",
      placeholderAttuale: "Password attuale...",
      nuovaPassword: "Password*",
      confermaPassword: "Conferma password*",
      placeholderConferma: "Conferma password...",
      requisitiPassword: "La password non può includere il nome né il cognome e deve contenere almeno 8 caratteri, di cui almeno un numero, una maiuscola, una minuscola ed un",
      tooltipCaratteri: "Devi usare almeno un carattere tra ! @ # $ % ^ & * ) ( + = . _ -",
      carattereSpeciale: "carattere speciale",
      passwordDiversa: "La nuova password deve essere diversa da quella attuale.",
      annullaOperazione: "Annulla Operazione",
      confermaModifica: "Conferma Modifica",
      siRevoca: "Sì, revoca permesso",
      noAnnulla: "No, annulla",
      revocaNecessaria: "Il consenso è necessario per la fruizione della piattaforma. Revocando il consenso, non potrai più utilizzare le funzionalità della piattaforma.",
      desideriRevoca: "Desideri procedere con la revoca del consenso?",
      revoca: {
        data_consense: "Vuoi revocare il consenso a Termini e Condizioni d'uso del servizio?",
        share_consense: "Vuoi revocare il consenso agli articoli 2, 7, 8, 10, 12 dei presenti del Termini e Condizioni d'uso",
        charge_consense: "Vuoi revocare il consenso per l'Informativa Privacy?"
      },
      successModifica: "Modifiche effettuate con successo",
      erroreModifica: "Non è stato possibile effettuare la modifica",
      modificaPasswordTemp: "Devi ancora modificare la tua password temporanea",
      passwordScadutaCambio: "La tua password è scaduta e deve essere cambiata"
    },
    ShowUserCode: {
      codice_utente: "Codice utente",
      descrizione_codice: "Il tuo codice utente ti permette di essere identificato in modo sicuro da altri utenti in piattaforma.",
      mostra: "Mostra",
      nascondi: "Nascondi",
      codice: "codice",
      etichetta_codice: "Il tuo codice utente:",
      istruzioni_caregiver: "Mostra questo codice al tuo caregiver affinché possa trovarti ed inserirti nella sua lista di assistiti.",
      nota_validita: "Nota: questo codice sarà <u>valido fino alla mezzanotte di oggi</u>.",
      errore_codice: "Non è stato possibile recuperare il codice",
      codice_copiato: "Codice copiato!",
      copia_codice: "Copia codice",
      button_label: "utente"
    },
    NotificationChannels: {
      accessi_notifiche: "Accessi e Notifiche",
      descrizione_accessi: "Visualizza e gestisci i tuoi accessi, e scegli quali notifiche ricevere nei canali di Concura.",
      notifiche_email1: "Notifiche Email",
      consenso_email: "Hai acconsentito alla ricezione di notifiche via e-mail come indicato nell'",
      no_consenso_email: "Non hai acconsentito alla ricezione di notifiche via e-mail come indicato nell'",
      informativa_privacy: "Informativa Privacy",
      modifica: "Modifica",
      ricezione_notifiche: "Ricezione notifiche",
      consent_push: "Concedi consenso alla ricezione di notifiche push per ricevere notifiche in app",
      canale_telegram: "Canale Telegram",
      ricezione_stato: "Ricezione notifiche",
      attiva: "attiva",
      disattivata: "disattivata",
      rimuovi_accesso: "Rimuovi questo accesso",
      nessun_accesso: "Nessun accesso Telegram attivo",
      accedi_telegram: "Accedi su Telegram!",
      elimina_accesso: "Elimina accesso",
      annulla: "No, Annulla",
      conferma: "Sì, Conferma",
      vuoi_rimuovere: "Vuoi rimuovere l'accesso via",
      accesso_da: "da",
      modifica_stato: "Modifica stato ricezione notifiche",
      vuoi: "Vuoi",
      attivare: "attivare",
      disattivare: "disattivare",
      notifiche_messenger: "la ricezione di notifiche via",
      notifiche_push: "la ricezione di notifiche push?",
      notifiche_email: "la ricezione di notifiche via email?",
      email_question: "Vuoi {azione} le notifiche email?",
      attivare: "attivare",
      disattivare: "disattivare",
      da: "da",
      conferma_operazione: "Conferma operazione",
      consenso_email_title: "Consenso ricezione email",
      acconsento_email: "Acconsento alla ricezione di notifiche via e-mail come indicato nell'",
      non_accetto: "Non accetto",
      salva_modifiche: "Salva modifiche",
      errore_accessi: "Non è stato possibile recuperare gli accessi",
      accesso_eliminato: "Accesso eliminato con successo",
      errore_eliminazione: "Non è stato possibile eliminare l'accesso",
      modifiche_successo: "Modifiche effettuate con successo",
      errore_modifiche: "Non è stato possibile effettuare la modifica",
      notifiche_push: "Notifiche Push"
    },
    StatoSottoscrizioniProfilo: {
      stato_profilo: "Stato Profilo",
      sottoscrizione_attesa: "Sottoscrizione in attesa di pagamento:",
      mesi: "mesi",
      acquista: "Acquista",
      sottoscrizione_attiva: "Sottoscrizione attiva:",
      nessuna_sottoscrizione: "Nessuna sottoscrizione attiva.",
      vai_acquisti: "Vai agli Acquisti",
      conferma_operazione: "Conferma operazione",
      annulla: "No, Annulla",
      conferma: "Sì, Conferma",
      sei_sicuro_attivare: "Sei sicuro di voler attivare il servizio di monitoraggio per",
      testo_attivazione: `
    Con questa operazione verrà avviato il processo di attivazione della
    sottoscrizione al servizio di monitoraggio: il paziente verrà assegnato
    ad un operatore del Centro Servizi che lo guiderà nella procedura di
    acquisto del servizio. <br />
    Inoltre, se ancora non impostato, dopo aver confermato l'operazione
    potrai selezionare, tra le opzioni disponibili, un percorso di cura
    idoneo alle esigenze del paziente; diversamente, verrà attivato il
    monitoraggio "standard" dei principali parametri<br />
    Per il monitoraggio dei principali parametri verranno impostati i
    valori-soglia e le frequenze di rilevazione di default.
  `,
      profilo_sospeso: "Profilo sospeso correttamente.",
      errore_operazione: "Non è stato possibile completare l'operazione.",
      attivazione_successo: "Attivazione eseguita correttamente!"
    },
    PercorsoCuraPaziente: {
      percorso_di_cura: "Percorso di cura",
      modifica_percorso: "Modifica percorso",
      nessun_percorso: "Nessun percorso di cura selezionato",
      seleziona_percorso: "Seleziona percorso",
      label_percorso: "Percorso di cura*",
      scegli: "scegli",
      dettagli_per: "Dettagli percorso per",
      piano_include: "Il piano include:",
      teleconsulti: "Teleconsulti",
      programmati_ogni: "programmati ogni",
      questionari: "Questionari e valutazioni",
      ogni: "ogni",
      monitoraggio_parametri: "Monitoraggio dei parametri",
      dispositivi_indossabili: "Dispositivi indossabili suggeriti",
      annulla: "Annulla",
      modifica_percorso_di_cura: "Modifica percorso di cura",
      seleziona_percorso_di_cura: "Seleziona percorso di cura",
      modal_descrizione_modifica: "Modifica il percorso di cura del paziente.",
      modal_descrizione_selezione: "Seleziona il percorso di cura adeguato alle esigenze del paziente.",
      conferma_modifica: "Conferma Modifica",
      conferma_selezione: "Conferma Selezione",
      percorso_aggiornato: "Percorso di cura aggiornato",
      errore_lista_piani: "Non è stato possibile prelevare la lista dei piani disponibili.",
      errore_operazione: "Non è stato possibile completare l'operazione.",
      ogni_giorno: "ogni giorno"
    },
    EliminaProfilo: {
      titolo: "Elimina Profilo",
      sottotitolo: "Elimina definitivamente la tua utenza",
      bottone_elimina: "Elimina il mio profilo",
      domanda_conferma: "Sei sicuro di voler eliminare il tuo profilo?",
      testo_conferma: `
        Se elimini il tuo profilo non potrai più accedere alla piattaforma ed
        usufruire dei servizi offerti. <br />
        L'operazione è irreversibile, una volta confermata l'eliminazione non
        potrai più tornare indietro.
        `,
      title_conferma: "Conferma Operazione",
      ok_elimina: "Sì, elimina",
      annulla: "No, annulla"
    },
    AnagraficaComponent: {
      profilo: "Profilo",
      modifica: "Modifica",
      scegli_immagine: "Scegli immagine",
      elimina: "Elimina",
      carica_immagine: "Carica Immagine",
      titolo: "Titolo",
      titolo_placeholder: "Sig...",
      nome: "Nome*",
      nome_placeholder: "Nome...",
      cognome: "Cognome*",
      cognome_placeholder: "Cognome...",
      data_nascita: "Data di nascita*",
      genere: "Genere",
      uomo: "uomo",
      donna: "donna",
      codice_fiscale: "Codice fiscale*",
      codice_fiscale_placeholder: "Codice fiscale...",
      tessera_sanitaria: "Numero Tessera Sanitaria",
      tessera_sanitaria_placeholder: "Numero tessera...",
      nazione_nascita: "Nazione di nascita*",
      medico_base: "Medico di base",
      medico_base_placeholder: "Medico di base...",
      asl: "Asl/Asp/Ats di riferimento",
      scegli_asl: "Scegli azienda sanitaria locale",
      asl_placeholder: "Asl/Asp/Ats di riferimento...",
      id_albo: "ID Iscrizione Albo",
      id_albo_doppio: "ID Iscrizione Albo**",
      id_albo_placeholder: "ID ordine...",
      specializzazione: "Specializzazione",
      specializzazione_placeholder: "Specializzazione medica...",
      annulla: "Annulla",
      salva: "Salva",
      residenza: "Residenza",
      regione: "Regione*",
      regione_placeholder: "Regione...",
      seleziona_regione: "Seleziona Regione",
      provincia: "Provincia*",
      provincia_placeholder: "Provincia...",
      seleziona_provincia: "Seleziona Provincia",
      comune: "Comune*",
      comune_placeholder: "Comune...",
      seleziona_comune: "Seleziona Comune",
      indirizzo: "Indirizzo e numero civico*",
      indirizzo_placeholder: "Indirizzo...",
      cap: "CAP*",
      cap_placeholder: "CAP...",
      contatti: "Contatti",
      telefono: "Numero di telefono",
      telefono_placeholder: "Telefono...",
      telefono_domicilio: "Telefono Domicilio",
      telefono_domicilio_placeholder: "Telefono domicilio...",
      telefono_riserva: "Telefono di Riserva",
      telefono_riserva_placeholder: "Telefono di riserva...",
      torna_verifica: "torna alla verifica",
      conferma_eliminazione: "Conferma eliminazione",
      conferma: "Sì, Conferma",
      domanda_eliminazione_immagine: "Confermi di voler eliminare l'immagine del profilo?",
      immagine_eliminata_successo: "Immagine del profilo eliminata correttamente",
      errore_eliminazione: "Errore nell'eliminazione della nota",
      immagine_caricata_successo: "Immagine del profilo caricata correttamente",
      errore_caricamento: "Errore nel caricamento dell'immagine del profilo",
      telefono_non_valido: "Numero di telefono non valido",
      includere_sigla: "**Includere la sigla provincia",
      title_sig: "Sig.",
      title_sigra: "Sig.ra",
      title_dott: "Dott.",
      title_dottssa: "Dott.ssa",
      tipo_medici: "Medici",
      tipo_dentisti: "Dentisti",
      tipo_farmacisti: "Farmacisti",
      tipo_infermieri: "Infermieri",
      tipo_biologi: "Biologi"
    },
    SessionLengthSetter: {
      timeout_sessione: "Timeout Sessione",
      descrizione: "Stabilisci quando far scadere la sessione. A sessione scaduta, verrai automaticamente sloggato.",
      sessione_logout: "La sessione si chiude con il logout",
      sessione_scade: "La sessione scade dopo",
      minuti_inattivita: "minuti di inattività",
      annulla: "Annulla",
      salva_modifiche: "Salva Modifiche",
      successo: "Timeout sessione aggiornato con successo",
      errore: "Errore durante l'aggiornamento del timeout della sessione"
    },
    CompilaQuestionarioCittadino: {
      questionario_prenotazione: "Questionario per la prenotazione prevista per il",
      ore: "ore",
      consenso: "Ho letto l'informativa e do il mio consenso",
      procedi: "Procedi",
      operazione_completata: "Operazione completata.",
      vai_agenda: "Vai all'agenda",
      questionario_gia_compilato: "Hai già compilato il questionario.",
      errore_attivita: "Non è stato possibile recuperare le attività",
      questionario_inviato: "Questionario inviato correttamente.",
      errore_invio: "Non è stato possibile inviare il questionario"
    },
    FillScoreSurveyCittadino: {
      consenso: "Ho letto l'informativa e do il mio consenso",
      procedi: "Procedi",
      operazione_completata: "Operazione completata.",
      vai_agenda: "Vai all'agenda",
      questionario_gia_compilato: "Hai già compilato il questionario.",
      errore_attivita: "Non è stato possibile recuperare le attività",
      questionario_inviato: "Questionario inviato correttamente.",
      errore_invio: "Non è stato possibile inviare il questionario"
    },
    NuovaTerapiaAssistito: {
      pazienti: "Pazienti",
      nessun_paziente: "Nessun Paziente selezionato",
      profilo_sanitario: "Profilo sanitario",
      riepilogo: "Riepilogo",
      scarica_promemoria: "Scarica promemoria",
      torna_profilo: "Torna al profilo sanitario",
      errore_scaricamento: "Non è stato possibile scaricare il promemoria"
    },
    PianoTerapeuticoCittadino: {
      indietro: "Indietro",
      piano_terapeutico: "Piano terapeutico",
      caricato_in_data: "Caricato in data:",
      validita: "Validità:",
      stato: "Stato:",
      farmacia: "Farmacia",
      telefono: "Telefono",
      indirizzo: "Indirizzo",
      mostra_piano: "Mostra Piano Terapeutico",
      nascondi_piano: "Nascondi Piano Terapeutico",
      caricamento: "Caricamento in corso...",
      farmaci_previsti: "Farmaci previsti dal Piano Terapeutico",
      consegnato: "Consegnato",
      quantita: "Quantità:",
      pacchetti_programmati: "Pacchetti consegna programmati per il Piano Terapeutico",
      pacchetto: "Pacchetto",
      stato_pacchetto: "Stato pacchetto:",
      farmaci_contenuti: "Farmaci contenuti nel pacchetto",
      conf: "conf.",
      scadenza: "scad.",
      lotto: "lotto",
      piano_non_trovato: "Piano non trovato",
      errore_info: "non è stato possibile prelevare le informazioni richieste",
      scegli: "scegli...",
      attesa_autorizzazione: "In attesa di autorizzazione",
      classe_c: "classe C",
      no_ssn: "Non a carico SSN",
      autorizzato_classe_a: "autorizzato classe A",
      rimborsabile: "Autorizzato come rimborsabile",
      autorizzato_dpc: "autorizzato DPC",
      per_conto: "Autorizzato per la dispensazione per conto",
      autorizzato_dd: "autorizzato DD",
      distribuzione_diretta: "Autorizzato per la distribuzione diretta",
      etichetta: "Etichetta"
    },
    FamiliariView: {
      genere: "Genere",
      data_nascita: "Data di nascita",
      non_indicata: "Non indicata",
      vai_profilo_sanitario: "Vai al profilo sanitario",
      disabilita: "Disabilita",
      disabilita: "abilita",
      abilitata: "Abilitata",
      vuoi_abilitare: "Vuoi abilitare questo caregiver?",
      vuoi_disabilitare: "Vuoi disabilitare questo caregiver?",
      abilita_caregiver: "Abilita caregiver",
      disabilita_caregiver: "Disabilita caregiver",
      errore_recupero_informazioni: "Errore nel recupero delle informazioni",
      caregiver_abilitato: "Caregiver abilitato correttamente",
      errore_operazione: "Errore durante l'operazione",
      caregiver_disabilitato: "Caregiver disabilitato correttamente"
    },
    Routes: {
      cittadino_home: "Home Cittadino",
      familiari: "I tuoi familiari",
      appuntamenti: {
        prestazione: "Visite e Prestazioni",
        prodotto: "Farmaci",
        teleconsulto: "Teleconsulti"
      },
      agenda: "La tua agenda",
      il_tuo_consulto: "Il tuo consulto",
      circolo_di_cura: "Il tuo circolo di cura",
      sottoscrizioni_paziente: "Acquisti e Sottoscrizioni",
      progetti_cittadino: "Blog",
      profilo_sanitario: "Profilo sanitario",
      profilo_cittadino: "Dati Anagrafici",
      impostazioni: "Impostazioni",
      guida_cittadino: "Guida",
      completa_questionario: "Completa il questionario",
      score_questionario: "Completa il questionario",
      nuova_terapia_assistito: "Nuova terapia assistito",
      acquisto: "Acquisto",
      pagina_non_trovata: "Pagina non trovata",
      verifica_numero: "Verifica il tuo numero",
      verifica_email: "Verifica la tua email",
      teleconsulti: {
        tcemergenza: "Teleconsulto Rapido",
        pediatrico: "Teleconsulto Pediatrico",
        specialistico: "Teleconsulto Specialistico",
        teleconsulto: "Teleconsulti"
      }
    },
    NavigationCittadino: {
      prenotazioni: "Prenotazioni",
      visite: "Visite e Prestazioni",
      farmaci: "Farmaci",
      teleconsulti: "Teleconsulti",
      rapido: "Rapido",
      pediatrico: "Pediatrico",
      specialistico: "Specialistico",
      familiari: "Familiari",
      tutti: "Tutti",
      nuovo: "Nuovo",
      blog: "Blog",
      profilo_sanitario: "Profilo Sanitario",
      circolo: "Circolo di Cura",
      gestione: "Gestione",
      strumenti: "Strumenti",
      report: "Report",
      acquisti: "Acquisti",
      sottoscrizioni: "Sottoscrizioni",
      storico: "Storico",
      agenda: "Agenda",
      pazienti: "Pazienti",
      impostazioni: "Impostazioni",
      consulta: "Consulta",
      guida: "Guida",
      servizi: "SERVIZI",
      pagine: "PAGINE"
    },
    NotificationCenter: {
      title: "Notifiche",
      browserPermission: "Per ricevere notifiche è necessario autorizzarne la ricezione sul browser.",
      noNotifications: "Nessuna nuova notifica."
    },
    CallSupportModal: {
      chiama: "Chiama il numero verde",
      chiama_per_prenotare: "Per prenotare chiama il numero verde",
      operatori: "I nostri operatori sono disponibili dal lunedì al venerdì dalle ore 9:00 alle ore 18:00"
    },
    PopupModal: {
      procedi: "Procedi",
      errore_invito: "non è stato possibile invitare il medico",
      success_grazie: "grazie per la tua risposta",
      errore_risposta: "non è stato possibile inviare la risposta"
    },
    SomministraCustomTeleconsultoSurvey: {
      compila_questionario: "Compila il questionario per il Teleconsulto",
      compilazione_obbligatoria: "(la compilazione è obbligatoria)",
      consenso_informativa: "Ho letto l'informativa e do il mio consenso",
      procedi: "Procedi",
      questionario_gia_compilato: "Hai già compilato il questionario.",
      vai_agenda: "Vai all'agenda",
      errore_recupero_attivita: "Non è stato possibile recuperare le attività",
      successo_questionario: "Questionario inviato correttamente.",
      errore_questionario: "Non è stato possibile inviare il questionario"
    },
    FillCustomTeleconsultoSurvey: {
      ok_procedi: "Ok, Procedi",
      placeholder_scrivi: "Scrivi qui",
      torna_indietro: "Torna indietro",
      procedi: "Procedi",
      salta: "Salta",
      salva_immagine: "Salva Immagine"
    },
    FreeSubscription: {
      descrizione: "Sottoscrizione gratuita",
      dettaglio: '<p class="m-0">Prenotazione veloce per visite e prestazioni: 10€ </p><p class="m-0">Servizio di Televisita o Teleconsulto: 10€</p><p class="m-0">Prenotazione farmaci: 4€</p>'
    },
    app: {
      partita_iva: "Partita IVA:",
      termini_condizioni: "Termini e condizioni",
      informativa_privacy: "Informativa Privacy",
      note_rilascio: "Note di rilascio"
    },
    nexi: {
      esito: {
        OK: "Transazione completata correttamente",
        KO: "Transazione fallita",
        ANNULLO: "Transazione annullata",
        ERRORE: "Errore transazione",
        PEN: "Transazione pendente",
      },
      messaggi: {
        "Message OK": "Transazione autorizzata.",
        "Controllo CF": "Il PAN della carta è già associato ad altro codice Fiscale.",
        "Controllo PAN": "Al codice Fiscale indicato sono già associate un numero massimo di carta.",
        "Controllo BLACKLIST": "Transazione bloccata per regole blacklist.",
        "Controllo CF/PAN": "Errore sul controllo tra Codice Fiscale e PAN.",
        "Auth. Denied": "Transazione non autorizzata.",
        "Impossibile eseguire la Post di Notifica": "Annullamento per errore di notifica server to server.",
        "3D Secure annullato da utente": "Autenticazione 3D-Secure non completata o annullata.",
        "Carta non autorizzata causa applicazione regole BIN table": "Carta non autorizzata per regole BIN table.",
        "Problema 3DSecure": "Problema durante l'autenticazione 3D-Secure.",
        "expired card": "Carta scaduta o merchant non abilitato.",
        "Invalid merchant": "Merchant non abilitato o revocato.",
        "transaction not permitted": "Transazione non permessa.",
        "not sufficient funds": "Fondi insufficienti sulla carta.",
        "Technical problem": "Problema tecnico nei sistemi autorizzativi.",
        "Host not found": "Sistema autorizzativo non disponibile.",
        "Transazione chiusa per time-out": "Transazione chiusa per superamento del tempo.",
        "Controllo PAN/CONTRATTO": "PAN presente su altro contratto.",
        "Numero di tentativi di retry esaurito": "Numero massimo di tentativi superato.",
        "soft decline": "Richiesta autenticazione forte (SCA). Riprova.",
        "Transazione avvenuta correttamente": "Transazione completata con successo.",
      },
    },
    aggiornata_successo: "Anagrafica aggiornata con successo!",
    common: {
      scegli: "Scegli"
    },
    PatientAnamnesi: {
      salva: "Salva",
      annulla: "Annulla",
      titoloConfermaEliminazione: "Conferma eliminazione",
      siProcedi: "Sì, procedi",
      noAnnulla: "No, annulla",
      testoConfermaEliminazione: "Sei sicuro di voler eliminare la nota",
      labelAllergie: "Allergie note, reazioni allergiche pregresse",
      labelEventiPregressi: "Eventi pregressi",
      labelOspedalizzazioni: "Interventi chirurgici, ospedalizzazioni",
      labelEventiAvversi: "Reazioni avverse ai farmaci",
      labelCondizioniNote: "Condizioni note in famiglia",
      nuovaNota: "Nuova nota {categoria}",
      nota: "Nota",
      erroreCaricamentoNote: "Errore durante il caricamento delle note",
      notaAggiornata: "Nota aggiornata correttamente",
      erroreAggiornamentoNota: "Errore durante l'aggiornamento della nota",
      notaCreata: "Nota creata correttamente",
      erroreCreazioneNota: "Errore durante la creazione della nota",
      notaEliminata: "Nota eliminata correttamente",
      erroreEliminazioneNota: "Errore durante l'eliminazione della nota",
      allergiePlaceholder: "Allergie alimentari, ambientali, tipo e gravità di reazioni allergiche pregresse...",
      pregressoPlaceholder: "Particolari eventi pregressi da segnalare...",
      ospedalizzazionePlaceholder: "Ospedalizzazioni precedenti, traumi importanti, interventi chirurgici...",
      eventiAvversiPlaceholder: "Effetti indesiderati, reazioni avverse a farmaci..."
    },
    uploader: {
      placeholder: "Scegli file...",
      carica: "Carica",
      caricamento_completato: "Caricamento completato",
      anteprima_pdf_titolo: "Visualizza PDF e procedi al caricamento",
      anteprima_immagine_titolo: "Visualizza immagine e procedi al caricamento",
      annulla_caricamento: "Annulla il caricamento del file",
      conferma_caricamento: "Conferma il caricamento del file",
      caricamento_in_corso: "Caricamento in corso...",
      anteprima_immagine_alt: "Anteprima immagine"
    },
    zip_code: "CAP",
    sono_cittadino_residente: "Sono un cittadino residente in Italia con Codice Fiscale",
    SignedDocumentsList: {
      title: "Documenti firmati",
      signedOn: "Firmato il {date}",
      download: "Scarica",
      downloadError: "Errore nel download del documento"
    },
    CompilazioneSessione: {
      torna_alle_sessioni: "Torna alle Sessioni",
      scheda_paziente: "Scheda Paziente",
      seleziona_paziente: "Seleziona il paziente a cui si intende somministrare la sessione:",
      registra_paziente: "Registra Paziente",
      paziente_selezionato: "Paziente selezionato:",
      nome_cognome: "NOME E COGNOME",
      codice_fiscale: "CODICE FISCALE",
      annulla_selezione: "Annulla selezione",
      avvia_sessione: "Avvia sessione",
      inserisci_pseudonimo: "Inserisci pseudonimo*:",
      conferma: "Conferma",
      paziente_label: "Paziente:",
      attenzione: "Attenzione!",
      informativa: "Informativa",
      consenso: "Ho letto l'informativa e do il mio consenso",
      procedi: "Procedi",
      operazione_completata: "Operazione completata.",
      operazione_non_consentita: "Operazione non consentita.",
      cf_mancante: "Per le sessioni in chiaro è richiesto il Codice Fiscale del paziente.",
      errore_caricamento_sessione: "Non è stato possibile recuperare i dati della sessione",
      errore_avvio_sessione: "Non è stato possibile avviare la sessione",
      errore_caricamento_questionario: "Non è stato possibile recuperare il questionario",
      errore_invio_questionario: "Non è stato possibile inviare il questionario",
      sessione_completata: "Sessione completata",
      errore_recupero_utente: "Non è stato possibile recuperare le informazioni dell'utente",
      necessaria_verifica_secondario: "Poiché il paziente non possiede un indirizzo email, è necessario che venga verificato anche il numero di telefono di riserva.",
      necessaria_verifica_numero: "Per proseguire è necessario che venga verificato il numero del paziente selezionato.",
      avviso_cancellazione_mezzanotte: "La sessione non è stata firmata. Se non procedi alla firma entro {days} giorni, verrà cancellata.",
      chiudi: "Chiudi",
      riepilogo_compilazioni: "Riepilogo compilazioni della sessione",
      tab_questionario: "Questionario",
      tab_data: "Data",
      tab_punteggio: "Punteggio",
      tab_azioni: "Azioni",
      visualizza_dettaglio_compilazione: "Visualizza dettaglio compilazione",
      nessuna_compilazione: "Nessuna compilazione disponibile",
      otp_verifica_titolo: "Verifica OTP",
      otp_verifica_testo: "Invia il codice OTP al paziente per validare la compilazione.",
      invia_otp: "Invia OTP"
    },
    RiepilogoCompilazioniTable: {
      tab_questionario: "Questionario",
      tab_data: "Data",
      tab_punteggio: "Punteggio",
      tab_azioni: "Azioni",
      visualizza_dettaglio_compilazione: "Visualizza dettaglio compilazione",
      nessuna_compilazione: "Nessuna compilazione disponibile"
    },
    HomeSessioni: {
      sessione_creata_successo: "Sessione creata con successo",
      sessione_avviata_successo: "Sessione avviata con successo",
      sessione_eliminata_successo: "Sessione eliminata con successo",
      errore_caricamento_sessioni: "Errore durante il caricamento delle sessioni",
      errore_caricamento_attivita: "Errore durante il caricamento delle attività",
      nome_questionario_obbligatori: "Nome sessione e almeno un questionario sono obbligatori",
      almeno_due_questionari_obbligatori: "Nome sessione e almeno due questionari sono obbligatori",
      errore_creazione_sessione: "Errore durante la creazione della sessione",
      errore_avvio_sessione: "Errore durante l'avvio della sessione",
      errore_eliminazione_sessione: "Errore durante l'eliminazione della sessione",
      nessuna_sessione_trovata: "Nessuna sessione trovata",
      crea_nuova_sessione: "nuova sessione",
      titolo_crea_nuova_sessione: "Nuova sessione",
      nome_sessione_asterisco: "Nome Sessione *",
      inserisci_nome_sessione: "Inserisci nome sessione",
      descrizione: "Descrizione",
      descrizione_opzionale: "Descrizione opzionale",
      questionari_asterisco: "Questionari *",
      questionari_disponibili: "Questionari Disponibili",
      cerca_questionari: "Cerca questionari",
      placeholder_cerca_questionari: "Digita per filtrare per nome",
      questionari_selezionati: "Questionari Selezionati",
      nessun_questionario_selezionato: "Nessun questionario selezionato",
      seleziona_questionari_per_iniziare: "Seleziona i questionari tra quelli disponibili per comporre la sessione",
      caricamento_attivita: "Caricamento attività...",
      nessun_questionario_disponibile: "Nessun questionario disponibile",
      attivo: "Attivo",
      inattivo: "Inattivo",
      questionari_sessione_ordinati: "Questionari della sessione",
      nessun_questionario_configurato: "Nessun questionario configurato per questa sessione.",
      visualizza_questionari: "Visualizza questionari",
      nessuna_descrizione: "Nessuna descrizione",
      visualizza_dettaglio: "Visualizza dettagli",
      richiede_firma_operatore: "Richiede firma operatore",
      informazioni_sessione: "Informazioni sessione",
      ruoli_consentiti: "Ruoli consentiti",
      somministrazione_consentita_ai_ruoli: "Somministrazione consentita ai ruoli",
      firma_operatore_si: "Sì",
      firma_operatore_no: "No",
      giorni_firma_asterisco: "Giorni per firma *",
      placeholder_giorni_firma: "Inserisci giorni (1-15)",
      aiuto_giorni_firma: "Numero di giorni entro cui l'operatore deve firmare la sessione; superata la scadenza la sessione viene eliminata. Valori consentiti 1–15; predefinito 3.",
      seleziona_numero_giorni_firma: "Seleziona il numero di giorni per la firma",
      somministra_sessione: "Somministra sessione",
      permesso_somministra_mancante: "Permesso somministrazione mancante",
      ruoli_non_autorizzati_msg: "Non hai i ruoli richiesti: {ruoli}",
      ruoli_non_autorizzati_generico: "Non hai i ruoli richiesti per somministrare questa sessione",
      elimina_sessione: "Elimina sessione",
      creata_da: "Creata da",
      eliminazione_non_consentita_sessione_somministrata: "Impossibile eliminare: esiste almeno una compilazione per questa sessione",
      conferma_eliminazione_sessione: "Sei sicuro di voler eliminare la sessione \"{nome}\"?",
      nessuna_compilazione_associata: "Non ci sono compilazioni associate a questa sessione.",
      espandi_dettagli: "Espandi dettagli questionari",
      comprimi_dettagli: "Comprimi dettagli questionari",
      cerca_sessione: "Cerca sessione per nome",
      seleziona_elementi_per_pagina: "Seleziona numero di elementi per pagina",
      filtra_per_stato: "Filtra sessioni per stato",
      elementi_per_pagina: "Elementi per pagina",
      stato_filtro: "Filtro stato",
      caricamento_sessioni: "Caricamento sessioni in corso",
      lista_sessioni: "Lista delle sessioni",
      dettagli_questionari: "Dettagli questionari della sessione",
      posizione_questionario: "Questionario {numero}: {nome}",
      stato_sessione: "Stato: {stato}",
      questionari_totali: "{totale} questionari trovati",
      nome: "Nome",
      descrizione: "Descrizione", 
      tipologia: "Tipologia",
      somministrati: "Somministrati",
      stato: "Stato",
      azioni: "Azioni",
      tutti_stati: "Tutti gli stati",
      in_attesa: "In attesa",
      in_corso: "In corso",
      completate: "Completate",
      annullate: "Annullate",
      filtri_e_paginazione: "Controlli filtri e paginazione",
      tipo_questionari_asterisco: "Tipo Questionari *",
      anonimo: "Anonimo",
      pseudoanonimo: "Pseudoanonimo", 
      in_chiaro: "In Chiaro",
      tutti_operatori_autorizzati: "Tutti gli operatori sono autorizzati",
      si: "Sì",
      no_solo_ruoli_specifici: "No, solo ruoli specifici",
      ruoli_consentiti_label: "Seleziona ruoli consentiti",
      rimuovi_ruolo: "Rimuovi ruolo {name}",
      questionari_in_chiaro: "Questionari in Chiaro",
      questionari_anonimi: "Questionari Anonimi",
      questionari_pseudoanonimi: "Questionari Pseudoanonimi",
      tipo_in_chiaro_desc: "I dati dei questionari sono collegati direttamente all'identità del paziente",
      tipo_anonimo_desc: "I dati dei questionari non sono collegabili a nessuna identità specifica",
      tipo_pseudoanonimo_desc: "I dati dei questionari sono collegati tramite un codice anonimo",
      questionari: "Questionari",
      nessuna_attivita_tipo_selezionato: "Nessuna attività disponibile per il tipo di questionario selezionato",
      numero_questionari_selezionati: "{count} questionari selezionati",
      lista_questionari_ordinabili: "Lista questionari ordinabili tramite trascinamento",
      questionario_posizione: "Questionario {numero}: {nome}",
      rimuovi_questionario: "Rimuovi questionario {nome}",
      modifica_sessione: "Modifica sessione",
      titolo_modifica_sessione: "Modifica sessione",
      modifica_sessione_apri: "Apri modifica sessione",
      sessione_modificata_successo: "Sessione modificata con successo",
      errore_modifica_sessione: "Errore durante la modifica della sessione",
      lista_attivita_questionari: "Lista attività con questionari disponibili",
      attivita_con_questionari: "Attività {nome} con questionari",
      espandi_attivita: "Espandi attività {nome} - {stato}",
      espansa: "espansa",
      chiusa: "chiusa",
      questionari_attivita: "Questionari disponibili per attività {nome}",
      questionario_item: "Questionario: {nome}",
      aggiungi_questionario: "Aggiungi questionario {nome} alla sessione",
      visualizza_dettaglio_compilazione: "Visualizza dettaglio compilazioni"
    },
    PatientSurveySessions: {
      titolo: "Sessioni",
      nessuna_descrizione: "Nessuna descrizione",
      somministra_sessione: "Somministra sessione",
      nessuna_sessione: "Nessuna sessione disponibile",
      nuova_sessione: "nuova sessione",
      seleziona_sessione: "Seleziona sessione",
      procedi: "Procedi",
      cerca_sessione: "Cerca sessione",
      filtro_in_chiaro: "Solo in chiaro",
      filtro_attive: "Solo attive",
      nessun_risultato: "Nessun risultato",
      permesso_somministra_mancante: "Permesso somministrazione mancante",
      ruoli_non_autorizzati_generico: "Non hai i ruoli richiesti per somministrare questa sessione",
      ruoli_non_autorizzati_msg: "Non hai i ruoli richiesti: {ruoli}",
      cf_mancante: "Per le sessioni in chiaro è richiesto il Codice Fiscale del paziente.",
      in_chiaro: "In Chiaro",
      pseudoanonimo: "Pseudoanonimo",
      anonimo: "Anonimo",
      item_position: "Elemento {number}: {name}",
      errore_caricamento_sessioni: "Errore durante il caricamento delle sessioni",
      lista_sessioni: "Lista delle sessioni"
    },
    UserLastSessions: {
      titolo: "Ultime sessioni",
      nuova_sessione: "somministra nuova sessione",
      vedi: "Vedi",
      vedi_dettaglio_sessione: "Vedi dettaglio sessione",
      vedi_storico_sessioni: "Vedi storico sessioni",
      nessuna_sessione: "Nessuna sessione disponibile",
      dettaglio_questionario: "Dettaglio questionario",
      chiudi: "Chiudi",
      dettaglio_sessione: "Dettaglio sessione",
      questionari_nella_sessione: "Questionari nella sessione",
      cf_mancante: "Per le sessioni in chiaro è richiesto il Codice Fiscale del paziente.",
      seleziona_sessione: "Seleziona sessione",
      procedi: "Procedi",
      cerca_sessione: "Cerca sessione",
      nessun_risultato: "Nessun risultato"
    },
    DettaglioSessioneModal: {
      titolo_dettaglio_sessione: "Dettaglio Sessione",
      contenuto_dettaglio_sessione: "Contenuto dettaglio sessione",
      informazioni_sessione: "Informazioni sessione",
      questionari_configurati: "questionari configurati",
      stato_sessione: "Stato: {stato}",
      istanze_compilazione: "Istanze di compilazione",
      compilazioni_sessione: "Compilazioni della Sessione",
      totale_compilazioni: "{totale} compilazioni totali",
      nessuna_compilazione: "Nessuna compilazione trovata",
      lista_istanze: "Lista istanze di compilazione",
      caricamento_istanze: "Caricamento istanze in corso",
      paziente: "Paziente",
      stato: "Stato",
      data_inizio: "Data Inizio",
      data_completamento: "Data Completamento",
      cf: "Codice Fiscale",
      progresso: "Progresso",
      azioni: "Azioni",
      in_corso: "In corso",
      progresso_compilazione: "Progresso: {percentuale}%",
      visualizza_dettaglio_compilazione: "Visualizza dettaglio compilazione",
      errore_caricamento_sessione: "Errore durante il caricamento dei dettagli della sessione",
      errore_caricamento_dettagli: "Errore durante il caricamento dei dettagli",
      chiudi_dettagli: "Chiudi dettagli",
      paziente_anonimo: "Paziente anonimo",
      istanza_iniziata: "Iniziata",
      istanza_in_corso: "In corso",
      istanza_completata: "Completata",
      istanza_abbandonata: "Abbandonata",
      stato_in_attesa: "In attesa",
      stato_in_corso: "In corso",
      stato_completate: "Completate",
      stato_annullate: "Annullate",
      funzione_in_sviluppo: "Funzione in fase di sviluppo"
    },
    DettaglioSessione: {
      sessioni: "Sessioni",
      titolo_compilazioni_sessione: "Compilazioni della sessione",
      titolo_dettaglio_sessione: "Dettaglio Sessione",
      torna_alle_sessioni: "Torna alle Sessioni",
      sessione_non_trovata: "Sessione non trovata",
      nessuna_compilazione: "Nessuna compilazione trovata",
      paziente: "Paziente",
      stato: "Stato",
      cf: "Codice Fiscale",
      questionario: "Questionario",
      data: "Data",
      punteggio: "Punteggio",
      data_inizio: "Data Inizio",
      data_completamento: "Data Completamento",
      progresso: "Progresso",
      azioni: "Azioni",
      filtro_cf: "Codice Fiscale",
      elementi_per_pagina: "Elementi per pagina",
      seleziona_elementi_per_pagina: "Seleziona numero di elementi per pagina",
      cf_solo_in_chiaro: "Filtro attivo solo per sessioni in chiaro",
      chiudi: "Chiudi",
      in_corso: "In corso",
      progresso_compilazione: "Progresso: {percentuale}%",
      visualizza_dettaglio_compilazione: "Visualizza dettaglio compilazione",
      visualizza_compilazioni_sessione: "Visualizza compilazioni della sessione",
      errore_caricamento_sessione: "Errore durante il caricamento dei dettagli della sessione",
      errore_caricamento_dettagli: "Errore durante il caricamento dei dettagli",
      paziente_anonimo: "Paziente anonimo",
      istanza_iniziata: "Iniziata",
      istanza_in_corso: "In corso",
      istanza_completata: "Completata",
      istanza_abbandonata: "Abbandonata",
      stato_in_attesa: "In attesa",
      stato_in_corso: "In corso",
      stato_completate: "Completate",
      stato_annullate: "Annullate",
      funzione_in_sviluppo: "Funzione in fase di sviluppo"
    },
  },
  en: {
    AdminOperatorsList: {
      abilita_tooltip: "Enable account",
      abilita_utenza_titolo: "Enable operator account",
      abilita_utenza_testo: "Do you confirm enabling this account?",
      nome: "Name",
      email: "Email",
      ruolo: "Role",
      operatore: "operator",
      abilitazione_successo: "Account enabled",
      abilitazione_errore: "Error while enabling the account"
    },
    ArchivioSanitarioComponent: {
      aria_tablist_label: "Health profile sections",
      tab_parametri: "Parameters",
      tab_esami: "Exams",
      tab_referti: "Reports",
      tab_altri_file: "Other files",
      tab_questionari: "Surveys",
      tab_sessioni: "Sessions",
      aria_selector_parametri: "Select Parameters section",
      aria_selector_esami: "Select Exams section",
      aria_selector_referti: "Select Reports section",
      aria_selector_altri_file: "Select Other files section",
      aria_selector_scores: "Select Scores section",
      aria_selector_questionari: "Select Surveys section",
      aria_selector_sessioni: "Select Sessions section",
    },
    SessionDetailModal: {
      dettaglio_sessione: "Session detail",
      questionari_nella_sessione: "Surveys in the session",
      vedi: "View",
    },
    SchedaPaziente: {
      archivio_sanitario: "Health archive",
      apri_archivio_sanitario: "Open health archive",
    },
    PatientArchive: {
      titolo: "Health archive",
      carica_documento: "Upload document",
      annulla_caricamento: "Cancel upload",
      caricamento_contenuti: "Loading content...",
      nessun_documento: "No documents available",
      nome_documento: "Document",
      data_caricamento: "Upload date",
      azioni: "Actions",
      archivia: "Archive",
      ripristina: "Restore",
      elimina: "Delete",
    },
    PatientArchiveCittadino: {
      titolo: "Health archive",
      nuovo_documento: "New file",
      modal_upload_titolo: "Upload new document",
      visualizza: "View",
      scarica: "Download",
      elimina_risorsa: "Delete resource",
      conferma_eliminazione_titolo: "Confirm deletion",
      conferma_eliminazione_testo: "Are you sure you want to permanently delete this document?",
      nessun_documento: "No documents available",
      caricato_da: "Uploaded by",
      aria_visualizza: "View {name}",
      aria_scarica: "Download {name}",
      aria_elimina: "Delete {name}"
    },
    RiepilogoCompilazioniTable: {
      tab_questionario: "Survey",
      tab_data: "Date",
      tab_punteggio: "Score",
      tab_azioni: "Actions",
      visualizza_dettaglio_compilazione: "View compilation details",
      nessuna_compilazione: "No compilations available"
    },
    UserLastSessions: {
      titolo: "Latest sessions",
      nuova_sessione: "New session",
      vedi: "View",
      vedi_dettaglio_sessione: "View session details",
      vedi_storico_sessioni: "View sessions history",
      nessuna_sessione: "No sessions available",
      dettaglio_questionario: "Questionnaire detail",
      chiudi: "Close",
      dettaglio_sessione: "Session detail",
      questionari_nella_sessione: "Questionnaires in the session",
      cf_mancante: "A Tax Code is required for clear-type sessions.",
      seleziona_sessione: "Select session",
      procedi: "Proceed",
      cerca_sessione: "Search session",
      nessun_risultato: "No results"
    },
    welcome: "Welcome",
    logout: "Logout",
    profile: "Profile",
    hello: "Hello",
    richieste_prenotazione: "Booking requests",
    esci: "Logout",
    seleziona_lingua: "Select language",
    non_verificato_email: "You have not yet verified your email address",
    tooltip_email: "To use the platform, it is necessary to verify your email address",
    non_verificato_telefono: "You have not yet verified your phone number",
    tooltip_telefono: "To use the platform, it is necessary to verify your phone number",
    non_compilata_anagrafica: "You have not yet completed your personal information",
    tooltip_anagrafica: "To fully benefit from all services provided by this platform, it is necessary to complete your personal information",
    titolo_informativa: "Terms and Conditions and Privacy Policy",
    testo_informativa:
      "To complete the registration, it is necessary to confirm that you have read the",
    condizioni_generali: "general terms and conditions",
    informativa_privacy: "Privacy Policy",
    ho_letto_privacy: "I have read and accept the",
    non_accetto: "I do not accept",
    ho_letto_termini: "I have read and accept the",
    termini_uso: "Terms and Conditions of Service",
    accetto_esplicitamente:
      "Pursuant to Article 1341 and following of the Civil Code, I expressly accept the provisions of Articles 2, 7, 8, 10, 12 of the present",
    titolo_marketing: "Authorization for commercial communications",
    acconsento_marketing:
      "I consent to receive commercial communications for promotional purposes as per the",
    conferma_scelte: "Confirm my choices",
    registrati: "Register",
    numero_supporto: "800.770.272", // keep the same if it's a phone number
    placeholder_email: "email@example.com",
    placeholder_password: "Password",
    dimenticato_password: "I forgot my password",
    credenziali_errate: "Invalid credentials.",
    accedi: "Login",
    recupera_password: "Recover password",
    testo_recupera_password: "Enter the email address used during registration.",
    placeholder_inserisci_email: "Enter email...",
    alert_demo_cie_spid: "Login with CIE and SPID not available in demo environment",
    mail_inviata: "Email sent! Check your inbox.",
    email_non_valida: "Invalid email address",
    invia: "Send",
    hai_bisogno_aiuto: "Need help?",
    contattaci: "Contact us",
    indietro: "Back",
    registrazione: "Registration",
    registrati_descrizione: "Sign up for free on our platform to enter the world of ConCura and receive a personalized, fast, and always-on service designed to help you take care of your health.",
    numero_supporto: "800.770.272",
    step: "Step",
    sono_cittadino: "I am a citizen",
    sono_operatore: "I am a healthcare professional",
    consulta_informativa_privacy: "View Privacy Policy",
    utenza_disabilitata: "Account Disabled",
    messaggio_utenza_disabilitata: "Your account has been disabled",
    reimposta_password_titolo: "Reset your password",
    reimposta_password_descrizione_1: "The new password must contain at least 8 characters, including a number, an uppercase letter, a lowercase letter and a",
    reimposta_password_carattere_speciale: "special character",
    tooltip_password_special_chars: "You must use at least one character among ! @ # $ % ^ & * ) ( + = . _ -",
    placeholder_nuova_password: "Password...",
    placeholder_conferma_password: "Confirm password...",
    credenziali_errate: "Invalid credentials.",
    salva_nuova_password: "Save new password",
  manuali_uso: "User Manuals",
  video_tutorial: "Tutorial Videos",
  scarica_versione_aggiornata: "Download the updated version",
  scarica_versione_inglese: "Download the English version",
  ultima_versione: "Latest version",
  altre_versioni: "Other versions",
  nessun_manuale: "No manuals available",
  scarica_selezionato: "Download selected version",
    recupera_password: "Recover your password",
    mail_inviata_controlla: "Email sent! Check your inbox.",
    non_ho_ricevuto_email: "I haven't received the email",
    inserisci_email_registrazione: "Enter the email address used during registration.",
    placeholder_email: "email@ ...",
    annulla: "Cancel",
    chiudi: "Close",
    invia: "Send",
    non_ricordo_email: "I don't remember the email address",
    sms_inviato_cf: "An SMS with the password reset link has been sent to the phone number associated with this tax code. Please wait a moment.",
    non_ho_ricevuto_sms: "I haven't received the SMS",
    inserisci_codice_fiscale: "Enter your tax code.",
    placeholder_cf: "TAX CODE...",
    sms_inviato_telefono_riserva: "An SMS with the reset link was sent to the backup number associated with this tax code, if set. Please wait a moment.",
    nessun_link_contatta_assistenza: "If it wasn't set or you didn't receive any link and couldn't access the system,",
    invia_richiesta_supporto: "send a support request",
    torna_login: "Back to login page",
    invia_numero_riserva: "Send to backup number",
    registrazione_successo: "Registration completed successfully!",
    benvenuto: "Welcome",
    email_confermata_successo: "Thank you for confirming your email address.",
    vai_homepage: "Go to Homepage",
    email_gia_verificata: "Email already verified.",
    email_gia_verificata_descrizione: "You have already confirmed your email address. If not yet done, proceed with filling out your personal information sheet.",
    vai_scheda_anagrafica: "Personal data form",
    conferma_email: "Confirm your email",
    link_non_valido: "The link used is no longer valid.",
    email_non_ricevuta_controlla_spam: "If you haven't received the confirmation email, check your spam folder or",
    richiedi_nuova_mail: "request a new confirmation email",
    invia_nuova_mail: "Send new email",
    verifica_numero_telefono: "Verify your phone number",
    verifica_istruzioni_1: "To use the platform, you must complete the registration by verifying the provided phone number.",
    verifica_istruzioni_link: "Check the number provided.",
    verifica_istruzioni_2: 'Click on "send verification code" to receive an OTP via SMS.',
    inserisci_numero_telefono: "Enter your phone number",
    inserisci_istruzioni: "To use the platform, you need to enter and verify your phone number.",
    etichetta_numero_telefono: "Phone number:",
    placeholder_numero: "1234...",
    salva_numero: "Save number",
    invia_codice_verifica: "Send verification code",
    verifica_fuori_piattaforma: "Verify phone number outside the platform",
    verifica_otp: "OTP Verification",
    codice_verificato: "Code successfully verified!",
    prosegui_istruzioni: "Thanks for completing the process. Click 'Close' to proceed.",
    sms_inviato: "We have sent the verification code via SMS to the number {numero}",
    inserisci_codice: "Enter the numeric code received via SMS:",
    otp_status_0: "Verification code sent",
    otp_status_minus1: "System error",
    otp_status_1: "Code successfully verified",
    otp_status_2: "Incorrect code",
    otp_status_3: "Code expired",
    otp_status_4: "Code already verified",
    otp_status_5: "Code deleted",
    codice_scade: "The code will expire in",
    secondi: "seconds",
    codice_scaduto: "Code expired",
    non_ricevuto: "Didn't receive the code?",
    invia_nuovo_codice: "Send new code",
    alternativa: "Alternatively,",
    invia_otp_riserva: "send OTP to backup number (if available).",
    chiudi: "Close",
    verifica: "Verify",
    verifica_non_completata: "Verification could not be completed.",
    verifica_controlla_assistenza: "Check that the contact number in the profile is correct. If the problem persists, contact support.",
    verifica_manuale: "Manual Verification",
    manuale_istruzioni: "Please call the user to verify their contact.",
    chiama: "Call",
    annulla: "Cancel",
    contrassegna_verificato: "Mark number as verified",
    non_possibile_effettuare_procedura: "The procedure could not be completed.",
    numero_verificato_successo: "Number successfully verified.",
    errore_verifica_numero: "An error occurred during phone number verification.",
    vai_homepage: "Go to Homepage",
    errore_salvataggio_pagamento: "Payment saving failed. Please check in your private area.",
    effettua_login: "Please log in",
    richieste_prenotazione: "Booking requests",
    visite_prestazioni: "Visits and procedures",
    farmaci: "Medications",
    teleconsulti: "Teleconsultations",
    teleconsulto_rapido: "Quick teleconsultation",
    errore_recupero_prenotazioni: "Unable to retrieve recent bookings",
    buongiorno: "Good morning",
    buon_pomeriggio: "Good afternoon",
    buona_sera: "Good evening",
    attesa_pagamento: "waiting for payment",
    vai_alla_prenotazione: "Go to booking",
    vedi_dettagli_prenotazione: "View booking details",
    nessuna_prenotazione_oggi: "No bookings for today.",
    vedi_tutte_sottoscrizioni: "View all subscriptions",
    piano_attivo: "Active plan",
    durata_minima: "Minimum duration",
    si_rinnova_il: "Renews on",
    scadra_il: "Expires on",
    leggi_di_piu: "Read more",
    cosa_prevede_sottoscrizione: "What's included in your subscription",
    prestazioni_disponibili: "Available services",
    ordine_farmaci_disponibili: "Available medication orders",
    effettua_upgrade_sottoscrizione: "Upgrade your subscription",
    gratis: "FREE",
    errore_operazione: "Operation could not be completed.",
    piani: "Plans",
    mese: "month",
    anno: "year",
    subscriptionDetail: {
      base: "Basic Subscriptions",
      advanced: "Advanced Subscriptions",
      monitoring: "Monitoring Subscriptions"
    },
    successUpdate: "Personal information updated successfully!",
    convenzioni: "Affiliations",
    richiedi_voucher: "Request voucher",
    richiedi_teleconsulto_rapido: "Request Quick Teleconsultation",
    teleconsulto_rapido: "Quick Teleconsultation",
    medico_contatto_entro_60_minuti: "A doctor will contact you within 60 minutes of the request.",
    durata_massima_15_minuti: "The Quick Teleconsultation lasts a maximum of 15 minutes.",
    motivo_richiesta: "Reason for request",
    scrivi_motivo: "Write the reason",
    costo_prestazione: "Service cost",
    iva_inclusa: "VAT included",
    iva_esclusa: "+ VAT",
    riprova: "Retry",
    annulla: "Cancel",
    rimuovi: "Remove",
    completa_acquisto: "Complete Purchase",
    nessun_operatore_disponibile: "No operators available at the moment. Please try again later.",
    in_attesa_di_risposta: "Waiting for response",
    medico_presto_disponibile: "A doctor will soon handle your request",
    rimani_collegato: "Stay connected",
    programmato_ore: "Scheduled at",
    avvia_ora: "Start now",
    clicca_per_pagamento_nexi: "Click on 'Complete Purchase' to start the secure Nexi payment session and finalize your purchase.",
    clicca_per_privacy_nexi: "Click",
    carte_accettate: "Accepted cards:",
    errore_pagamento_link: "Unable to initialize payment. Please contact support.",
    errore_salvataggio_pagamento_semplice: "Payment saving error",
    link_pagamento_inviato: "A payment link has been sent to your email address.",
    completa_acquisto: "Complete Purchase",
    link_pagamento_inviato: "A payment link has been sent to your email address.",
    errore_pagamento_link: "Unable to initialize the payment. Please contact support.",
    errore_salvataggio_pagamento_semplice: "Payment saving error",
    non_puoi_lasciare_pagina_pagamento: "You can't leave this page during the payment process.",
    richiedi_tc_pediatrico: "Request Pediatric Teleconsultation",
    teleconsulto_pediatrico: "Pediatric Teleconsultation",
    tc_pediatrico_descrizione_1: "A doctor will contact you within 60 minutes of the request.",
    tc_pediatrico_descrizione_2: "The Pediatric Teleconsultation has a maximum duration of 15 minutes.",
    scegli_familiare: "Choose a family member (optional)",
    motivo_richiesta: "Reason for request",
    placeholder_motivo: "Enter the reason",
    costo_prestazione: "Service cost",
    iva_inclusa: "VAT included",
    piu_iva: "+ VAT {percentuale} %",
    in_attesa_risposta: "Waiting for response",
    tc_medico_in_carico: "A doctor will soon take charge of your request",
    rimani_collegato: "Stay connected",
    programmato_per_ore: "Scheduled for",
    avvia_ora: "Start now",
    salva: "Save",
    errore_info_pagamento: "Unable to retrieve payment information",
    errore_inoltro_richiesta: "Unable to submit the request",
    nessun_operatore_disponibile: "No operator available at this time",
    transazione_non_finalizzata: "Transaction not finalized",
    errore_operazione: "Operation could not be completed",
    errore_recupero_informazioni: "Unable to retrieve the requested information",
    registra_familiare: "Register Family Member",
    scegli_familiare: "Choose family member",
    titolo_nuovo_familiare: "New Family Member",
    nome: "First Name",
    placeholder_nome: "First name...",
    cognome: "Last Name",
    placeholder_cognome: "Last name...",
    codice_fiscale: "Tax Code",
    placeholder_cf: "Tax code...",
    numero_tessera_sanitaria: "Health Card Number",
    placeholder_ts_number: "Card number...",
    fascia_eta: "Age Range",
    seleziona_fascia_eta: "Select age range",
    relazione: "Relationship",
    seleziona_relazione: "Select relationship",
    genere: "Gender",
    maschile: "Male",
    femminile: "Female",
    campi_obbligatori: "*Required fields",
    salva: "Save",
    nuovo_familiare_successo: "New family member successfully added!",
    errore_salvataggio_familiare: "It was not possible to save the information.",
    familiari: "Family Members",
    tutti: "All",
    nuovo: "New",
    paziente_non_trovato: "Patient not found",
    data_di_nascita: "Birthday",
    non_indicata: "Not indicated",
    i_tuoi_familiari: "Your family members",
    aggiungi: "Add",
    tooltip_familiari_1: "People not registered on the platform that you added as family members.",
    tooltip_familiari_2: "Click \"+\" to create new members: once added you can book drugs and services for them.",
    i_tuoi_assistiti: "Your assisted persons",
    tooltip_assistiti: "People who chose you as their caregiver. They allowed you to book services and medications on their behalf.",
    nessun_assistito_registrato: "There are no assisted persons registered for this account.",
    i_tuoi_caregiver: "Your caregivers",
    tooltip_caregivers: "People who take care of you. They are allowed to book services and medications for you.",
    nessun_caregiver_registrato: "There are no caregivers registered for this account.",
    vuoi_abilitare: "Do you want to enable",
    vuoi_disabilitare: "Do you want to disable",
    come_tuo_caregiver: "as your caregiver?",
    conferma_informativa: "To confirm, you must acknowledge that you have read the privacy policy.",
    ho_letto_informativa: "I have read and understood the privacy policy",
    acconsento_trattamento_dati: "I consent to the processing of my personal data for the purposes stated in the policy",
    no_annulla: "No, Cancel",
    si_conferma: "Yes, Confirm",
    nessun_utente_selezionato: "No user selected",
    errore_recupero_informazioni: "It was not possible to retrieve the information.",
    caregiver_abilitato: "Caregiver enabled",
    caregiver_disabilitato: "Caregiver disabled",
    abilita_caregiver: "Enable caregiver",
    disabilita_caregiver: "Disable caregiver",
    registrazione_step: "Step {n}",
    titolo: "Title",
    nome: "First name",
    cognome: "Last name",
    codice_azienda: "Company code",
    tooltip_codice_azienda: "The company code can be found in the settings section of the administrator operator",
    inserisci_codice_azienda: "Enter the 10-digit code provided by your company.",
    codice_fiscale: "Tax code",
    data_nascita: "Date of birth",
    genere: "Gender",
    maschile: "male",
    femminile: "female",
    nazione_nascita: "Country of birth",
    indirizzo: "Address and house number",
    cap: "ZIP code",
    email: "Email",
    telefono: "Phone number",
    telefono_fisso: "Landline number",
    aderisco_progetto: "I join the project",
    ordine: "Order",
    id_albo: "Professional Order ID",
    specializzazione: "Specialization",
    specializzazione_placeholder: "Medical specialization...",
    password: "Password",
    conferma_password: "Confirm password",
    consulta_informativa_privacy: "View Privacy Policy",
    consulta_termini: "View Terms and Conditions of Service",
    non_accetto: "I do not accept",
    completa: "Complete",
    informativa_commerciale: "Authorization for commercial communications",
    accetta_informativa: "I have read and accept the Privacy Policy",
    accetta_termini: "I have read and accept the Terms and Conditions of Service",
    accetta_articoli: "Pursuant to Articles 1341 et seq. of the Civil Code, I expressly accept the provisions of Articles 2, 7, 8, 10, 12 of these Terms and Conditions of Use",
    acconsento_marketing: "I consent to receiving promotional communications for marketing purposes",
    avanti: "Forward",
    regione_residenza: "Region of residence",
    regione: "Region",
    provincia: "Province",
    provincia_residenza: "Province of residence",
    comune: "City",
    comune_residenza: "City of residence",
    indirizzo_numero_civico: "Address and street number",
    cap: "ZIP code",
    seleziona_regione: "Select Region",
    seleziona_provincia: "Select Province",
    seleziona_comune: "Select City",
    placeholder_indirizzo: "Address",
    placeholder_cap: "ZIP",
    email: "Email",
    numero_telefono: "Phone number",
    telefono_fisso: "Landline phone",
    aderisco_progetto: "Join the project",
    nessun_progetto: "No project",
    nessuna_selezione: "--",
    password: "Password",
    conferma_password: "Confirm password",
    password_requisiti:
      "The password cannot include your name or surname and must contain at least 8 characters, including one number, one uppercase, one lowercase and one",
    carattere_speciale: "special character",
    tooltip_carattere_speciale:
      "You must use at least one character among ! @ # $ % ^ & * ) ( + = . _ -",
    termini_condizioni_privacy: "Terms and Privacy Policy",
    concludi_registrazione_testo:
      "To complete the registration, it is necessary to confirm that you have read the",
    termini_condizioni_link: "general terms and conditions",
    informativa_privacy_link: "Privacy Policy",
    accetto_informativa_privacy: "I have read and accept the Privacy Policy",
    accetto_termini_condizioni:
      "I have read and accept the Terms and Conditions of the service",
    accetto_comunicazioni_commerciali:
      "I agree to receive promotional communications as per the Privacy Policy",
    non_accetto: "I do not accept",
    e: "and",
    progetto_selezionato_testo:
      "**By selecting the project {projectName}, the healthcare facility involved will be added to your circle of care",
    consulta_informativa_privacy: "View Privacy Policy",
    accetto_termini_condizioni: "I have read and accept",
    termini_condizioni_uso: "Terms and Conditions of Service",
    non_accetto: "I do not accept",
    e: "and",
    accetto_articoli_cc: "Pursuant to Article 1341 and following of the Civil Code, I expressly accept the provisions of Articles 2, 7, 8, 10, 12 of the",
    autorizzazione_marketing: "Authorization for marketing communications",
    accetto_marketing: "I consent to receiving marketing communications for promotional purposes as described in the",
    scheda: {
      rilevazioni: "Measurements",
      patologie: "Conditions",
      terapie: "Therapies",
      note: "Notes",
      dispositivi: "Devices",
      genere: "Gender",
      regione: "Region",
      indirizzo: "Address",
      data_nascita: "Date of birth",
      provincia: "Province",
      telefono: "Phone number",
      codice_fiscale: "Tax Code",
      comune: "Municipality",
      email: "Email",
      non_indicato: "Not specified",
      utente_non_trovato: "User not found",
      alert_recupero_errore: "Unable to retrieve information.",
    },
    familiari: {
      nessun_familiare: "No family members registered for this account.",
      familiari: "Family members",
      nome: "First Name",
      nome_placeholder: "First name...",
      cognome: "Last Name",
      cognome_placeholder: "Last name...",
      cf: "Tax Code",
      cf_placeholder: "Tax code...",
      ts: "Health Insurance Card Number",
      ts_placeholder: "Card number...",
      fascia_eta: "Age Group",
      fascia_eta_seleziona: "Select age group",
      relazione: "Relationship",
      relazione_seleziona: "Select relationship",
      genere: "Gender",
      maschile: "Male",
      femminile: "Female",
      campi_obbligatori: "*Required fields",
      annulla: "Cancel",
      salva: "Save",
      nessun_elemento_selezionato: "No member selected",
      alert_recupero_errore: "Unable to retrieve the requested information.",
      alert_creazione_successo: "Family member added succesfully",
      alert_creazione_errore: "Unable to invite your family member",
      alert_invito_successo: "Family member invited successfully",
      alert_salvataggio_successo: "Information updated successfully",
      alert_salvataggio_errore: "Unable to update the information.",
      maschile: "Male",
      femminile: "Female",
      eta_pediatrica: "Pediatric age",
      adulto: "Adult",
      anziano: "Elderly",
      figlio: "Child",
      genitore: "Parent",
      coniuge: "Spouse",
      convivente: "Partner",
      nipote: "Grandchild",
      altro_parente: "Other (relative)",
      altro_non_parente: "Other (non-relative)",
      fascia_eta: "Age group",
      ts: "Health insurance card",
      ts_non_inserita: "Not entered",
      genere: "Gender",
      relazione: "Relationship",
      cf: "Tax code",
      seleziona_tipo_inserimento: "Select the type of entry",
      inserimento_semplice: "Simple entry",
      inserimento_semplice_descrizione: "Manually enter a user not already in the system",
      utente_registrato: "Registered user",
      utente_registrato_descrizione: "If the user is already in the platform, you can add them via user code",
      nuovo_familiare: "New family member",
      condivisione_dati: "Your family member's identifying data will be shared with the healthcare professionals in your care circle",
      nome: "First name",
      nome_placeholder: "First name...",
      cognome: "Last name",
      cognome_placeholder: "Last name...",
      cf: "Tax code",
      cf_placeholder: "Tax code...",
      ts: "Health card number",
      ts_placeholder: "health card number...",
      fascia_eta: "Age group",
      fascia_eta_seleziona: "select age group",
      relazione: "Relationship",
      relazione_seleziona: "Select relationship",
      genere: "Gender",
      maschile: "male",
      femminile: "female",
      autorizzazione_dichiarazione: "* In accordance with DPR no. 445/2000, I declare that I am authorized, by law or by my family member, to use the ConCura services to manage their medical data on their behalf",
      campi_obbligatori: "*Required fields",
      richiesta_codice_descrizione: "Search for a relative or assisted person using their user code – available in the 'Settings' section under 'Personal user code' – and invite them to join your family. The invited user will receive an email through which they can accept your invitation and designate you as their caregiver.",
      label_codice: "Enter user code",
      placeholder_codice: "User code...",
      bottone_cerca: "Search",
      utente_trovato: "User found:",
      domanda_inviare_richiesta: "Send request?",
      invia_richiesta: "Send request",
      invita: "Invite",
      utente_non_trovato: "No user found.",
      alert_codice_non_trovato: "User code not associated with any user"
    },
    informativa: {
      titolo: "PRIVACY POLICY FOR BOOKING, ORDER AND TELECONSULTATION SERVICES MANAGED BY FAMILY MEMBERS AND CAREGIVERS",
      sottotitolo: "(Art. 14 EU Reg. 679/2016)",
      blocco_1: `
      <h6 class="text-center bg-sec-4 py-2 border-bottom border-dark">Who processes my relative's/assisted person's data?</h6>
      <p class="px-1 mb-0 border-bottom border-dark">
        The Data Controller is the healthcare entity affiliated with <b>{{ appName }}</b> that processes your personal data for all the purposes listed below.
        You can view their contact details in the <span class="text-prim-grad-1 fw-bolder">"My care facility"</span> section of your personal area.
      </p>
    `,
      quali_dati: `
      <h6 class="text-center">1. WHAT PERSONAL DATA IS PROCESSED?</h6>
      <p>The Controller will process the following personal data:</p>
      <ul>
        <li>First and last name</li>
        <li>Tax code</li>
        <li>Health insurance card number (optional)</li>
        <li>Age group</li>
        <li>Relationship with your caregiver (e.g. child, parent, relative, etc.)</li>
        <li>Type, date and time of the service</li>
        <li>Product related to the order</li>
        <li>NRE and REV code of the prescription</li>
        <li>Prescription in PDF format (optional)</li>
        <li>Medical condition for teleconsultation</li>
        <li>Teleconsultation date and time</li>
      </ul>
    `,
      finalita: `
      <h6 class="text-center">2. FOR WHAT PURPOSES IS MY DATA PROCESSED AND WHY IS IT LEGAL?</h6>
      <p>The Controller processes your data to allow you to book through a family member/caregiver:</p>
      <ul>
        <li>services at the pharmacy;</li>
        <li>orders at the pharmacy;</li>
        <li>teleconsultation services at the pharmacy.</li>
      </ul>
      <p>This processing is lawful because:</p>
      <ul>
        <li>for common data (e.g. personal info), it is necessary for the execution of a contract;</li>
        <li>for health data, it is based on consent given through the caregiver, approved or inserted as such via the platform.</li>
      </ul>
    `,
      comunicazioni: `
      <h6 class="text-center">3. WHO IS MY DATA SHARED WITH?</h6>
      <p>Your data is shared with:</p>
      <ul>
        <li>the IT consultancy company Qwince Innovation S.r.l. for platform management;</li>
        <li>the individuals (e.g. family members, caregivers) you choose to share your data with via the platform.</li>
      </ul>
      <p>
        You may request a full list of recipients by writing to
        <a href="mailto:assistenza@concura.online">assistenza@concura.online</a>. Your data will not be disclosed publicly.
      </p>
    `,
      trasferimenti: `
      <h6 class="text-center">4. IS MY DATA TRANSFERRED OUTSIDE THE EU?</h6>
      <p>No, your data is not transferred outside the European Union.</p>
    `,
      conservazione: `
      <h6 class="text-center">5. HOW LONG IS MY DATA STORED?</h6>
      <p>
        Your data will be stored as long as your account is active. Once deactivated, your data will be either permanently deleted or anonymized.
      </p>
    `,
      profilazione: `
      <h6 class="text-center">6. WILL I BE PROFILED?</h6>
      <p>
        No, your data will not be used for profiling or subject to any automated decision-making.
      </p>
    `,
      diritti: `
      <h6 class="text-center">7. WHAT ARE MY RIGHTS?</h6>
      <p>You have the following rights:</p>
      <ul>
        <li><b>Right of access:</b> to obtain confirmation and a copy of your data.</li>
        <li><b>Right to rectification:</b> to correct or complete your data.</li>
        <li><b>Right to erasure:</b> to delete your data if no longer needed, processed unlawfully, or due to legal obligations.</li>
        <li><b>Right to restriction:</b> to restrict processing in specific circumstances (e.g., accuracy disputed, legal claims).</li>
        <li><b>Right to data portability:</b> to receive your data in a structured format and transmit it to another controller.</li>
        <li><b>Right to object to automated decision-making:</b> including profiling, if it significantly affects you.</li>
      </ul>
      <p>You can exercise your rights by writing to the Data Controller. You will receive a reply within 30 days.</p>
    `,
      raccolta: `
      <h6 class="text-center">8. HOW DID THE CONTROLLER OBTAIN MY DATA?</h6>
      <p>Your data was provided by your family member or caregiver.</p>
    `,
      reclamo: `
      <h6 class="text-center">9. HOW CAN I FILE A COMPLAINT?</h6>
      <p>
        If you wish to file a complaint regarding how your data is handled, you can contact the competent authority via
        <a href="https://www.garanteprivacy.it" target="_blank">www.garanteprivacy.it</a>.
      </p>
    `
    },
    utente_non_trovato: "User not found",
    misurazioni: {
      parametri: "Parameters",
      esami: "Exams",
      referti: "Reports",
      nuovo_parametro_btn: "new parameter measurement",
      nuovo_parametro_title: "New parameter measurement",
      trova_parametro: "Find parameter",
      nuovo_esame_btn: "new exam measurement",
      nuovo_esame_title: "New exam measurement",
      nuovo_referto_btn: "new report",
      nuovo_referto_title: "New report",
      referto_carica_da_file: "Upload report from file",
      referto_scrivi: "Write report",
      referto_carica_desc: "Upload an existing PDF or image",
      referto_scrivi_desc: "Compose the report with Assessment, Prescription and attachments",
      referto_modal_question: "How do you want to create the report?",
      cerca: "Search...",
      data_ora: "Date and Time of Measurement",
      inserisci_data: "Enter date",
      inserisci_ora: "Enter time",
      valore_placeholder: "Value*",
      visibile_solo_a_me: "visible only to me**",
      storico: "History",
      anno: "Year",
      mese: "Month",
      giorno: "Day",
      valori_rilevati: "Measured values",
      scarica: "Download",
      referto_seen: "downloaded",
      referto_unseen: "not yet downloaded",
      nessuna_altra_rilevazione: "No other measurements available",
      modifica_valore: "Edit Value",
      conferma: "Confirmation",
      si_elimina: "Yes, delete",
      no_annulla: "No, cancel",
      data_ora: "Date and Time of Measurement",
      valori_riferimento: "Reference values",
      annotazioni: "Notes",
      parametro_osservato: "The parameter is being monitored.",
      parametro_non_osservato: "Parameter not monitored.",
      visualizza_soglie: "View thresholds",
      imposta_soglie: "Set thresholds",
      tutti: "all",
      nuovo_parametro: "New parameter measurement",
      nuovo_esame: "New exam measurement",
      nuovo_referto: "New report upload",
      referti_richiedono_sottoscrizione: "Uploading reports requires an active subscription.",
      errore_generico: "Something went wrong",
      inserimento_successo: "Measurement successfully added",
      inserimento_errore: "Unable to insert the measurement",
      aggiornamento_successo: "Measurement successfully updated",
      aggiornamento_errore: "Unable to update the measurement",
      eliminazione_successo: "Measurement successfully deleted",
      eliminazione_errore: "Unable to delete the measurement",
      download_errore: "Unable to download the resource",
      referto: "this report",
      esame: "this exam",
      rilevazione: "this measurement",
      visibileSoloMe: "**if you select this option, only you will be able to view",
      scarica: "Download",
      aggiungi: "add",
      salva_modifiche: "Save changes",
      cancel_title: "Cancel",
      soglie_parametro: "Thresholds for parameter {parametro}",
      elimina_valore: "Do you want to delete this value of",
      mesi: {
        gennaio: 'January',
        febbraio: 'February',
        marzo: 'March',
        aprile: 'April',
        maggio: 'May',
        giugno: 'June',
        luglio: 'July',
        agosto: 'August',
        settembre: 'September',
        ottobre: 'October',
        novembre: 'November',
        dicembre: 'December',
      }
    },
    uploader: {
      caricamento_completato: "Upload completed",
      placeholder: "Select file...",
      carica: "Upload",
      errore_caricamento: "File upload error",
    },
    soglie: {
      valori_soglia_per_parametro: "Threshold values for the parameter",
      descrizione_soglie_custom:
        "By configuring critical threshold values for a parameter, an alert will be triggered when the patient enters an out-of-range value, corresponding to the appropriate severity level. Values below the 'normal' range are displayed on the left side of the table, while values above are shown on the right. Click the pencil icon to edit the threshold for the selected severity. You can configure from a minimum of 1 to a maximum of 7 thresholds.",
      valori_default_parametro: "Default values for the parameter",
      descrizione_valori_default:
        "Below are the available threshold values for the parameter. Click on \"use default values for monitoring\" to apply them for the patient. After saving, you can customize them if needed according to the patient's needs.",
      usa_default: "Use default values for monitoring",
      nessun_valore_default: "No default values available for the parameter",
      soglie_personalizzate: "custom thresholds",
      errore_generico: "Something went wrong",
      valori_modificati_successo: "Values successfully updated",
      errore_modifica_valori: "Unable to update the value",
      note_aggiornate: "Notes successfully updated",
      errore_note: "Unable to update the notes",
      soglia_eliminata: "Threshold successfully deleted",
      errore_eliminazione: "Unable to delete the threshold",
      valori_impostati: "Values successfully set",
      conferma_operazione: "Confirm action",
      si_elimina: "Yes, delete",
      no_annulla: "No, cancel",
      sicuro_eliminare: "Are you sure you want to delete this threshold?",
      modifica_note: "Edit notes",
      note_soglia: "Threshold notes",
      note_titolo: "Threshold Notes",
      note_descrizione: "You can enter notes here to suggest or take actions in case the parameter falls within the selected threshold, for diagnostic (Diagnostic protocol) and/or operational (Operational protocol) purposes. Fill in either one or both fields.",
      protocollo_diagnostico: "Diagnostic protocol:",
      protocollo_operativo: "Operational protocol:",
      placeholder_diagnostico: "Diagnostic test suggested, consult with...",
      placeholder_operativo: "Suggested to check, take, interrupt...",
      annulla: "Cancel",
      salva_note: "Save notes"
    },
    FrequenzeRilevazioni: {
      titleAdd: "New monitoring frequency",
      titleUpdate: "Edit setting",
      titleDelete: "Edit operation",
      titleConfirm: "Confirm operation",
      labelEvery: "The parameter must be measured every",
      labelFrequency: "Monitoring frequency: one measurement every",
      labelSuspended: "Monitoring suspended",
      labelDeleteQuestion: "Do you want to delete this monitoring frequency?",
      labelEnableQuestion: "Do you want to enable this monitoring frequency?",
      labelDisableQuestion: "Do you want to disable this monitoring frequency?",
      buttonSetFrequency: "Set monitoring frequency",
      buttonSave: "Save frequency",
      buttonCancel: "Cancel",
      buttonConfirm: "Confirm",
      buttonEdit: "Save changes",
      buttonDeleteYes: "Yes, delete",
      buttonDeleteNo: "No, cancel",
      error_generic: "Something went wrong",
      success_saved: "Values successfully saved",
      success_updated: "Frequency setting successfully updated",
      error_update: "Unable to update frequency",
      success_deleted: "Frequency setting successfully deleted",
      error_delete: "Unable to delete frequency",
      months: "months",
      month: "month",
      weeks: "weeks",
      week: "week",
      days: "days",
      day: "day",
      hours: "hours",
      hour: "hour",
      minutes: "minutes",
      minute: "minute"
    },
    PatologieComponent: {
      title: "Pathologies",
      new: "new pathology",
      create: "Create therapy for",
      searchTitle: "Search pathology",
      searchPlaceholder: "Search pathology by name or code...",
      searchDescription: "*source: updated ICD-10 classification",
      selectPatologia: "Select pathology",
      nomePatologia: "Pathology name*",
      tipo: "Type*",
      inizio: "Start date",
      fine: "End date",
      visibileSoloAMe: "visible only to me**",
      visibilitaDescrizione: "**if you select this option only you will be able to see this pathology",
      annotazioni: "Notes",
      campiObbligatori: "*Required fields",
      annulla: "Cancel",
      salva: "Save",
      modifica: "Edit",
      inseritaIl: "entered on",
      codicePatologia: "Pathology Code (ICD-10):",
      vedi: "View",
      successSave: "Pathology successfully saved!",
      failSave: "Unable to save the pathology",
      successUpdate: "Changes saved successfully!",
      failUpdate: "Unable to save changes",
      failFetch: "Unable to retrieve pathologies",
      cronica: "chronic",
      acuta: "acute",
      stagionale: "seasonal",
      data_inizio: "start",
      dal: "from",
      al: "to"
    },
    IndiceAderenza: {
      title: "Adherence Index",
      references: "Reference:",
      level0: "not determinable",
      level1: "poor",
      level2: "medium",
      level3: "optimal"
    },
    TerapieComponent: {
      activeTitle: "Current therapies",
      newTherapy: "new therapy",
      downloadProspetto: "Therapy Overview",
      suspended: "Suspended",
      until: "Until",
      since: "Since",
      finished: "end date",
      historyTitle: "Therapy history",
      noHistory: "No items in the history",
      edit: "Edit",
      resume: "Resume",
      suspend: "Suspend",
      downloadReminder: "Download reminder",
      createdAt: "Inserted on:",
      deleteConfirmTitle: "Delete confirmation",
      deleteConfirmText: "Do you confirm you want to delete the therapy?",
      downloadError: "It was not possible to download the overview.",
      fetchError: "Unable to retrieve therapies",
      suspended: "suspended",
      resumed: "resumed",
      therapy: "Therapy",
      operationFailed: "The operation could not be completed",
      deleted: "Therapy deleted!",
      deleteError: "Unable to delete the therapy",
      downloadReminderError: "Unable to download the reminder",
      si_conferma: "Yes, confirm",
      no_annulla: "No, cancel",
      scaricaProspetto: "Download Therapy Summary",
      nuovaTerapia: "New Therapy",
      elimina: "Delete",
      vedi: "View",
      conferma: "Confirm",
      testoConfermaSospensione: "Do you confirm you want to {azione} the therapy?",
      azioneSospendere: "suspend",
      azioneRiprendere: "resume"
    },
    RecapTherapy: {
      pathology: "pathology",
      indicazione: "indication",
      noPathology: "No pathology specified",
      dosage: "Dosage",
      of: "of",
      byRoute: "by route",
      toTake: "To be taken:",
      duration: "Duration",
      from: "From",
      until: "until",
      followEvery: "The therapy must be followed every",
      for: "for",
      startingFrom: "starting from",
      undefined: "undefined",
      notes: "Notes",
      noNotes: "no notes",
      details: "Details",
      prescriber: "Prescriber",
      source: "Information source",
      sideEffects: "Side effects",
      allergicReactions: "Allergic reactions",
      interactions: "Interactions",
      notIndicated: "not indicated",
      reminder: "Reminder",
      tenMinutesBefore: "10 minutes before administration",
      adherenceIndex: "Adherence index",
      selectDrug: "Select drug",
      searchDrug: "Search drug by name..",
      notFound: "Product not found",
      frequency: "Frequency",
      frequencyAndDosage: "Frequency, method and dosage",
      daily: "daily",
      asNeeded: "as needed",
      every: "every",
      onlyOneIntakeTime: "Only one intake moment can be selected with this frequency",
      morning: "Morning",
      midMorning: "Mid-morning",
      lunch: "Lunch",
      afternoon: "Afternoon",
      evening: "Evening",
      night: "Night",
      prescriberSelect: "indicate who prescribed the therapy",
      sourceSelect: "indicate information source",
      sideEffectsPlaceholder: "any side effects attributed to the drug..",
      allergicReactionsPlaceholder: "any allergic reactions attributed to the drug..",
      interactionsPlaceholder: "possible interactions with other drugs or foods..",
      privateInfoNote: "**if you select this option, only you will see this therapy",
      visibleOnlyToMe: "visible only to me**",
      cancel: "Cancel",
      saveChanges: "Save changes",
      saveSuccess: "New therapy saved",
      saveError: "An error occurred while saving",
      startDate: "Starting from",
      endDate: "Until",
      unitsSing: {
        mese: "month",
        settimana: "week",
        giorno: "day"
      },
      unitsPlur: {
        mesi: "months",
        settimane: "weeks",
        giorni: "days",
        ore: "hours"
      },
      unit: {
        compressa: "tablet",
        capsula: "capsule",
        goccia: "drop",
        inalazione: "inhalation",
        busta: "sachet",
        supposta: "suppository",
        scatola: "box",
        cerotto: "patch",
        fiala: "vial",
        fleboclisi: "infusion",
        ovulo: "vaginal ovule",
        sacca: "bag",
        flacone: "bottle",
        confezione: "package",
        kilogrammo: "kilogram",
        kit: "kit",
        millilitro: "milliliter",
        milligrammo: "milligram",
        applicazione: "application",
        UI: "IU"
      },
      vias: {
        orale: "Oral",
        transdermica: "Transdermal",
        nasale: "Nasal",
        endovena: "Intravenous",
        intramuscolo: "Intramuscular",
        oftalmica: "Ophthalmic",
        rettale: "Rectal",
        uretale: "Urethral",
        vaginale: "Vaginal",
        sottocute: "Subcutaneous"
      }
    },
    EditTherapy: {
      Annotazioni: 'Notes',
      Annulla: 'Cancel',
      Farmaco_indicato: 'Prescribed drug',
      Mattina: 'Morning',
      Meta_mattina: 'Mid-morning',
      Notte: 'Night',
      Ore: 'Hours',
      Pomeriggio: 'Afternoon',
      Pranzo: 'Lunch',
      Prodotto_non_trovato: 'Product not found',
      Salva_modifiche: 'Save changes',
      Sera: 'Evening',
      al_bisogno: 'as needed',
      al_di: 'per day',
      giorni: 'days',
      indica_prescrittore: 'indicate who prescribed the therapy',
      indica_fonte: 'indicate information source',
      indica_patologia: 'indicate pathology',
      mesi: 'months',
      non_indicare_patologia: 'do not indicate pathology',
      occasionale: 'occasional',
      ogni: 'every',
      ore: 'hours',
      giorni: 'days',
      per_sempre: 'forever',
      periodica: 'periodic',
      settimane: 'weeks',
      ikey_descrizione: '{{ ikey.descrizione }}',
      prod_Nome: '{{ prod.Nome }}',
      dosaggio: 'dosage',
      durata_terapia: "Therapy duration"
    },
    Common: {
      genericError: "An error occured."
    },
    nuovaPrenotazioneSalvata: {
      prenotazionePassata: "past appointment",
      testoIstruzioni: "Select a service, a date and a time slot to enter a service already performed.",
      prestazione: "Service to be entered*",
      dataInserimento: "Insertion date*",
      labelHelp: "Use the arrows to navigate between dates",
      fasciaOraria: "Time slot*",
      placeholderData: "Select a date",
      selezionaFascia: "Select a time slot",
      mattina: "morning",
      pomeriggio: "afternoon",
      sera: "evening",
      modalTitle: "New past appointment",
      success: "Appointment successfully saved",
      error: "Error while saving the appointment"
    },
    SelectCompanyHealthService: {
      loading: "Loading...",
      empty: "No active and available services",
      choose: "choose a service",
      loadError: "Error while loading health services"
    },
    PatientAnnotations: {
      title: "Notes",
      new: "new health note",
      info: "Add a health note to the patient's profile. This note will not be visible to the patient.",
      month: "Month",
      year: "Year",
      all: "All",
      yours: "Your notes",
      noneForMonth: "No notes for this month.",
      noneForFilters: "No notes with the selected filters.",
      loadError: "Unable to retrieve notes",
      months: {
        january: "January",
        february: "February",
        march: "March",
        april: "April",
        may: "May",
        june: "June",
        july: "July",
        august: "August",
        september: "September",
        october: "October",
        november: "November",
        december: "December"
      }
    },
    ClinicalReportGenerator: {
      emit: "Issue Report",
      modalTitle: "Generate signed report",
      placeholder: "Your notes...",
      authorizeAndEmit: "Authorize and issue report",
      otpInstruction: "The facility requires this operation to be confirmed by verifying a code (OTP) sent to your phone number.\n\nClick \"send verification code\" to receive the OTP.",
      or: "or",
      cancel: "Cancel operation",
      serviceNotAvailable: "Service not available for this facility.",
      contactSupport: "Contact us for more information",
      emitSuccess: "Report issued successfully",
      emitError: "Error during report processing",
      downloadError: "Unable to download the resource"
    },
    singleAnnotationComponent: {
      visible: "Visible to patient",
      notVisible: "Not visible to patient",
      soapLabel: "health note",
      subjective: "Subjective",
      objective: "Objective",
      assessment: "Assessment",
      plan: "Plan",
      other: "Other",
      saveChanges: "Save changes",
      cancelChanges: "Cancel changes",
      modalTitle: "Confirm deletion",
      cancelDelete: "No, Cancel",
      confirmDelete: "Yes, Confirm",
      confirmDeleteText: "Do you confirm you want to delete this note?",
      updateSuccess: "Note updated successfully",
      updateError: "Error updating note",
      deleteSuccess: "Note deleted successfully",
      deleteError: "Error deleting note"
    },
    NewAnnotationComponent: {
      placeholder: "Add a simple note",
      visibilityLabel: "Patient Visibility",
      notVisible: "Not visible to the patient",
      visible: "Visible to the patient",
      save: "Save note",
      cancel: "Cancel",
      success: "Note added successfully",
      error: "Error while adding the note"
    },
    NewSoapAnnotationComponent: {
      subjective: "Subjective",
      objective: "Objective",
      assessment: "Assessment",
      plan: "Plan",
      other: "Other",
      subjectivePlaceholder: "Impressions, symptoms reported by the patient, family history...",
      objectivePlaceholder: "Signs, physical exam, instrumental investigations...",
      assessmentPlaceholder: "Evaluation, diagnosis, progress...",
      planPlaceholder: "Recommendations, procedures or treatments, changes to the plan...",
      otherPlaceholder: "Other relevant observations...",
      save: "Save note",
      cancel: "Cancel",
      success: "Note added successfully",
      error: "Error while adding the note"
    },
    ScoresComponent: {
      title: "Questionnaires",
      new: "new questionnaire score",
      newBtn: "new questionnaire score",
      newTitle: "New questionnaire score",
      history: "History",
      lastScore: "Last recorded score",
      year: "Year",
      month: "Month",
      day: "Day",
      all: "all",
      values: "Recorded values",
      noValues: "No values recorded",
      findByScore: "Find questionnaire by score",
      add: "add",
      back: "back",
      complete: "complete questionnaire",
      error: "something went wrong",
      placeholder: "Search...",
      esito_title: "Questionnaire result",
      vediQuestioniario: "see questionnaire",
      esito: "Outcome"
    },
    FrequenzaValutazioneScore: {
      frequencyPer: "Detection frequency: one assessment every",
      suspended: "Assessment suspended",
      setFrequency: "Set assessment frequency",
      parameterNeeded: "The parameter must be measured every",
      toggleQuestion: "Do you want to {{ selectedFrequency.enabled ? 'disable' : 'enable' }} this monitoring frequency?",
      confirmDeleteQuestion: "Do you want to delete this monitoring frequency?",
      deleteTitle: "Edit operation",
      updateTitle: "Edit setting",
      modificaTitle: "edit",
      sospendiTitle: "stop",
      riprendiTitle: "resume",
      eliminaTitle: "remove",
      confirmTitle: "Confirm operation",
      deleteConfirm: "Yes, delete",
      saveChanges: "Save changes",
      cancel: "Cancel",
      confirm: "Confirm",
      genericError: "Something went wrong",
      setSuccess: "Values set successfully",
      updateSuccess: "Frequency setting successfully updated",
      updateError: "Unable to update frequency",
      deleteSuccess: "Frequency setting successfully deleted",
      deleteError: "Unable to delete frequency",
      sing: {
        mese: "month",
        settimana: "week",
        giorno: "day",
        ora: "hour",
        minuto: "minute"
      },
      plur: {
        mesi: "months",
        settimane: "weeks",
        giorni: "days",
        ore: "hours",
        minuti: "minutes"
      }
    },
    PatientDevices: {
      title: "Devices",
      newDevice: "new device",
      noneAssociated: "No device associated with the user.",
      newDeviceTitle: "New User Device",
      searchDevice: "Find device",
      searchPlaceholder: "Search...",
      noneAvailable: "No available device for assignment.",
      codePlaceholder: "Enter code*",
      back: "Back",
      save: "Save",
      addSuccess: "Device added successfully",
      addError: "Failed to add the device",
      removeSuccess: "Device removed successfully",
      removeError: "Failed to remove the device",
      updateCodeSuccess: "Product code updated successfully",
      updateCodeError: "Failed to update product code",
      enabled: "enabled",
      disabled: "disabled",
      examStatusUpdated: "Exam {status} successfully",
      examStatusError: "Failed to update exam status",
      updateRequested: "Update requested. You will receive a notification once completed",
      updateRequestError: "Failed to request update"
    },
    DeviceCard: {
      requestUpdate: "Request data update",
      noExams: "No exam enabled on this device.",
      confirmTitle: "Confirm operation",
      confirmOk: "Yes, confirm",
      confirmCancel: "No, cancel",
      confirmMessage: "Do you want to deactivate the device",
  editTitle: "Edit Device {name}",
      parameters: "Parameters",
      enabled: "Enabled",
      disabled: "Disabled",
      productCode: "Product Code",
      edit: "Edit",
      save: "Save",
      cancel: "Cancel",
      close: "Close",
      productCodePlaceholder: "Product Code"
    },
    EsenzioniComponent: {
      title: "Exemptions",
      new: "new exemption",
      none: "No exemptions entered",
      modalTitle: "Add exemption",
      choose: "choose",
      requiredField: "*Required field",
      cancel: "Cancel",
      save: "Save",
      deleteTitle: "Do you confirm you want to delete the exemption?",
      deleteOk: "Yes, delete",
      cancelDelete: "No, cancel",
      saveSuccess: "Exemption successfully saved!",
      saveError: "Unable to save the exemption",
      deleteSuccess: "Exemption successfully deleted!",
      deleteError: "Unable to delete the exemption",
      pathologiesError: "Unable to fetch list of pathologies",
      loadError: "Unable to retrieve exemptions"
    },
    ProfiloAnagraficoAssistito: {
      title: "Patient Information",
      subtitle: "Patient profile",
      loadError: "Unable to retrieve the information."
    },
    AnagraficaPazienteComponent: {
      profile: "Profile",
      title: "Title",
      titlePlaceholder: "Mr./Ms...",
      firstName: "First name*",
      firstNamePlaceholder: "First name...",
      lastName: "Last name*",
      lastNamePlaceholder: "Last name...",
      birthDate: "Date of birth*",
      gender: "Gender",
      male: "male",
      female: "female",
      taxCode: "Tax code*",
      taxCodePlaceholder: "Tax code...",
      healthCard: "Health Card Number",
      healthCardPlaceholder: "Health card number...",
      birthCountry: "Country of birth*",
      gp: "Primary care doctor",
      gpPlaceholder: "Primary doctor...",
      localHealthAuthority: "Reference LHA (ASL/ASP/ATS)",
      selectAuthority: "Select local health authority",
      cancel: "Cancel",
      save: "Save Changes",
      residence: "Residence",
      region: "Region*",
      regionPlaceholder: "Region...",
      province: "Province*",
      provincePlaceholder: "Province...",
      city: "City*",
      cityPlaceholder: "City...",
      selectRegion: "Select Region",
      selectProvince: "Select Province",
      selectCity: "Select City",
      address: "Address and street number*",
      addressPlaceholder: "Address...",
      zip: "ZIP code*",
      zipPlaceholder: "ZIP...",
      contacts: "Contacts",
      phone: "Phone number",
      phonePlaceholder: "Phone...",
      homePhone: "Home phone",
      homePhonePlaceholder: "Home phone...",
      backupPhone: "Backup phone",
      backupPhonePlaceholder: "Backup phone...",
      deleteImageTitle: "Confirm deletion",
      confirm: "Yes, Confirm",
      confirmDeleteImage: "Do you confirm you want to delete the profile image?",
      selectCountry: "Select Country",
      titleOptions: {
        sig: "Mr.",
        sigRa: "Ms.",
        dott: "Dr.",
        dottSsa: "Dr. (female)"
      },
      invalidPhone: "Invalid phone number",
      success: "Changes saved successfully",
      genericError: "Unable to complete the operation"
    },
    UploadComponent: {
      uploadSuccess: "successfully uploaded!",
      uploadNew: "Upload new file",
      codeDetected: "Code successfully detected!",
      codeNotDetected:
        "Unable to detect the code from the uploaded prescription. Please try scanning the code with the camera or manually enter the code in the appropriate field.",
      placeholder: "select file...",
      upload: "Upload",
      invalidFile: "Invalid file or file size too large (max 8MB)"
    },
    ContattiEmergenza: {
      title: "Useful Contacts",
      none: "No contact entered.",
      newContact: "new contact",
      modalTitle: "Add useful contact",
      cancel: "Cancel",
      save: "Save contact",
      loadError: "Unable to retrieve the information."
    },
    NewEmergencyContact: {
      type: "Contact type",
      firstName: "First name*",
      firstNamePlaceholder: "First name...",
      lastName: "Last name*",
      lastNamePlaceholder: "Last name...",
      organization: "Organization*",
      relation: "Contact relationship*",
      selectRelation: "Select relationship type",
      region: "Region*",
      selectRegion: "Select Region",
      province: "Province*",
      selectProvince: "Select Province",
      city: "City*",
      selectCity: "Select City",
      address: "Address and street number",
      addressPlaceholder: "Address...",
      zip: "ZIP",
      zipPlaceholder: "ZIP...",
      phone: "Phone number*",
      phonePlaceholder: "Phone...",
      cancel: "Cancel",
      save: "Save Contact",
      success: "Contact added successfully",
      error: "Error saving the contact",
      relations: {
        family: "family",
        friend: "friend",
        assistance: "assistance",
        medicalStaff: "medical staff",
        healthStaff: "healthcare staff",
        other: "other"
      },
      contactTypes: {
        person: "person",
        place: "place"
      },
      cityPlaceholder: "City...",
      delete: "Delete",
      edit: "Edit",
      cancel: "Cancel",
      save: "Save",
      confirm: "Yes, Confirm",
      confirmDeleteTitle: "Confirm deletion",
      confirmDeleteText: "Do you confirm you want to delete contact details for",
      updateSuccess: "Contact updated successfully",
      updateError: "Error saving the changes",
      deleteSuccess: "Contact deleted successfully",
      deleteError: "Unable to delete the contact"
    },
    PrenotazioniCittadinoMain: {
      newRequest: "New booking request",
      pending: "Pending",
      confirmed: {
        plural: "Confirmed",
        singular: "Confirmed"
      },
      history: "History",
      inactiveService: "Service not active."
    },
    UserReservations: {
      myBookings: "My bookings",
      assistiti: "Assisted patients",
      noReservations: "No reservations.",
      loadError: "Unable to retrieve recent reservations",
      updateSuccess: "Request successfully updated",
      genericError: "Unable to complete the operation",
      downloadError: "Unable to download the reminder",
      sendSuccess: "Request sent successfully"
    },
    DettaglioPrenotazioneCittadino: {
      cost: "cost {costo}",
      productRequest: "Product request",
      teleconsulto: "Teleconsultation",
      estimatedDate: "DATE AND TIME (ESTIMATED)",
      toConfirm: "To be confirmed",
      forWho: "On behalf of",
      requestCode: "REQUEST CODE",
      status: "STATUS",
      nameSurname: "NAME AND SURNAME",
      taxCode: "TAX CODE",
      booking: "Booking",
      location: "LOCATION",
      details: "Details",
      operationDate: "OPERATION DATE",
      yourNotes: "YOUR NOTES",
      purchase: "Purchase",
      date: "DATE"
    },
    UserDetailPrestazione: {
      attachments: "ATTACHMENTS",
      prescription: "PRESCRIPTION",
      download: "Download",
      questionnaireToFill: "QUESTIONNAIRE TO FILL IN",
      completeQuestionnaire: "Complete questionnaire",
      questionnaire: "QUESTIONNAIRE",
      questionnaireMin: "Questionnaire",
      openQuestionnaire: "open questionnaire",
      downloadPdf: "download as PDF",
      notes: "SERVICE NOTES:",
      operatorNotes: "OPERATOR NOTES",
      confirmBooking: "Confirm Booking",
      rejectChanges: "Reject Changes",
      cancelBooking: "Cancel Appointment",
      confirmCancelTitle: "Confirm Cancellation",
      confirmCancelMessage: "Are you sure you want to cancel this appointment?",
      confirm: "Yes, Confirm",
      cancel: "Cancel",
      loadQuestionnaireError: "Unable to retrieve the questionnaire",
      downloadError: "Unable to download the resource"
    },
    FilledSurveyShower: {
      totalScore: "Total score:",
      questions: "Questions",
      noFile: "--- no file uploaded",
      information: "Information notice"
    },
    ImageShower: {
      downloadAttachment: "download attachment",
      downloadError: "unable to retrieve the attachment"
    },
    PickMessageForm: {
      attachMessage: "Attach a message for the user:",
      noMessage: "No message",
      placeholder: "Write a message...",
      cancel: "No, close",
      confirm: "Yes, proceed"
    },
    UserDetailTeleconsulto: {
      expectedDuration: "EXPECTED DURATION",
      actualDuration: "ACTUAL DURATION",
      minutes: "minutes",
      prescription: "PRESCRIPTION",
      download: "Download",
      questionnaire: "QUESTIONNAIRE",
      openQuestionnaire: "open questionnaire",
      downloadPdf: "download as PDF",
      toFillQuestionnaire: "QUESTIONNAIRE TO FILL IN",
      completeQuestionnaire: "Complete questionnaire",
      teleconsultation: "TELECONSULTATION",
      goToTeleconsultation: "go to Teleconsultation",
      operatorNotes: "OPERATOR NOTES",
      notes: "NOTES",
      saveChanges: "Save Changes",
      confirmBooking: "Confirm Booking",
      rejectChanges: "Reject Changes",
      cancelBooking: "Cancel Booking",
      confirmCancelTitle: "Confirm Cancellation",
      confirmCancelMessage: "Are you sure you want to cancel this appointment?",
      confirm: "Yes, Confirm",
      cancel: "Cancel",
      questionnaireError: "Unable to retrieve the questionnaire",
      downloadError: "Unable to download the resource"
    },
    UserDetailProdotto: {
      medicalPrescription: "MEDICAL PRESCRIPTION",
      vetPrescription: "VETERINARY PRESCRIPTION",
      productsAvailable: "The prescribed products are available",
      productsNotAvailable: "The prescribed products are not available",
      reminder: "Remember to bring the prescription pin when collecting your order!",
      requestedProducts: "REQUESTED PRODUCTS",
      generic: "GENERIC",
      prescription: "Prescription",
      prescriptionNeeded: "required",
      prescriptionNotNeeded: "not required",
      product: "Product",
      available: "available",
      notAvailable: "not available",
      orderNotes: "ORDER NOTES",
      prescriptionShort: "PRESCRIPTION",
      noPrescriptionAttached: "No prescription attached",
      operatorNotes: "OPERATOR NOTES",
      saveChanges: "Save Changes",
      confirmOrder: "Confirm Order",
      rejectChanges: "Reject Changes",
      cancelOrder: "Cancel Order",
      confirmCancelTitle: "Confirm Cancellation",
      confirmCancelMessage: "Are you sure you want to cancel this appointment?",
      confirm: "Yes, Confirm",
      cancel: "Cancel",
      downloadError: "Unable to download the resource",
      download: "Download"
    },
    UpdateNotesComponent: {
      title: "Update your booking notes",
      description: "In this space you can add relevant information or messages for this specific booking.",
      newNote: "New note:",
      cancel: "Cancel",
      save: "Save",
      updateError: "It was not possible to update the notes"
    },
    UpdateReservationDate: {
      reschedule: "Reschedule",
      modalTitle: "Request change of date/time",
      currentDateTime: "Currently scheduled date and time:",
      selectNewDate: "Select new date and time*:",
      updateNotes: "Update notes",
      cancel: "Cancel",
      submit: "Submit",
      fetchError: "Unable to retrieve the request",
      submitError: "Unable to submit the request"
    },
    DatetimeSelection: {
      selectDateTime: "Select date and time",
      month: "Month",
      year: "Year",
      prev: "Previous",
      next: "Next",
      noAvailabilityThisWeek: "No availability for this week. Try checking the upcoming weeks.",
      noAvailabilityThisWeekMsg: "No availability for the selected week and service",
      noAvailabilityForService: "Unable to find availability for this service",
      infoNoAvailability: "The selected service has no availability for the current week",
      teleconsultDurationError: "Error retrieving teleconsultation duration. Please try again later.",
      months: {
        january: "January",
        february: "February",
        march: "March",
        april: "April",
        may: "May",
        june: "June",
        july: "July",
        august: "August",
        september: "September",
        october: "October",
        november: "November",
        december: "December"
      }
    },
    PreferenzeSelection: {
      selectPreferences: "Select preferred days and times",
      noPreference: "I have no particular preferences",
      hasPreference: "I want to specify preferences",
      preferredDate: "Preferred date*",
      preferredTimeSlot: "Preferred time slot*",
      datePlaceholder: "Select a date",
      labelHelp: "Use the arrows to browse dates",
      addPreference: "Add preference",
      saveAndContinue: "Save and continue",
      saveSelection: "Save selection",
      timeOptions: {
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        allDay: "all day"
      }
    },
    ChatComponent: {
      startChat: "Start chat",
      viewConversation: "View conversation",
      title: "Conversation",
      connectionError: "Unable to connect",
      messageSendError: "Unable to send the message",
      updateError: "Unable to update the conversation",
      fetchMessagesError: "Unable to retrieve previous messages",
      downloadError: "Unable to download the resource",
      loadingError: "Unable to load the chat",
      utenteConnesso: "...connected."
    },
    CardPrenotazioneCittadino: {
      waitingForPayment: "awaiting payment",
      waitingForConfirmation: "awaiting confirmation",
      location: "Location:",
      scheduledFor: "Appointment scheduled for:",
      costOnSite: "Cost on site:",
      memo: "Reminder",
      calendar: "Calendar",
      view: "View",
      pay: "Pay",
      ore: "at"
    },
    NuovoOrdineCittadino: {
      need: "What do you need",
      forWhom: "For whom",
      at: "At",
      cancel: "Cancel",
      date: "Date",
      confirm: "Confirm",
      summary: "Summary",
      noFacilities: "No facilities available for booking.",
      selectCompanyPreference: "Select a preference from the affiliated facilities",
      tryOtherFilters: "Try changing the search filters.",
      saveAndProceed: "Save and proceed",
      backToFacilities: "Back to facilities",
      availabilityPrompt: "INDICATE YOUR AVAILABILITY",
      selectedDates: "Selected dates:",
      fillQuestionnaire: "Fill out the questionnaire",
      service: "Service:",
      generic: "generic",
      reminder: "Remember to bring the prescription pin when collecting your order.",
      assignedStructureChoice: "Structure choice assigned to",
      preferenzeOrLocation: "Preferred structure",
      preferenzeFallback: "At",
      dateTimeSelected: "Selected date and time:",
      dateTimeEstimated: "Estimated date and time:",
      selectedPreferences: "Selected preferences:",
      attachedPrescription: "Attached prescription:",
      serviceFee: "Service handling cost:",
      vatExcluded: "VAT {iva}% excluded",
      totalDue: "Total due:",
      free: "Free of charge",
      operatorNote: "If you wish, add a note for the operator",
      operatorNoteProduct: "If you wish, add a note for the operator (e.g., a different delivery address)",
      confirmInstruction: 'By clicking "proceed" you will submit the booking request.',
      waitForOperator: "Wait for",
      operatorWillContactWithPayment: "an operator to contact you to confirm the booking and process the payment.",
      operatorWillContact: "an operator to contact you to confirm the booking.",
      readPolicy: "To proceed with the order confirmation, you must",
      acknowledgePolicy: "confirm that you have read the privacy policy",
      autoAssignProduct: "Let {app} choose the structure for you",
      autoAssignHealth: "Let {app} choose the healthcare facility for you",
      vatExcluded: "VAT {iva}% excluded",
      informRead: "I have read and understood",
      informativeLink: "the privacy policy",
      informConsent: "I consent to the processing of my personal data for the purposes stated in the privacy policy",
      proceed: "Proceed",
      viewReservation: "View reservation",
      downloadCalendar: "download calendar",
      downloadReminder: "download reminder",
      purchaseCompleted: "Purchase completed",
      purchasePending: "Purchase pending payment",
      informativaProdotto: "product policy",
      informativaPrestazione: "treatment policy",
      informativaTeleconsulto: "teleconsultation policy",
      genericError: "Unable to complete the operation.",
      preferencesUpdated: "Preferences updated successfully!",
      updatePreferencesError: "Unable to update preferences",
      noAvailabilityThisWeek: "The selected service has no availability for the current week",
      noAvailabilityThisService: "Unable to find availability for this service",
      noAvailabilityWeek: "No availability for the current week",
      bookingSuccess: "Booking submitted successfully!",
      bookingError: "Unable to submit the request",
      reminderDownloadError: "Unable to download the reminder",
      questionnaireSendError: "Unable to submit the questionnaire",
      paymentInfoError: "Unable to retrieve payment information",
      companyNotFound: "Unable to find companies for the selected service",
      downloadFailed: "Unable to download the resource",
      costo: "cost",
      timeSlots: {
        morning: 'morning',
        afternoon: 'afternoon',
        allday: 'all day'
      },
      preferenzaStruttura: "Preferred facility",
      presso: "At",
      preferenzeScelte: "Selected Preferences",
      informativa: "Policy"
    },
    CalendarioDisponibilitaGiornalieraCittadino: {
      chooseDateTime: "Choose date and time from available slots",
      labelHelp: "Use the arrows to navigate between dates",
      day: "day",
      noAvailability: "No availability for the selected day"
    },
    SearchCompany: {
      back: "Go back",
      noResults: "No results found with these search parameters.",
      rangeHelp: 'Use the "range" field to increase or decrease the search radius',
      geolocWarning: "To use this feature, you must allow location sharing.",
      allowConsent: "Grant consent",
      meters: "meters",
      repeatSearch: "Repeat search",
      searchByPosition: "Search using my current location",
      searchHelp: 'Fill in one or more fields and press "search" to view the results',
      labelRegion: "Region*",
      selectRegion: "Select Region",
      labelProvince: "Province*",
      selectProvince: "Select Province",
      labelMunicipality: "Municipality*",
      selectMunicipality: "Select Municipality",
      labelName: "Name",
      placeholderName: "Name...",
      requiredFields: "*required fields",
      clearFields: "Clear fields",
      search: "Search",
      increaseRange: "Increase search radius",
      clickToSetPreferredFromHome: 'Click the location you want to set as preferred and confirm by pressing "Confirm Choice"',
      clickToSetPreferred: 'Click your preferred location and confirm by pressing "Confirm Choice"',
      setAsPreferred: "Set as Preferred",
      cancel: "Cancel",
      confirm: "Confirm Choice",
      noResultsSearch: "No results for this search",
      successPreferences: "Preferences updated successfully!",
      errorPreferences: "Unable to update preferences"
    },
    FeverPrivacy: {
      titolo: "Fever Privacy Policy",
      logo_alt: "Fever Logo",
      pdf_title: "Fever privacy policy PDF document",
      pdf_aria_label: "PDF viewer for Fever privacy policy",
      scarica_pdf: "Download PDF",
      scarica_aria_label: "Download Fever privacy policy as PDF",
      indietro_aria_label: "Go back to previous page"
    },
    FillSurvey: {
      privacyIntro: "More details can be found in the",
      privacyPolicy: "Privacy Policy",
      termsIntro: "The terms of use are available",
      termsLink: "here",
      okProceed: "Ok, Proceed",
      back: "Go back",
      next: "Next",
      thankYou: "Thank you for completing the survey!",
      canContinueBooking: "You may proceed with the booking.",
      continue: "Continue",
      skip: "Skip"
    },
    SurveyUploader: {
      filesUploaded: "Files uploaded successfully!",
      fileUploaded: "File uploaded successfully!",
      remove: "Remove",
      upload: "Upload",
      select_file: "select file...",
      select_more_file: "select one or more file..."
    },
    NewSubjectSelection: {
      forMe: "For me",
      forFamilyMember: "For a family member",
      forAssisted: "For a patient of mine",
      chooseFamilyMember: "choose family member",
      chooseAssisted: "choose assisted person",
      noneRegistered: "You haven't registered any",
      continueToRegister: "Continue to register",
      registerNow: "register now",
      selectFamilyMember: "Select family member",
      selectAssisted: "Select assisted person",
      cannotFetchInfo: "Unable to retrieve the requested information",
      cannotFetchInfoShort: "Unable to retrieve the information."
    },
    ProductSelection: {
      productSelectionTitle: "Product Selection",
      searchInstruction: "Search the formulary for the products you need by typing at least 3 characters below:",
      searchLabel: "Search product",
      searchPlaceholder: "Search product...",
      noProductFound: "No product found",
      for: "for",
      selectOneOrMore: "Select one or more products from the formulary",
      selectProductsOption: "Select products...",
      selectProductOption: "Select product...",
      selectedProductsTitle: "Selected products list",
      quantityLabel: "Quantity:",
      generic: "Generic",
      cannotFindProduct: "I can't find the product I'm looking for",
      insertManualProduct: "Enter product not listed in formulary",
      manualProductLabel: "Product name*:",
      manualProductPlaceholder: "Enter product name...",
      add: "Add",
      prescriptionExplanation: "If you want to place an order for a medical or veterinary prescription, fill in one of the fields below. It is not necessary to manually enter the products already listed in the prescription.",
      insertNRECode: "Enter the code below",
      nreLabel: "Enter NRE prescription code",
      nrePlaceholder: "Enter NRE prescription...",
      insertREVCode: "If veterinary, enter the code below",
      revLabel: "Enter REV prescription code",
      revDescription: "*13 characters. Do not include the pin.",
      revPlaceholder: "Enter REV prescription...",
      pdfUploadAlt: "Alternatively, upload the prescription as a PDF",
      pdfUploadInstruction: "Upload the prescription in PDF format: the system will read the NRE code from the file and insert it in the appropriate field. Files uploaded here are not stored in the system. Code reading is only valid for NRE prescriptions; for veterinary ones, please enter the code manually.",
      scanWithCamera: "Or scan the NRE code using the camera",
      saveOrder: "Save order",
      prodotto: "Product:"
    },
    BarcodeComponent: {
      instructions:
        "Press the button below to activate the scanner. Once active, frame the two barcodes located at the top right of the prescription, one at a time from left to right (first the shorter code, then the longer one). Once the full code is detected, confirm that it matches the one written on the request.",
      scanWithCamera: "Scan code using device camera",
      cancelOperation: "Cancel Operation",
      codeDetected: "Code Detected:",
      invalidCode: "Invalid code",
      confirm: "Confirm",
      retry: "Retry"
    },
    NewPrestazioneSelection: {
      searchLabel: "Search for the visit or service you need",
      searchPlaceholder: "Enter the name of the service",
      skip_payment_label: "Request that no payment be required for this reservation"
    },
    PickHealthServiceFromCompany: {
      skip_payment_label: "Request that no payment be required for this reservation"
    },
    SkipPaymentCheckbox: {
      title: "Request reservation without payment",
      section_title: "The reservation:",
      standard_label: "follows standard payment rules",
      skip_label: "must be without payment",
      standard_description: "Payment will be applied based on the patient's subscription, any available free services, or the settings of projects the patient is enrolled in",
      skip_description: "No payment will be required, even without an active subscription and with free services still available",
      section_label: "Enable or disable reservation without payment request"
    },
    TeleconsultoSurveySelection: {
      reasonLabel: "Why are you requesting the consultation?",
      fetchError: "Unable to retrieve the questionnaires"
    },
    StepperButtons: {
      remainingFreeBookings: "Remaining free bookings",
      goBack: "Go Back",
      continue: "Continue"
    },
    PrivacyInfoComponent: {
      title: "INFORMATION ON THE PROCESSING OF PERSONAL DATA – ORDERS FOR ME / FOR FAMILY MEMBERS / ASSISTED PERSONS",

      whoProcessesData: "Who processes my data?",
      whoProcessesDataContent: `
    <p class="px-1 mb-0 border-bottom border-dark">
      The Data Controller is Qwince Innovation S.R.L.
    </p>
    <p class="px-1 mb-0 border-bottom border-dark">
      Registered office:
    </p>
    <p class="px-1 mb-0 border-bottom border-dark">
      Email address: info@concura.online / Certified email (PEC): qwince.legalmail.it
    </p>
    <p class="px-1 mb-0">
      Contact details of the Data Protection Officer (DPO): dpo@qwince.com.
    </p>
  `,

      controller: "Data Processor",
      controllerContent: `
    <p>The data processor is:</p>
    <p>Registered office:</p>
    <p>Email:</p>
    <p v-if="company.contatto_dpo" class="px-1 mb-0">
      Contact details of the Data Protection Officer (DPO): {{ company.contatto_dpo }}
    </p>
  `,

      section1Title: "1. FOR WHAT PURPOSES ARE MY / MY FAMILY MEMBER'S DATA PROCESSED AND WHY IS IT LEGITIMATE?",
      section1Content: `
    <p>The Controller processes your data to allow you to book orders for yourself or a family member/assisted person at the facility. This processing is lawful because:</p>
    <ul>
      <li>for common data (e.g., personal information), the processing is necessary for the execution of a contract;</li>
      <li>for health data, the processing is based on your consent, which you may provide by checking the appropriate box before submitting the order.</li>
    </ul>
  `,

      section2Title: "2. WHO IS MY / MY FAMILY MEMBER'S DATA SHARED WITH?",
      section2Content: `
    <p>Your data is shared with an IT consulting company and with Qwince Innovation S.R.L. for the management of the Platform. You may request the complete list of data recipients by writing to <a href="mailto:assistenza@concura.online" class="text-secondary">assistenza@concura.online</a>. Your data will not be publicly disclosed.</p>
  `,

      section3Title: "3. ARE MY / MY FAMILY MEMBER'S DATA TRANSFERRED OUTSIDE THE EUROPEAN UNION?",
      section3Content: `
    <p>Your data are not transferred outside the European Union.</p>
  `,

      section4Title: "4. HOW LONG ARE MY / MY FAMILY MEMBER'S DATA RETAINED?",
      section4Content: `
    <p>The Controller retains personal data for no longer than necessary to achieve the purposes for which the data is being processed. Specifically, your data will be stored for the entire period your profile remains active, and therefore until your profile is deactivated. After this period, unless legally required, the Controller will delete the data irreversibly using secure destruction or deletion methods or store it in anonymized form that does not allow identification, even indirectly.</p>
  `,

      section5Title: "5. WILL I BE SUBJECT TO PROFILING?",
      section5Content: `
    <p>Your data will never be used to gather information about your preferences or behavior, and you will not be subject to any decision based solely on automated processing of your personal data.</p>
  `,

      section6Title: "6. WHAT ARE MY RIGHTS?",
      section6Content: `
    <p>You have the following rights:</p>
    <ul>
      <li><b>Right of access:</b> the right to obtain confirmation as to whether your personal data is being processed and, if so, access to it and related information.</li>
      <li><b>Right to rectification:</b> the right to have inaccurate personal data corrected and incomplete data completed.</li>
      <li>
        <b>Right to erasure:</b> the right to have your personal data deleted without undue delay if:
        <ul>
          <li>the data are no longer necessary for the purposes for which they were collected or processed;</li>
          <li>the data were unlawfully processed;</li>
          <li>the data must be erased to comply with a legal obligation;</li>
          <li>the data were collected in relation to the offer of information society services.</li>
        </ul>
      </li>
      <li>
        <b>Right to restriction of processing:</b> applicable in the following cases:
        <ul>
          <li>you contest the accuracy of the data, for a period enabling verification;</li>
          <li>the processing is unlawful and you oppose deletion, requesting restriction instead;</li>
          <li>the controller no longer needs the data, but you require it for legal claims;</li>
          <li>you object to processing pending verification of the controller's legitimate grounds.</li>
        </ul>
      </li>
      <li><b>Right to data portability:</b> the right to receive your data in a structured, commonly used, machine-readable format and to transmit it to another controller, when processing is based on consent or contract and carried out by automated means.</li>
      <li><b>Right not to be subject to automated decision-making:</b> including profiling, if it produces legal effects or significantly affects you.</li>
    </ul>
    <p>You can exercise your rights by contacting the Controller by email. You will receive a response within 30 days.</p>
  `,
      section7Title: "7. AM I REQUIRED TO PROVIDE MY / MY FAMILY MEMBER'S DATA?",
      section7Content: `
    <p>You are free not to provide your data, but if you do not, you will not be able to proceed with the order.</p>
  `,
      section8Title: "8. HOW CAN I FILE A COMPLAINT?",
      section8Content: `
    <p>If you wish to file a complaint regarding how your personal data are processed or how your complaint was handled, you have the right to contact the supervisory authority via the procedures indicated at <a href="https://www.garanteprivacy.it" target="_blank">www.garanteprivacy.it</a>.</p>
  `,
      controllerLabel: "The data processor is:",
      controllerAddress: "Registered office:",
      controllerEmail: "Email:",
      controllerDPO: "Contact details of the Data Protection Officer (DPO):"
    },
    RiepilogoPrenotazione: {
      service: "Service:",
      generic: "generic",
      rememberPin: "Remember to bring the prescription PIN with you when you collect the order.",
      structureAssigned: "Facility selection managed by",
      selectedDateTime: "Selected date and time:",
      estimatedDateTime: "Estimated date and time:",
      downloadableDocs: "Downloadable Documents",
      docsNote: "There are documents related to this booking. You can view them by clicking on each one. Documents with fields to fill in must be downloaded, printed, completed, and presented at the appointment.",
      recommendations: "Recommendations",
      thankYou: "Thank you",
      forRequest: "for your booking request.",
      forBooking: "for your booking.",
      confirmationMessage: "You will soon receive a message from one of our operators to confirm the booking.",
      structurePreference: "Preferred Healthcare Facility:"
    },
    PickNuovaPrenotazioneType: {
      ricerca_per_visita: "Search by visit or service",
      ricerca_per_centro: "Search by provider center",
      skip_payment_label: "Request that no payment be required for this reservation",
      skip_payment_help: "The reservation will be marked as free"
    },
    PickCompanyOperator: {
      labelAssign: "Operator to assign to the booking",
      labelPreference: "Preferred Healthcare Professional",
      noPreference: "No Preference",
      emailDocumentiFirmatiInfo: "The selected operator will receive emails of documents signed during the service."
    },
    qui: "HERE",
    NewPreferenzeSelection: {
      insertAtLeast3: "Enter at least 3 preferences and time slots.",
      saveAndProceed: "Save and continue",
      saveSelection: "Save selection",
      selectDaysAndTimes: "Select preferred days and time slots",
      noPreference: "I have no particular preferences",
      wantToSpecify: "I want to specify preferences",
      labelHelp: "Use the arrows to navigate between dates",
      datePlaceholder: "Choose a date",
      timeSlotLabel: "Preferred time slot*",
      addPreference: "Add preference",
      timeOptions: {
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        allday: "all day"
      },
      dateLabel: "Preferred date*"
    },
    PreferenzePicker: {
      morning: "Morning",
      afternoon: "Afternoon",
      allday: "All day",
      days: {
        long: {
          monday: "Monday",
          tuesday: "Tuesday",
          wednesday: "Wednesday",
          thursday: "Thursday",
          friday: "Friday",
          saturday: "Saturday",
          sunday: "Sunday"
        },
        short: {
          monday: "M",
          tuesday: "T",
          wednesday: "W",
          thursday: "T",
          friday: "F",
          saturday: "S",
          sunday: "S"
        }
      },
      scegliFasciaOraria: "Choose your preferred time slot"
    },
    SearchCompanyFilters: {
      searchCenter: "Search provider center",
      namePlaceholder: "Name",
      type: "Type",
      region: "Region",
      province: "Province",
      municipality: "Municipality",
      zip: "ZIP code",
      zipPlaceholder: "ZIP"
    },
    CittadinoAgenda: {
      title: "Calendar",
      serviceInactive: "Service not active."
    },
    CalendarioCittadino: {
      month: "Month",
      year: "Year",
      previous: "Previous",
      next: "Next",
      showMondayOnly: "show only Monday",
      showTuesdayOnly: "show only Tuesday",
      showWednesdayOnly: "show only Wednesday",
      showThursdayOnly: "show only Thursday",
      showFridayOnly: "show only Friday",
      showSaturdayOnly: "show only Saturday",
      showSundayOnly: "show only Sunday",
      noRequests: "No requests here.",
      teleconsulto: "Teleconsultation",
      ordine: "Order",
      prestazioneSanitaria: "Healthcare service",
      evento: "Event",
      statusConfirmed: "Confirmed",
      statusCompleted: "Completed",
      statusForwarded: "Forwarded/Pending response",
      statusError: "Error/Rejected/Cancelled",
      fetchError: "Unable to retrieve bookings",
      updateSuccess: "Request successfully updated",
      genericError: "Operation failed",
      downloadError: "Unable to download reminder",
      months: {
        january: "January",
        february: "February",
        march: "March",
        april: "April",
        may: "May",
        june: "June",
        july: "July",
        august: "August",
        september: "September",
        october: "October",
        november: "November",
        december: "December"
      },
      daysShort: {
        mon: "Mon",
        tue: "Tue",
        wed: "Wed",
        thu: "Thu",
        fri: "Fri",
        sat: "Sat",
        sun: "Sun"
      },
      rangeDate: "{start} - {end}"
    },
    Eventi: {
      nuovoEvento: "New Event",
      nomeLabel: "Event Name*",
      luogoLabel: "Location*",
      dataLabel: "Date*",
      dataPlaceholder: "Select a date",
      oraLabel: "Time*",
      noteLabel: "Notes",
      notePlaceholder: "Add notes (optional)",
      parametriObbligatori: "*required fields",
      salva: "Save",
      salvaModifiche: "Save Changes",
      modifica: "Edit Event",
      elimina: "Delete Event",
      annullaModifiche: "Cancel Changes",
      confermaElimina: "Do you confirm you want to delete the event?",
      okElimina: "Yes, delete",
      annullaElimina: "No, cancel",
      testoConfermaElimina: `If confirmed, the event {titolo} will be permanently deleted.`,
      titoloNuovo: "New Event",
      titoloModifica: "Edit Event",
      titoloDettagli: "Event Details",
      successoModifica: "Event updated successfully",
      erroreModifica: "Error updating the event",
      successoCreazione: "Event created successfully",
      erroreCreazione: "Error creating the event",
      successoEliminazione: "Event deleted successfully",
      erroreEliminazione: "Error deleting the event"
    },
    CalendarioCittadinoMobile: {
      labelHelp: "Use the arrows to navigate between dates",
      day: "day",
      loading: "loading",
      noRequests: "No requests here.",
      teleconsulto: "Teleconsultation",
      ordine: "Order",
      prestazioneSanitaria: "Healthcare service",
      evento: "Event",
      statusConfirmed: "Confirmed",
      statusCompleted: "Completed",
      statusForwarded: "Forwarded/Pending response",
      statusError: "Error/Rejected/Cancelled",
      fetchError: "Unable to retrieve bookings",
      updateSuccess: "Request updated successfully",
      operationError: "Operation could not be completed",
      downloadError: "Unable to download reminder",
      requestSuccess: "Request sent successfully"
    },
    PreviewConsultoCittadino: {
      avvia: "Start",
      termina: "End",
      consulto: "Consultation",
      questionario: "Your questionnaire",
      tempoRimanente: "Time remaining",
      status: "status",
      durata: "Duration",
      consultoConcluso: "Consultation completed.",
      vaiAiReferti: "Go to your reports",
      consultiPrevisti: "Consultations scheduled for today",
      ora: "Time",
      con: "with",
      durataPrevista: "expected duration",
      minuti: "minutes",
      nessunConsulto: "No consultations scheduled for today",
      abbonamentoNonAttivo: "Unfortunately, the selected pharmacy no longer has an active subscription for the service.",
      erroreRichieste: "Unable to retrieve requests",
      connessione: {
        attesa: "Waiting for connection...",
        inCorso: "Connecting...",
        connesso: "Connected.",
        fallita: "Connection failed. End and restart the session.",
        abbandonato: "The user has left the consultation."
      },
      documentiDaFirmare: {
        titolo: "Document to sign",
        titoloMultipli: "Documents to sign",
        caricamentoDocumenti: "Loading documents...",
        firmato: "Signed",
        firma: "Sign",
        documentiCompletati: "Documents signed!",
        tuttiDocumentiFirmati: "All documents have been signed successfully",
        riduzioneAutomatica: "Auto-minimize",
        firmati: "Signed",
        documentiFirmati: "Signed documents",
        firmatoIl: "signed on"
      }
    },
    DocumentSigningModal: {
      firmaDocumento: "Sign Document",
      caricamentoDocumento: "Loading document...",
      leggiAttentamente: "Please read the document carefully before proceeding with digital signature.",
      scorriFineFondo: "Scroll to the bottom of the document to enable signing.",
      puoiProcedere: "You have read the entire document. You can proceed with signing.",
      scarica: "Download",
      scaricamento: "Downloading...",
      scorriDocumento: "Scroll the document to enable signing",
      scorriAbilitare: "Scroll through the entire document to enable signing",
      scorriPercentuale: "Scroll document ({percentuale}%)",
      documentoFirmato: "Document signed successfully",
      caricamentoDatiUtente: "Loading user data...",
      erroreFirma: "Error signing document",
      erroreCaricamento: "Error loading document",
      erroreDownload: "Error downloading document",
      documentoFirmatoSuccesso: "Document signed successfully",
      emailInviata: "An email with the signed document has been sent to you and healthcare staff"
    },
    VideoCaller: {
      attesaCollegamento: "Waiting for the other user to connect...",
      reteAssente: "No internet signal.",
      connectionStatus: {
        1: "Opening new secure connection channel...",
        2: "Secure connection initialized...",
        3: "Connecting...",
        4: "Connected!",
        5: "Connection error, closing secure channel...",
        6: "Connection error, secure channel closed.",
        7: "The user left the consultation. Teleconsultation ended.",
        8: "The user left the consultation. Teleconsultation ended."
      },
      clientStatus: {
        1: "New client",
        2: "Client connected to the internet",
        3: "Internet connection interrupted. Please check your device's connectivity."
      },
      connessioneFallita: "Unable to connect",
      avvioMediaFallito: "Unable to start camera and/or microphone",
      connessioneNonRiuscita: 'Unable to connect. Click "End" and restart the session.',
      connessioneStabilita: "Connection established.",
      connessioneSconosciuta: "Unknown connection status",
      connessioneInstabile: "Unable to establish a stable connection. Please end and restart the consultation."
    },
    MessagingComponent: {
      chat: "Chat",
      invio: "sending",
      connessioneFallita: "Unable to connect",
      connesso: "...connected to the chat",
    },
    PrenotazioniTeleconsultoCittadino: {
      nuovaRichiesta: "New booking request",
      inSospeso: "Pending",
      confermati: "Confirmed",
      confermate: "Confirmed",
      storico: "History",
      servizioNonAttivo: "Service not active."
    },
    RichiesteEmergenzaCittadinoMain: {
      titolo: "My requests",
      aggiornamento: "Updating...",
      nessunaRichiesta: "No requests here.",
      modalTitle: "Quick Teleconsultation",
      modalOk: "Start now",
      programmato: "Scheduled at",
      servizioNonAttivo: "Service not active.",
      erroreRichieste: "Unable to retrieve requests"
    },
    DettaglioRichiestaEmergenza: {
      attesaRisposta: "waiting for response",
      terminato: "Completed",
      programmato: "Scheduled",
      annullato: "Cancelled",
      dataRichiesta: "Request date",
      orarioRichiesta: "Request time",
      teleconsultoCon: "Teleconsultation with",
      prenotazionePer: "Booking made for",
      avviaOra: "Start now"
    },
    CircoloCura: {
      titolo: "Your circle of care",
      aggiungiNuovo: "add new",
      consigliati: "Recommended for you",
      nessunElemento: "No items in your circle of care.",
      area: "Area",
      sede: "location",
      mioCircolo: "My circle of care",
      contatti: "Contacts",
      email: "email",
      telefono: "phone",
      apertura: "Opening",
      chiuso: "Closed",
      nonInseriti: "Not provided",
      prenota: "Book",
      impostaPreferito: "Set as favorite",
      rimuoviCircolo: "Remove from my circle of care",
      rimossoSuccesso: "Item removed successfully!",
      rimossoErrore: "Unable to remove the selected item",
      preferenzeAggiornate: "Preferences updated successfully!",
      preferenzeErrore: "Unable to update preferences",
      infoErrore: "Unable to retrieve information",
      aggiungiTooltip: "Add to your circle of care"
    },
    AddMedicoModal: {
      invitaMedico: "invite my doctor",
      titleTooltip: "Invite your doctor to ",
      nomeLabel: "First Name*",
      nomePlaceholder: "First name...",
      cognomeLabel: "Last Name*",
      cognomePlaceholder: "Last name...",
      cittaLabel: "City*",
      cittaPlaceholder: "City...",
      emailLabel: "Email",
      emailPlaceholder: "Email...",
      campiObbligatori: "*Required fields",
      invia: "Invite",
      successo: "Doctor invited successfully!",
      erroreInvito: "Unable to invite the doctor"
    },
    SottoscrizioniCittadinoMain: {
      acquisti: "Purchases",
      acquisto: "Purchase",
      gestione: "Management",
      storico: "History",
      sottoscriviAbbonamento: "Subscribe to a plan",
      acquistaAbbonamento: "Purchase subscription",
      acquistaPrenotazione: "Purchase reservation",
      storicoAcquisti: "Purchase history",
      riepilogo: "Summary",
      abbonamento: "Subscription",
      sottoscrizione: "Plan",
      ivaInclusa: "VAT included",
      ivaEsclusa: "+ VAT",
      mese: "Month",
      mesi: "Months",
      anno: "Year",
      servizio: "Service",
      costiServizio: "Service management costs",
      codiceSconto: "Discount Code",
      voucher: "Voucher discount code",
      totale: "Total",
      imponibile: "Taxable amount",
      iva: "VAT",
      sottoscrivi: "Subscribe",
      rinnovoAutomatico: "*The subscription renews automatically",
      ogniMese: "every month",
      ogni: "every",
      riprova: "Retry",
      attesaPagamento: "Purchase pending payment",
      homepage: "Homepage",
      completata: "Subscription to plan completed",
      ore: "at",
      interrompibile: "Automatic renewal can be canceled at any time.",
      completed: "completed",
      erroreGenerico: "The operation could not be completed.",
      errorePagamento: "Unable to retrieve payment information",
      sottoscrizioneSuccesso: "Subscription completed",
      erroreSottoscrizione: "Subscription could not be completed",
    },
    PianiTerapeuticiScheda: {
      titolo: "Therapeutic Plans",
      nuovoPiano: "new therapeutic plan",
      nessunRisultato: "No results found.",
      piano: "Therapeutic Plan",
      validoDal: "valid from",
      al: "to",
      dal: "from",
      somministraQuestionario: "Administer questionnaire",
      pianoInvalidato: "The plan has been invalidated by the ASL.",
      rinnovoRifiutato: "Supply renewal was rejected by the ASL.",
      motivazioni: "Reasons:",
      pacchetto: "Package",
      stato: "Status",
      il: "on",
      etichetta: "Label:",
      contenuto: "Content:",
      quantità: "Quantity:",
      lotto: "Batch:",
      scadenza: "Expiration:",
      noteAsl: "ASL Notes:",
      nessunPacchetto: "No packages scheduled for this plan yet.",
      nessunElemento: "No items among the plans",
      caricaPiano: "Upload new Therapeutic Plan",
      annulla: "Cancel",
      salva: "Save",
      documento: "Document",
      fileCaricato: 'File uploaded successfully.',
      validitàPiano: "Plan validity",
      farmaciInclusi: "Drugs included in the plan",
      selezionaTerapie: "Select therapies*",
      scegliTerapie: "Choose therapies",
      annotazioni: "Notes",
      inserisciNote: "Enter any notes related to the Therapeutic Plan",
      salvaPiano: "Save Plan",
      confermaOperazione: "Confirm Operation",
      noAnnulla: "No, Cancel",
      siElimina: "Yes, delete",
      seiSicuro: "Are you sure you want to delete this plan?",
      conferma: "Confirm",
      rinnovoPerFarmaci: "For which drugs do you want to request renewal?",
      questionarioPaziente: "Patient Questionnaire",
      informativaPaziente: "Patient Information",
      consentoInformativa: "I have delivered/communicated the information to the citizen",
      procedi: "Proceed",
      operazioneCompletata: "Operation completed.",
      istruzioniCaricamento: "Each time a new Therapeutic Plan is issued and brought to the pharmacy, review and update the patient's record with particular attention to the therapies section, where the drugs prescribed in the plan must be entered. After updating the patient's record, proceed with uploading the plan; once uploaded, it is necessary to specify the plan's validity dates and select the drugs included using the \"select therapies\" menu. Click \"save plan\" to complete the operation: the competent ASL office will be notified and will take charge of the plan. When the drug is ready for delivery, the ASL will notify both the pharmacy staff and the patient.",
      ricordaInserimento: "Remember to enter and verify the prescribed drugs under therapies before uploading the Therapeutic Plan. To request renewal of an already uploaded and valid plan, do not upload a new plan, but use the \"supply renewal\" function on the completed therapeutic plan row.",
      descrizioneScarica: "By clicking on the \"download pdf for the patient\" button, you can download the completed questionnaire in a printable version, including the information sheet (if present) and a dedicated signature area. You can still download the PDF and the questionnaire in other formats from the dedicated reporting section.",
      chiudiFinestra: "close window",
      scaricaPdf: "download pdf for the patient",
      servizioNonAbilitato: "Service not enabled",
      placeholderCerca: "Search ID...",
      rinnovoFornitura: "Supply renewal",
      somministraQuestionario: "Administer questionnaire",
      caricaNuovoPiano: "Upload new Therapeutic Plan",
      annulla: "Cancel",
      noAnnulla: "No, Cancel",
      salva: "Save",
      siElimina: "Yes, delete",
      conferma: "Confirm",
      confermaOperazione: "Confirm Operation",
    },
    CambiaStatoConsegna: {
      cambia: "Change",
      aggiorna: "Update",
      stato: "status",
      title: "Update delivery package status",
      ok: "Confirm",
      annulla: "Cancel",
      selezionaStato: "Select the new status of package",
      inPreparazione: "in preparation",
      prontoRitiro: "ready for pickup",
      ritiratoProntoConsegna: "picked up, ready for delivery to the patient",
      consegnato: "delivered to the patient",
      reso: "returned by the patient",
      successo: "Package status updated successfully",
      errore: "Unable to update the package status"
    },
    CompilaQuestionarioOperatore: {
      domandaOperatore: "- question for the operator",
      scegliOpzioni: "select one or more options...",
      aggiungiAltro: "add another",
      placeholderAltro: "other custom option",
      invia: "Submit"
    },
    GestioneSottoscrizioni: {
      titolo: "Subscription Management",
      visualizzaTutte: "View all subscriptions",
      pianoAttivo: "Active plan",
      durataMinima: "Minimum duration:",
      mese: "month",
      year: "year",
      siRinnovaIl: "Renews on",
      scadraIl: "Expires on",
      leggiDiPiu: "Read more",
      prestazioniDisponibili: "Available services:",
      ordineFarmaci: "Available medication orders:",
      teleconsultoRapido: "Rapid Teleconsultation:",
      teleconsultoPediatrico: "Pediatric Teleconsultation:",
      gratis: "FREE",
      altreSottoscrizioni: "Other Subscriptions",
      contattaci: "Contact us",
      acquista: "Purchase",
      completaAcquisto: "Complete purchase",
      elimina: "Delete",
      confermaAnnullamento: "Do you confirm to cancel the subscription",
      siCancella: "Yes, cancel",
      noAnnulla: "No, cancel",
      piani: "Plans",
      erroreGenerico: "The operation could not be completed.",
      sottoscrizioneEliminata: "Subscription successfully deleted.",
      dataFineModificata: "Subscription end date updated successfully.",
      rinnovoStatoSuccesso: "Subscription renewal {{stato}} successfully.",
      attivato: "enabled",
      disattivato: "disabled"
    },
    SendHelpRequest: {
      titolo: "Support",
      descrizione: "Select the option that best describes your request, then write your message and click 'send request': the system will forward an email to the support center, which will handle your request as soon as possible. Depending on the request, you may receive a reply via email or be contacted by phone.",
      campiObbligatori: "*Required fields",
      inviaRichiesta: "Send Request",
      titoloModale: "Support Request",
      oggettoLabel: "Subject*",
      messaggioLabel: "Message*",
      selezionaOggetto: "Select a subject",
      richiestaInformazioni: "Information request",
      richiestaImplementazione: "Feature request",
      malfunzionamento: "Bug report",
      correzioneDati: "Incorrect data correction",
      successo: "Support request successfully sent",
      errore: "Unable to send the request",
      testoRichiestaFullMonitor: "I would like to know more about the ConCura Full Monitor subscription"
    },
    EditSubscription: {
      titolo: "Edit Subscription",
      infoInizio: "You can set an end date for the subscription, or disable automatic renewal.",
      infoGiaImpostata: "You have already set a subscription end date.",
      infoModificaVincolo: "You can only change the auto-renewal status if no end date is set.",
      infoAzzeraPerModificare: "To disable auto-renewal, first clear the end date.",
      infoRiabilitaPerDataFine: "You can only set an end date if auto-renewal is enabled. Re-enable it to select a final date.",
      rinnovoIl: "The subscription will renew on",
      scadraIl: "The subscription will expire on",
      attivaProssimoPagamento: "The subscription is active and the next payment is scheduled for",
      gestisciRinnovo: "Manage Auto-Renewal",
      rinnovoAutomatico: "Auto-renewal",
      impostaDataFine: "Set a subscription end date",
      descrizioneDataFine: "For subscriptions with enabled auto-renewal, an end date can be set. From that date, renewal will stop.",
      nessunaData: "No end date set.",
      impostaData: "Set end date",
      modificaData: "An end date is already set. You can modify or clear it.",
      selezionaPeriodo: "Select",
      unMeseE: "a month and",
      unAnno: "a year for the subscription end date",
      annoFine: "End year",
      imposta: "Set date",
      azzera: "Clear",
      validazioneData: "The end date must be later than the next payment date",
      gennaio: "January",
      febbraio: "February",
      marzo: "March",
      aprile: "April",
      maggio: "May",
      giugno: "June",
      luglio: "July",
      agosto: "August",
      settembre: "September",
      ottobre: "October",
      novembre: "November",
      dicembre: "December",
      meseFine: "End month"
    },
    StoricoAcquisti: {
      nessunAcquisto: "No purchases made.",
      visualizzaAcquisti: "View Purchases",
      mostraProforma: "Show Proforma Invoice",
      descrizione: "Description",
      stato: "Status",
      erroreGenerico: "The operation could not be completed.",
      idTransazione: "Transaction ID",
      importo: "Amount",
      esito: "Result",
      dataPagamento: "Payment Date",
      azioni: "Actions", 
      acquisti:"Purchases"
    },
    SubscriptionVoucherValidator: {
      labelCodice: "Do you have a discount code? Enter it here:",
      conferma: "Confirm",
      voucherNonValido: "Invalid voucher"
    },
    ProgettiMain: {
      servizioNonAbilitato: "Service not enabled",
      contattaci: "Contact us",
      perAbilitare: "to learn more or to enable the service",
      confermaEliminazione: "Are you sure you want to delete the selected post?",
      siElimina: "Yes, delete",
      noAnnulla: "No, cancel",
      caricaArticolo: "Upload an article",
      modificaArticolo: "Edit article",
      inserisci: "Insert a",
      modifica: "Edit",
      webinar: "Webinar",
      video: "Video",
      servizioNonAttivo: "Service not active.",
      erroreServizi: "Error retrieving services",
      errorePost: "Error retrieving posts",
      postCreato: "Post created successfully",
      erroreCreazione: "Error creating post",
      postModificato: "Post updated successfully",
      erroreModifica: "Error updating post",
      postEliminato: "Post deleted successfully",
      erroreEliminazione: "Error deleting post"
    },
    ProjectPanoramica: {
      benvenuto: "Welcome to the Blog of",
      articoli: "Articles",
      vediTutti: "See all",
      nuovoArticolo: "new article",
      nessunArticolo: "No articles available at the moment.",
      video: "Videos",
      nuovoVideo: "new video",
      nessunVideo: "No videos available at the moment.",
      nuovoWebinar: "new webinar",
      nessunWebinar: "No webinars available at the moment.",
      videoTipoWebinar: "Webinar-type video"
    },
    ProjectDetail: {
      tornaIndietro: "Go back",
      nuovo: "new",
      cerca: "Search",
      nessunElemento: "There is nothing to show",
      cercaPerTitolo: "Search by Title",
      cercaPerData: "Search by Date",
      nonCiSono: "There are no",
      daMostrare: "to show",
      subsection: {
        articolo: "articles",
        video: "videos",
        webinar: "webinars",
        evento: "events"
      }
    },
    CreateEditArticle: {
      immagineCopertina: "Cover image",
      titolo: "Title*",
      placeholderTitolo: "Enter the article title",
      contenuto: "Content*",
      placeholderContenuto: "Article content",
      data: "Date",
      abilitato: "Enabled",
      disabilitato: "Disabled",
      campiObbligatori: "* required fields",
      salva: "Save",
      modifiche: "changes",
      nuovoArticolo: "new article"
    },
    CreateEditVideo: {
      immagineCopertina: "Cover image*",
      erroreCopertina: "Please upload a cover image",
      titolo: "Title*",
      placeholderTitolo: "Enter the video title",
      abilitato: "Enabled",
      disabilitato: "Disabled",
      categoriaWebinar: "Webinar Category",
      tipoWebinar: "This video is a Webinar",
      tipoNonWebinar: "This video is not a Webinar",
      campiObbligatori: "* required fields",
      salva: "Save",
      modifiche: "changes",
      nuovoVideo: "new video"
    },
    ProfiloSanitarioMain: {
      archivioSanitario: "Health Archive",
      patologie: "Conditions",
      terapie: "Therapies",
      piani: "Therapeutic Plans",
      note: "Notes",
      dispositivi: "Devices",
      accessi: "Recorded activity",
      servizioNonAttivo: "Service not active.",
      errore: "The operation could not be completed.",
      anamnesi: "Anamnesis"
    },
    LineChart: {
      gennaio: "January",
      febbraio: "February",
      marzo: "March",
      aprile: "April",
      maggio: "May",
      giugno: "June",
      luglio: "July",
      agosto: "August",
      settembre: "September",
      ottobre: "October",
      novembre: "November",
      dicembre: "December",
      ordiniAlMese: "Orders per month"
    },
    ArmadiettoComponent: {
      terapieInAtto: "Active therapies",
      prospettoTerapie: "Therapy Overview",
      nuovaTerapia: "new therapy",
      sospesa: "Suspended",
      finoAl: "Until",
      dal: "From",
      elimina: "Delete",
      vedi: "View",
      storicoTerapie: "Therapy History",
      terminataIl: "Ended on",
      nessunElemento: "No items in history",
      modificaTerapia: "Edit therapy",
      dettaglioTerapia: "Therapy details",
      perPatologia: "for condition",
      patologia: "condition",
      modifica: "Edit",
      riprendi: "Resume",
      sospendi: "Suspend",
      scaricaPromemoria: "Download reminder",
      inseritaIl: "Inserted on",
      conferma: "Confirm",
      noAnnulla: "No, Cancel",
      siConferma: "Yes, Confirm",
      confermiSospRipr: "Do you confirm you want to",
      sospendere: "suspend",
      riprendere: "resume",
      laTerapia: "the therapy?",
      confermaEliminazione: "Confirm deletion",
      confermiEliminazione: "Do you confirm you want to delete the therapy?",
      erroreRecupero: "Unable to retrieve therapies",
      terapia: "Therapy",
      sospesa: "suspended",
      ripresa: "resumed",
      erroreOperazione: "The operation could not be completed",
      eliminata: "Therapy deleted!",
      erroreEliminazione: "Unable to delete the therapy",
      erroreDownloadPromemoria: "Unable to download the reminder",
      erroreDownloadProspetto: "Unable to download the overview.",
      mattina: "morning",
      meta_mattina: "mid-morning",
      pranzo: "lunch",
      pomeriggio: "afternoon",
      sera: "evening",
      notte: "night"
    },
    RecapTherapyModal: {
      posologia: "Dosage",
      di: "of",
      perVia: "by route",
      daFinoA: "From {{start}} to {{end}}",
      daAssumere: "To be taken",
      durata: "Duration",
      terapiaOgni: "The therapy must be taken every",
      per: "for",
      aPartireDa: "starting from",
      cronica: "chronic",
      prescrittore: "Prescriber",
      effettiCollaterali: "Side Effects",
      reazioniAllergiche: "Allergic Reactions",
      interazioni: "Interactions",
      annotazioni: "Notes",
      non_indicata: "not indicated",
      non_indicate: "not indicated",
      non_indicato: "not indicated",
      non_indicati: "not indicated",
      nessuna_nota: "no notes",
      typesMap: {
        Compresse: "tablet",
        Capsule: "capsule",
        Gocce: "drop",
        Inalazioni: "inhalation",
        Buste: "sachet",
        Supposte: "suppository",
        Scatole: "box",
        Cerotti: "patch",
        Fiale: "vial",
        Fleboclisi: "IV infusion",
        Ovuli: "ovule",
        Sacche: "bag",
        Flaconi: "bottle",
        Confezioni: "package",
        Kilogrammi: "kilogram",
        Kit: "kit",
        Millilitri: "milliliter",
        Milligrammi: "milligram",
        Applicazioni: "application",
        UI: "IU"
      },
      forEveryUmsSing: {
        0: "month",
        1: "week",
        2: "day"
      },
      forEveryUmsPlur: {
        0: "months",
        1: "weeks",
        2: "days"
      },
      assunzioni: {
        mattina: "morning",
        meta_mattina: "mid-morning",
        pranzo: "lunch",
        pomeriggio: "afternoon",
        sera: "evening",
        notte: "night"
      }
    },
    NuovaTerapiaCittadino: {
      profiloSanitario: "Health profile",
      riepilogo: "Summary",
      scaricaPromemoria: "Download reminder",
      erroreDownloadPromemoria: "Unable to download the reminder"
    },
    NewTherapy: {
      titoloPatologia: "Condition for which the therapy was prescribed",
      indicaPatologia: "specify condition",
      nonIndicare: "do not specify",
      farmacoIndicato: "Prescribed medication",
      labelCercaFarmaco: "Search medication",
      placeholderCercaFarmaco: "Search by name or AIC...",
      labelSelezionaFarmaco: "Select medication*",
      prodottoNonTrovato: "Product not found",
      frequenzaModalitaDosaggio: "Frequency, method and dosage of administration",
      dosaggio: "Dosage*",
      frequenza: "Frequency*",
      alDi: "per day",
      alBisogno: "as needed",
      ogni: "every",
      ore: "hours",
      giorni: "days",
      daAssumere: "To be taken",
      mattina: "Morning",
      metaMattina: "Mid-morning",
      pranzo: "Lunch",
      pomeriggio: "Afternoon",
      sera: "Evening",
      notte: "Night",
      maxUnoAssunzione: "With this frequency you can select at most one intake time",
      inviaAlert: "Send alert 10 minutes before administration",
      durataTerapia: "Therapy duration",
      indeterminata: "undetermined",
      periodica: "periodic/cyclic",
      occasionale: "occasional",
      mesi: "months",
      settimane: "weeks",
      giorni: "days",
      ogni: "Every",
      aPartireDal: "Starting from*",
      finoAl: "Until*",
      visibileSoloMe: "**if you select this option, only you will be able to view this therapy",
      dettagli: "Details",
      prescrittore: "Prescribing physician*",
      indicaPrescrittore: "specify who prescribed the therapy",
      fonte: "Information source*",
      indicaFonte: "specify the information source",
      effettiCollaterali: "Side effects",
      placeholderEffetti: "any side effects attributed to the medication...",
      reazioniAllergiche: "Allergic reactions",
      placeholderAllergie: "any allergic reactions attributed to the medication...",
      interazioni: "Interactions",
      placeholderInterazioni: "possible interactions with medications or foods...",
      annotazioni: "Notes",
      salva: "Save therapy",
      visibileSoloMe: "**if you select this option, only you will be able to view this therapy",
      posologyTypes: {
        Compresse: "Tablets",
        Capsule: "Capsules",
        Gocce: "Drops",
        Inalazioni: "Inhalations",
        Buste: "Sachets",
        Supposte: "Suppositories",
        Scatole: "Boxes",
        Cerotti: "Patches",
        Fiale: "Vials",
        Fleboclisi: "IV Infusion",
        Ovuli: "Ovules",
        Sacche: "Bags",
        Flaconi: "Bottles",
        Confezioni: "Packages",
        Kilogrammi: "Kilograms",
        Kit: "Kit",
        Millilitri: "Milliliters",
        Milligrammi: "Milligrams"
      },
      posologyVias: {
        Orale: "Oral",
        Transdermica: "Transdermal",
        Nasale: "Nasal",
        Endovena: "Intravenous",
        Intramuscolo: "Intramuscular",
        Oftalmica: "Ophthalmic",
        Rettale: "Rectal",
        Uretale: "Urethral",
        Vaginale: "Vaginal",
        Sottocute: "Subcutaneous"
      },
      everyUms: {
        0: "months",
        1: "weeks",
        2: "days"
      },
      everyPosologyTypes: {
        0: "day",
        1: "hours",
        2: "as needed"
      },
      everyPosologyUms: {
        1: "hours",
        2: "days"
      },
      successSalvataggio: "New therapy saved",
      erroreSalvataggio: "An error occurred while saving",
      erroreGenerico: "An error occurred.",
    },
    AccessLogs: {
      titolo: "Recorded activity on your health profile",
      mese: "month",
      anno: "Year",
      nessunAccessoMese: "No activity for this month.",
      nessunAccessoAnno: "No activity in the selected year.",
      nessunaAzione: "No activity in the selected period",
      erroreNote: "Unable to retrieve notes",
      filtro_elementi: "Items per page",
      take_label: "Items per page",
      day_label: "Day",
      month_label: "Month",
      year_label: "Year",
      tutti_giorni: "All",
      opzione_elementi: "Show {count} items",
      azione_label: "Recorded activity",
      data_label: "Date and time",
      azienda_label: "Facility",
      operatore_sconosciuto: "Operator not available",
      company_missing: "Not available",
      azione_sconosciuta: "Activity not specified",
      mesi: {
        "01": "January",
        "02": "February",
        "03": "March",
        "04": "April",
        "05": "May",
        "06": "June",
        "07": "July",
        "08": "August",
        "09": "September",
        10: "October",
        11: "November",
        12: "December"
      }
    },
    nessunaImpostazione: "No settings for this user",
    AccessoEPermessi: {
      datiAccesso: "Access Data",
      modificaPasswordTemporanea: "Change your temporary password",
      passwordScaduta: "Your password has expired: please update it to continue.",
      username: "Username",
      password: "Password",
      cambiaPassword: "Change Password",
      terminiEPrivacy: "Terms and Conditions and Privacy Policy",
      visioneTermini: "You have reviewed the",
      revocaTermini: "You have withdrawn your consent to the",
      titoloTermini: "Terms and Conditions of Service",
      modifica: "Edit",
      visionePrivacy: "You have reviewed the",
      revocaPrivacy: "You have withdrawn your consent to the",
      titoloPrivacy: "Privacy Policy",
      visionati1341: "You have expressly reviewed, pursuant to Article 1341 et seq. of the Civil Code, the provisions of Articles 2, 7, 8, 10, 12 of these Terms",
      revocati1341: "You have withdrawn consent to Articles 2, 7, 8, 10, 12 of these Terms",
      acconsentoComunicazioni: "You have consented to receive promotional communications as described in the",
      nonAcconsentoComunicazioni: "You have not consented to receive promotional communications as described in the",
      titleConsensoComunicazioni: "Consent to marketing communications",
      acconsento: "I consent to receiving promotional communications as described in the Privacy Policy",
      nonAccetto: "I do not accept",
      annulla: "Cancel",
      salva: "Save changes",
      titleModificaPassword: "Change your password",
      passwordAttuale: "Current Password*",
      placeholderAttuale: "Current password...",
      nuovaPassword: "Password*",
      confermaPassword: "Confirm Password*",
      placeholderConferma: "Confirm password...",
      requisitiPassword: "The password must not include your first or last name and must be at least 8 characters long, including one number, one uppercase letter, one lowercase letter, and one",
      tooltipCaratteri: "You must use at least one special character from ! @ # $ % ^ & * ) ( + = . _ -",
      carattereSpeciale: "special character",
      passwordDiversa: "The new password must be different from the current one.",
      annullaOperazione: "Cancel Operation",
      confermaModifica: "Confirm Change",
      siRevoca: "Yes, revoke permission",
      noAnnulla: "No, cancel",
      revocaNecessaria: "Consent is required to use the platform. By withdrawing your consent, you will no longer be able to use the platform's features.",
      desideriRevoca: "Do you wish to proceed with revoking your consent?",
      revoca: {
        data_consense: "Do you want to withdraw consent to the Terms and Conditions of use?",
        share_consense: "Do you want to withdraw consent to articles 2, 7, 8, 10, 12 of the Terms and Conditions of use?",
        charge_consense: "Do you want to withdraw consent to the Privacy Policy?"
      },
      successModifica: "Changes saved successfully",
      erroreModifica: "It was not possible to save the changes",
      modificaPasswordTemp: "You still need to change your temporary password",
      passwordScadutaCambio: "Your password has expired and must be changed"
    },
    ShowUserCode: {
      codice_utente: "User code",
      descrizione_codice: "Your user code allows you to be securely identified by other users on the platform.",
      mostra: "Show",
      nascondi: "Hide",
      codice: "code",
      etichetta_codice: "Your user code:",
      istruzioni_caregiver: "Show this code to your caregiver so they can find you and add you to their list of assisted users.",
      nota_validita: "Note: this code will be <u>valid until midnight today</u>.",
      errore_codice: "Unable to retrieve the code",
      codice_copiato: "Code copied!",
      copia_codice: "Copy code",
      button_label: "user"
    },
    NotificationChannels: {
      accessi_notifiche: "Access and Notifications",
      descrizione_accessi: "View and manage your access, and choose which notifications to receive through Concura channels.",
      notifiche_email1: "Email Notifications",
      email_question: "Do you want to {azione} email notifications?",
      attivare: "enable",
      disattivare: "disable",
      consenso_email: "You have consented to receive email notifications as stated in the",
      no_consenso_email: "You have not consented to receive email notifications as stated in the",
      informativa_privacy: "Privacy Policy",
      modifica: "Edit",
      ricezione_notifiche: "Notification reception",
      consent_push: "Consent to receive push notifications to get alerts in app",
      canale_telegram: "Telegram Channel",
      ricezione_stato: "Notification reception",
      attiva: "enabled",
      disattivata: "disabled",
      rimuovi_accesso: "Remove this access",
      nessun_accesso: "No active Telegram access",
      accedi_telegram: "Log in on Telegram!",
      elimina_accesso: "Delete access",
      annulla: "No, Cancel",
      conferma: "Yes, Confirm",
      vuoi_rimuovere: "Do you want to remove access via",
      accesso_da: "from",
      modifica_stato: "Edit notification reception status",
      vuoi: "Do you want to",
      attivare: "enable",
      disattivare: "disable",
      notifiche_messenger: "notification reception via",
      notifiche_push: "push notifications?",
      notifiche_email: "Email notifications",
      da: "from",
      conferma_operazione: "Confirm operation",
      consenso_email_title: "Email reception consent",
      acconsento_email: "I consent to receiving email notifications as stated in the",
      non_accetto: "I do not accept",
      salva_modifiche: "Save changes",
      errore_accessi: "Failed to retrieve accesses",
      accesso_eliminato: "Access successfully removed",
      errore_eliminazione: "Failed to remove access",
      modifiche_successo: "Changes saved successfully",
      errore_modifiche: "Unable to save changes",
      notifiche_push: "Push Notification"
    },
    StatoSottoscrizioniProfilo: {
      stato_profilo: "Profile Status",
      sottoscrizione_attesa: "Subscription pending payment:",
      mesi: "months",
      acquista: "Purchase",
      sottoscrizione_attiva: "Active subscription:",
      nessuna_sottoscrizione: "No active subscription.",
      vai_acquisti: "Go to Purchases",
      conferma_operazione: "Confirm operation",
      annulla: "No, Cancel",
      conferma: "Yes, Confirm",
      sei_sicuro_attivare: "Are you sure you want to activate the monitoring service for",
      testo_attivazione: `
    This operation will start the subscription activation process for the
    monitoring service: the patient will be assigned to a Service Center
    operator who will guide them through the service purchase procedure. <br />
    Also, if not yet configured, after confirming the operation you can
    select a suitable care path among the available options; otherwise, the
    "standard" monitoring of key parameters will be activated.<br />
    For the monitoring of key parameters, default threshold values and
    detection frequencies will be set.
  `,
      profilo_sospeso: "Profile successfully suspended.",
      errore_operazione: "The operation could not be completed.",
      attivazione_successo: "Activation successfully completed!"
    },
    PercorsoCuraPaziente: {
      percorso_di_cura: "Care plan",
      modifica_percorso: "Edit plan",
      nessun_percorso: "No care plan selected",
      seleziona_percorso: "Select plan",
      label_percorso: "Care plan*",
      scegli: "choose",
      dettagli_per: "Plan details for",
      piano_include: "The plan includes:",
      teleconsulti: "Scheduled teleconsultations",
      programmati_ogni: "scheduled every",
      questionari: "Questionnaires and evaluations",
      ogni: "every",
      monitoraggio_parametri: "Monitoring of parameters",
      dispositivi_indossabili: "Recommended wearable devices",
      annulla: "Cancel",
      modifica_percorso_di_cura: "Edit care plan",
      seleziona_percorso_di_cura: "Select care plan",
      modal_descrizione_modifica: "Edit the patient's care plan.",
      modal_descrizione_selezione: "Select the appropriate care plan based on the patient's needs.",
      conferma_modifica: "Confirm Edit",
      conferma_selezione: "Confirm Selection",
      percorso_aggiornato: "Care plan successfully updated",
      errore_lista_piani: "Unable to retrieve the list of available plans.",
      errore_operazione: "The operation could not be completed.",
      ogni_giorno: "every day"
    },
    EliminaProfilo: {
      titolo: "Delete Profile",
      sottotitolo: "Permanently delete your account",
      bottone_elimina: "Delete my profile",
      domanda_conferma: "Are you sure you want to delete your profile?",
      testo_conferma: `
          If you delete your profile, you will no longer be able to access the
          platform or use the available services. <br />
          This action is irreversible. Once confirmed, the deletion cannot be undone.
        `,
      title_conferma: "Confirm Operation",
      ok_elimina: "Yes, delete",
      annulla: "No, cancel"
    },
    AnagraficaComponent: {
      profilo: "Profile",
      modifica: "Edit",
      scegli_immagine: "Choose image",
      elimina: "Delete",
      carica_immagine: "Upload Image",
      titolo: "Title",
      titolo_placeholder: "Mr...",
      nome: "First name*",
      nome_placeholder: "First name...",
      cognome: "Last name*",
      cognome_placeholder: "Last name...",
      data_nascita: "Date of birth*",
      genere: "Gender",
      uomo: "male",
      donna: "female",
      codice_fiscale: "Tax code*",
      codice_fiscale_placeholder: "Tax code...",
      tessera_sanitaria: "Health Insurance Card Number",
      tessera_sanitaria_placeholder: "Card number...",
      nazione_nascita: "Country of birth*",
      medico_base: "Primary care doctor",
      medico_base_placeholder: "Primary care doctor...",
      asl: "Local Health Authority",
      scegli_asl: "Select local health authority",
      asl_placeholder: "Local health authority...",
      id_albo: "Medical Registry ID",
      id_albo_doppio: "Medical Registry ID**",
      id_albo_placeholder: "Registry ID...",
      specializzazione: "Specialization",
      specializzazione_placeholder: "Medical specialization...",
      annulla: "Cancel",
      salva: "Save",
      residenza: "Residence",
      regione: "Region*",
      regione_placeholder: "Region...",
      seleziona_regione: "Select Region",
      provincia: "Province*",
      provincia_placeholder: "Province...",
      seleziona_provincia: "Select Province",
      comune: "Municipality*",
      comune_placeholder: "Municipality...",
      seleziona_comune: "Select Municipality",
      indirizzo: "Address and street number*",
      indirizzo_placeholder: "Address...",
      cap: "ZIP code*",
      cap_placeholder: "ZIP code...",
      contatti: "Contacts",
      telefono: "Phone number",
      telefono_placeholder: "Phone...",
      telefono_domicilio: "Home phone",
      telefono_domicilio_placeholder: "Home phone...",
      telefono_riserva: "Backup phone",
      telefono_riserva_placeholder: "Backup phone...",
      torna_verifica: "return to verification",
      conferma_eliminazione: "Confirm deletion",
      conferma: "Yes, Confirm",
      domanda_eliminazione_immagine: "Do you confirm the deletion of the profile image?",
      immagine_eliminata_successo: "Profile image successfully deleted",
      errore_eliminazione: "Error deleting the note",
      immagine_caricata_successo: "Profile image uploaded successfully",
      errore_caricamento: "Error uploading the profile image",
      telefono_non_valido: "Invalid phone number",
      includere_sigla: "**Include province abbreviation",
      title_sig: "Mr.",
      title_sigra: "Ms.",
      title_dott: "Dr.",
      title_dottssa: "Dr. (female)",
      tipo_medici: "Doctors",
      tipo_dentisti: "Dentists",
      tipo_farmacisti: "Pharmacists",
      tipo_infermieri: "Nurses",
      tipo_biologi: "Biologists"
    },
    SessionLengthSetter: {
      timeout_sessione: "Session Timeout",
      descrizione: "Set when the session should expire. Once expired, you will be automatically logged out.",
      sessione_logout: "The session ends with logout",
      sessione_scade: "The session expires after",
      minuti_inattivita: "minutes of inactivity",
      annulla: "Cancel",
      salva_modifiche: "Save Changes",
      successo: "Session timeout successfully updated",
      errore: "Error updating session timeout"
    },
    CompilaQuestionarioCittadino: {
      questionario_prenotazione: "Questionnaire for the appointment scheduled on",
      ore: "at",
      consenso: "I have read the privacy policy and I give my consent",
      procedi: "Proceed",
      operazione_completata: "Operation completed.",
      vai_agenda: "Go to calendar",
      questionario_gia_compilato: "You have already filled out the questionnaire.",
      errore_attivita: "Failed to retrieve activities",
      questionario_inviato: "Questionnaire successfully submitted.",
      errore_invio: "Failed to submit the questionnaire"
    },
    FillScoreSurveyCittadino: {
      consenso: "I have read the information and I give my consent",
      procedi: "Proceed",
      operazione_completata: "Operation completed.",
      vai_agenda: "Go to agenda",
      questionario_gia_compilato: "You have already completed the questionnaire.",
      errore_attivita: "Unable to retrieve activities",
      questionario_inviato: "Questionnaire successfully submitted.",
      errore_invio: "Unable to submit the questionnaire"
    },
    NuovaTerapiaAssistito: {
      pazienti: "Patients",
      nessun_paziente: "No patient selected",
      profilo_sanitario: "Health profile",
      riepilogo: "Summary",
      scarica_promemoria: "Download reminder",
      torna_profilo: "Back to health profile",
      errore_scaricamento: "Failed to download the reminder"
    },
    PianoTerapeuticoCittadino: {
      indietro: "Back",
      piano_terapeutico: "Therapeutic plan",
      caricato_in_data: "Uploaded on:",
      validita: "Validity:",
      stato: "Status:",
      farmacia: "Pharmacy",
      telefono: "Phone",
      indirizzo: "Address",
      mostra_piano: "Show Therapeutic Plan",
      nascondi_piano: "Hide Therapeutic Plan",
      caricamento: "Loading...",
      farmaci_previsti: "Medications included in the Therapeutic Plan",
      consegnato: "Delivered",
      quantita: "Quantity:",
      pacchetti_programmati: "Scheduled delivery packages for the Therapeutic Plan",
      pacchetto: "Package",
      stato_pacchetto: "Package status:",
      farmaci_contenuti: "Medications contained in the package",
      conf: "pack",
      scadenza: "exp.",
      lotto: "batch",
      piano_non_trovato: "Plan not found",
      errore_info: "Unable to retrieve the requested information",
      scegli: "choose...",
      attesa_autorizzazione: "Awaiting authorization",
      classe_c: "class C",
      no_ssn: "Not covered by NHS",
      autorizzato_classe_a: "authorized class A",
      rimborsabile: "Authorized as reimbursable",
      autorizzato_dpc: "authorized DPC",
      per_conto: "Authorized for third-party dispensing",
      autorizzato_dd: "authorized DD",
      distribuzione_diretta: "Authorized for direct distribution",
      etichetta: "Label"
    },
    FamiliariView: {
      genere: "Gender",
      data_nascita: "Date of birth",
      non_indicata: "Not specified",
      vai_profilo_sanitario: "Go to health profile",
      disabilita: "Disable",
      abilita: "Enable",
      abilitata: "Enabled",
      vuoi_abilitare: "Do you want to enable this caregiver?",
      vuoi_disabilitare: "Do you want to disable this caregiver?",
      abilita_caregiver: "Enable caregiver",
      disabilita_caregiver: "Disable caregiver",
      errore_recupero_informazioni: "Error retrieving information",
      caregiver_abilitato: "Caregiver successfully enabled",
      errore_operazione: "Operation failed",
      caregiver_disabilitato: "Caregiver successfully disabled"
    },
    Routes: {
      cittadino_home: "Citizen Home",
      familiari: "Your family members",
      appuntamenti: {
        prestazione: "Visits and Services",
        prodotto: "Medications",
        teleconsulto: "Teleconsultations"
      },
      agenda: "Your schedule",
      il_tuo_consulto: "Your consultation",
      circolo_di_cura: "Your care circle",
      sottoscrizioni_paziente: "Purchases and Subscriptions",
      progetti_cittadino: "Blog",
      profilo_sanitario: "Health profile",
      profilo_cittadino: "Personal data",
      impostazioni: "Settings",
      guida_cittadino: "Guide",
      completa_questionario: "Complete the questionnaire",
      score_questionario: "Complete the questionnaire",
      nuova_terapia_assistito: "New therapy",
      acquisto: "Purchase",
      pagina_non_trovata: "Page not found",
      verifica_numero: "Verify your number",
      verifica_email: "Verify your email",
      teleconsulti: {
        tcemergenza: "Quick Teleconsultation",
        pediatrico: "Pediatric Teleconsultation",
        specialistico: "Specialist Teleconsultation",
        teleconsulto: "Teleconsultations"
      }
    },
    NavigationCittadino: {
      prenotazioni: "Bookings",
      visite: "Visits and Services",
      farmaci: "Medications",
      teleconsulti: "Teleconsultations",
      rapido: "Quick",
      pediatrico: "Pediatric",
      specialistico: "Specialist",
      familiari: "Family Members",
      tutti: "All",
      nuovo: "New",
      blog: "Blog",
      profilo_sanitario: "Health Profile",
      circolo: "Care Circle",
      gestione: "Management",
      strumenti: "Tools",
      report: "Reports",
      acquisti: "Purchases",
      sottoscrizioni: "Subscriptions",
      storico: "History",
      agenda: "Schedule",
      pazienti: "Patients",
      impostazioni: "Settings",
      consulta: "View",
      guida: "Help",
      servizi: "SERVICES",
      pagine: "PAGES"
    },
    NotificationCenter: {
      title: "Notifications",
      browserPermission: "To receive notifications you must authorize their reception on your browser.",
      noNotifications: "No new notifications."
    },
    CallSupportModal: {
      chiama: "Call the toll-free number",
      chiama_per_prenotare: "To book, call the toll-free number",
      operatori: "Our operators are available Monday to Friday from 9:00 AM to 6:00 PM"
    },
    PopupModal: {
      procedi: "Proceed",
      errore_invito: "It was not possible to invite the doctor",
      success_grazie: "Thank you for your response",
      errore_risposta: "It was not possible to submit the response"
    },
    SomministraCustomTeleconsultoSurvey: {
      compila_questionario: "Fill out the questionnaire for the Teleconsultation",
      compilazione_obbligatoria: "(completion is mandatory)",
      consenso_informativa: "I have read the privacy notice and give my consent",
      procedi: "Proceed",
      questionario_gia_compilato: "You have already completed the questionnaire.",
      vai_agenda: "Go to schedule",
      errore_recupero_attivita: "Unable to retrieve activities",
      successo_questionario: "Questionnaire submitted successfully.",
      errore_questionario: "Unable to submit the questionnaire"
    },
    FillCustomTeleconsultoSurvey: {
      ok_procedi: "Ok, Proceed",
      placeholder_scrivi: "Write here",
      torna_indietro: "Go back",
      procedi: "Proceed",
      salta: "Skip",
      salva_immagine: "Save Image"
    },
    FreeSubscription: {
      descrizione: "Free subscription",
      dettaglio: '<p class="m-0">Fast booking for visits and services: €10 </p><p class="m-0">Teleconsultation or telemedicine service: €10</p><p class="m-0">Prescription booking: €4</p>'
    },
    app: {
      partita_iva: "VAT Number:",
      termini_condizioni: "Terms and Conditions",
      informativa_privacy: "Privacy Policy",
      note_rilascio: "Release notes"
    },
    nexi: {
      esito: {
        OK: "Transaction completed successfully",
        KO: "Transaction failed",
        ANNULLO: "Transaction canceled",
        ERRORE: "Transaction error",
        PEN: "Transaction pending",
      },
      messaggi: {
        "Message OK": "Transaction authorized.",
        "Controllo CF": "Card PAN already associated with another tax code.",
        "Controllo PAN": "This tax code is already associated with the maximum number of cards.",
        "Controllo BLACKLIST": "Transaction blocked due to blacklist rules.",
        "Controllo CF/PAN": "Mismatch between PAN and tax code.",
        "Auth. Denied": "Transaction not authorized.",
        "Impossibile eseguire la Post di Notifica": "Transaction canceled due to server-to-server notification failure.",
        "3D Secure annullato da utente": "3D Secure authentication not completed or canceled by user.",
        "Carta non autorizzata causa applicazione regole BIN table": "Card denied by BIN table rules.",
        "Problema 3DSecure": "3D Secure issue during authentication.",
        "expired card": "Expired card or merchant not enabled.",
        "Invalid merchant": "Invalid or revoked merchant code.",
        "transaction not permitted": "Transaction not permitted.",
        "not sufficient funds": "Insufficient funds on card.",
        "Technical problem": "Technical issue in authorization system.",
        "Host not found": "Issuer authorization system not available.",
        "Transazione chiusa per time-out": "Transaction closed due to timeout.",
        "Controllo PAN/CONTRATTO": "PAN linked to another contract.",
        "Numero di tentativi di retry esaurito": "Retry attempts exceeded.",
        "soft decline": "Strong customer authentication required. Please retry.",
        "Transazione avvenuta correttamente": "Transaction completed successfully.",
      },
    },
    aggiornata_successo: "Profile successfully updated!",
    common: {
      scegli: "Choose"
    },
    PatientAnamnesi: {
      salva: "Save",
      annulla: "Cancel",
      titoloConfermaEliminazione: "Delete confirmation",
      siProcedi: "Yes, proceed",
      noAnnulla: "No, cancel",
      testoConfermaEliminazione: "Are you sure you want to delete the note",
      labelAllergie: "Known allergies, previous allergic reactions",
      labelEventiPregressi: "Past events",
      labelOspedalizzazioni: "Surgical procedures, hospitalizations",
      labelEventiAvversi: "Adverse drug reactions",
      labelCondizioniNote: "Known conditions in the family",
      nuovaNota: "New note {categoria}",
      nota: "Note",
      erroreCaricamentoNote: "Error while loading notes",
      notaAggiornata: "Note successfully updated",
      erroreAggiornamentoNota: "Error while updating the note",
      notaCreata: "Note successfully created",
      erroreCreazioneNota: "Error while creating the note",
      notaEliminata: "Note successfully deleted",
      erroreEliminazioneNota: "Error while deleting the note",
      allergiePlaceholder: "Food, environmental allergies, type and severity of previous allergic reactions...",
      pregressoPlaceholder: "Relevant past events to report...",
      ospedalizzazionePlaceholder: "Previous hospitalizations, major trauma, surgeries...",
      eventiAvversiPlaceholder: "Side effects, adverse drug reactions..."
    },
    uploader: {
      placeholder: "Choose file...",
      carica: "Upload",
      caricamento_completato: "Upload completed",
      anteprima_pdf_titolo: "View PDF and proceed to upload",
      anteprima_immagine_titolo: "View image and proceed to upload",
      annulla_caricamento: "Cancel file upload",
      conferma_caricamento: "Confirm file upload",
      caricamento_in_corso: "Loading...",
      anteprima_immagine_alt: "Image preview"
    },
    zip_code: "ZIP Code",
    sono_cittadino_residente: "I am a citizen resident in Italy with Tax Code",
    SignedDocumentsList: {
      title: "Signed documents",
      signedOn: "Signed on {date}",
      download: "Download",
      downloadError: "Error downloading document"
    },
    CompilazioneSessione: {
      close: "Close",
      torna_alle_sessioni: "Back to Sessions",
      scheda_paziente: "Patient Chart",
      seleziona_paziente: "Select the patient for session administration:",
      registra_paziente: "Register Patient",
      paziente_selezionato: "Selected patient:",
      nome_cognome: "NAME AND SURNAME",
      codice_fiscale: "TAX CODE",
      annulla_selezione: "Clear selection",
      avvia_sessione: "Start session",
      inserisci_pseudonimo: "Enter pseudonym*:",
      conferma: "Confirm",
      paziente_label: "Patient:",
      attenzione: "Attention!",
      informativa: "Information notice",
      consenso: "I have read the information notice and I give my consent",
      procedi: "Proceed",
      operazione_completata: "Operation completed.",
      operazione_non_consentita: "Operation not allowed.",
      cf_mancante: "For clear sessions, the patient's Tax Code is required.",
      errore_caricamento_sessione: "Unable to load session data",
      errore_avvio_sessione: "Unable to start session",
      errore_caricamento_questionario: "Unable to load questionnaire",
      errore_invio_questionario: "Unable to submit questionnaire",
      sessione_completata: "Session completed",
      errore_recupero_utente: "Unable to retrieve user information",
      necessaria_verifica_secondario: "Since the patient does not have an email address, the secondary phone number must also be verified.",
      necessaria_verifica_numero: "To proceed, the patient's phone number must be verified.",
      avviso_cancellazione_mezzanotte: "The session has not been signed. If you do not sign within {days} days, it will be deleted.",
      chiudi: "Close",
      riepilogo_compilazioni: "Session summary",
      tab_questionario: "Survey",
      tab_data: "Date",
      tab_punteggio: "Score",
      tab_azioni: "Actions",
      visualizza_dettaglio_compilazione: "View compilation details",
      nessuna_compilazione: "No compilations available",
      firmata_da_alle: "Signed by {nome} at {ora} on {giorno}",
      firma_richiesta_warning: "Signature required: send OTP",
      otp_verifica_titolo: "OTP verification",
      otp_verifica_testo: "Send the OTP code to the patient to validate the compilation.",
      invia_otp: "Send OTP"
    },
    HomeSessioni: {
      sessione_creata_successo: "Session created successfully",
      sessione_avviata_successo: "Session started successfully",
      sessione_eliminata_successo: "Session deleted successfully",
      errore_caricamento_sessioni: "Error loading sessions",
      errore_caricamento_attivita: "Error loading activities",
      nome_questionario_obbligatori: "Session name and at least one survey are required",
      almeno_due_questionari_obbligatori: "Session name and at least two surveys are required",
      errore_creazione_sessione: "Error creating session",
      errore_avvio_sessione: "Error starting session",
      errore_eliminazione_sessione: "Error deleting session",
      nessuna_sessione_trovata: "No sessions found",
      crea_nuova_sessione: "new session",
      titolo_crea_nuova_sessione: "New session",
      nome_sessione_asterisco: "Session Name *",
      inserisci_nome_sessione: "Enter session name",
      descrizione: "Description",
      descrizione_opzionale: "Optional description",
      questionari_asterisco: "Surveys *",
      questionari_disponibili: "Available Surveys",
      cerca_questionari: "Search surveys",
      placeholder_cerca_questionari: "Type to filter by name",
      questionari_selezionati: "Selected Surveys",
      nessun_questionario_selezionato: "No surveys selected",
      seleziona_questionari_per_iniziare: "Select surveys from available ones to compose the session",
      caricamento_attivita: "Loading activities...",
      nessun_questionario_disponibile: "No surveys available",
      attivo: "Active",
      inattivo: "Inactive",
      questionari_sessione_ordinati: "Session surveys",
      nessun_questionario_configurato: "No surveys configured for this session.",
      visualizza_questionari: "View surveys",
      nessuna_descrizione: "No description",
      visualizza_dettaglio: "View details",
      informazioni_sessione: "Session information",
      giorni_firma_asterisco: "Days to sign *",
      placeholder_giorni_firma: "Enter days (1-15)",
      aiuto_giorni_firma: "Number of days within which the operator must sign the session; after the deadline the session is deleted. Allowed values 1–15; default 3.",
      ruoli_consentiti: "Allowed roles",
      somministra_sessione: "Administer session",
      permesso_somministra_mancante: "Missing administer permission",
      ruoli_non_autorizzati_msg: "You don't have the required roles: {ruoli}",
      ruoli_non_autorizzati_generico: "You don't have the required roles to administer this session",
      elimina_sessione: "Delete session",
      creata_da: "Created by",
      eliminazione_non_consentita_sessione_somministrata: "Cannot delete: at least one compilation exists for this session",
      conferma_eliminazione_sessione: "Are you sure you want to delete the session \"{nome}\"?",
      nessuna_compilazione_associata: "There are no compilations associated with this session.",
      espandi_dettagli: "Expand survey details",
      comprimi_dettagli: "Collapse survey details",
      cerca_sessione: "Search sessions by name",
      seleziona_elementi_per_pagina: "Select number of items per page",
      filtra_per_stato: "Filter sessions by status",
      elementi_per_pagina: "Items per page",
      stato_filtro: "Status filter",
      caricamento_sessioni: "Loading sessions",
      lista_sessioni: "Sessions list",
      dettagli_questionari: "Session surveys details",
      posizione_questionario: "Survey {numero}: {nome}",
      stato_sessione: "Status: {stato}",
      questionari_totali: "{totale} surveys found",
      nome: "Name",
      descrizione: "Description",
      tipologia: "Type",
      somministrati: "Administered",
      stato: "Status",
      azioni: "Actions",
      tutti_stati: "All statuses",
      in_attesa: "Pending",
      in_corso: "In progress",
      completate: "Completed",
      annullate: "Cancelled",
      filtri_e_paginazione: "Filter and pagination controls",
      tipo_questionari_asterisco: "Survey Type *",
      anonimo: "Anonymous",
      pseudoanonimo: "Pseudonymous",
      in_chiaro: "Clear",
      tutti_operatori_autorizzati: "All operators are authorized",
      si: "Yes",
      no_solo_ruoli_specifici: "No, only specific roles",
      ruoli_consentiti_label: "Select allowed roles",
      somministrazione_consentita_ai_ruoli: "Administration allowed to roles",
      rimuovi_ruolo: "Remove role {name}",
      questionari_in_chiaro: "Clear Surveys",
      questionari_anonimi: "Anonymous Surveys",
      questionari_pseudoanonimi: "Pseudonymous Surveys",
      tipo_in_chiaro_desc: "Survey data is directly linked to patient identity",
      tipo_anonimo_desc: "Survey data cannot be linked to any specific identity",
      tipo_pseudoanonimo_desc: "Survey data is linked through an anonymous code",
      questionari: "Surveys",
      nessuna_attivita_tipo_selezionato: "No activities available for the selected survey type",
      numero_questionari_selezionati: "{count} surveys selected",
      lista_questionari_ordinabili: "Sortable survey list via drag and drop",
      questionario_posizione: "Survey {numero}: {nome}",
      rimuovi_questionario: "Remove survey {nome}",
      lista_attivita_questionari: "List of activities with available surveys",
      attivita_con_questionari: "Activity {nome} with surveys",
      espandi_attivita: "Expand activity {nome} - {stato}",
      espansa: "expanded",
      chiusa: "collapsed",
      questionari_attivita: "Available surveys for activity {nome}",
      questionario_item: "Survey: {nome}",
      aggiungi_questionario: "Add survey {nome} to session",
      visualizza_dettaglio_compilazione: "View compilation details"
    },
    PatientSurveySessions: {
      titolo: "Sessions",
      nessuna_descrizione: "No description",
      somministra_sessione: "Administer session",
      nessuna_sessione: "No sessions available",
      nuova_sessione: "new session",
      seleziona_sessione: "Select session",
      procedi: "Proceed",
      cerca_sessione: "Search session",
      filtro_in_chiaro: "Cleartext only",
      filtro_attive: "Active only",
      nessun_risultato: "No results",
      permesso_somministra_mancante: "Missing administer permission",
      ruoli_non_autorizzati_generico: "You don't have the required roles to administer this session",
      ruoli_non_autorizzati_msg: "You are missing required roles: {ruoli}",
      cf_mancante: "Tax Code is required for cleartext sessions.",
      in_chiaro: "Cleartext",
      pseudoanonimo: "Pseudonymous",
      anonimo: "Anonymous",
      item_position: "Item {number}: {name}",
      errore_caricamento_sessioni: "Error while loading sessions",
      lista_sessioni: "Session list"
    },
    DettaglioSessioneModal: {
      titolo_dettaglio_sessione: "Session Details",
      contenuto_dettaglio_sessione: "Session details content",
      informazioni_sessione: "Session information",
      questionari_configurati: "surveys configured",
      stato_sessione: "Status: {stato}",
      istanze_compilazione: "Compilation instances",
      compilazioni_sessione: "Session Compilations",
      totale_compilazioni: "{totale} total compilations",
      nessuna_compilazione: "No compilations found",
      lista_istanze: "Compilation instances list",
      caricamento_istanze: "Loading instances",
      paziente: "Patient",
      stato: "Status",
      data_inizio: "Start Date",
      data_completamento: "Completion Date",
      cf: "Tax Code",
      progresso: "Progress",
      azioni: "Actions",
      in_corso: "In progress",
      progresso_compilazione: "Progress: {percentuale}%",
      visualizza_dettaglio_compilazione: "View compilation details",
      errore_caricamento_sessione: "Error loading session details",
      errore_caricamento_dettagli: "Error loading details",
      chiudi_dettagli: "Close details",
      paziente_anonimo: "Anonymous patient",
      istanza_iniziata: "Started",
      istanza_in_corso: "In progress",
      istanza_completata: "Completed",
      istanza_abbandonata: "Abandoned",
      stato_in_attesa: "Pending",
      stato_in_corso: "In progress",
      stato_completate: "Completed",
      stato_annullate: "Cancelled",
      funzione_in_sviluppo: "Feature under development"
    },
    DettaglioSessione: {
      sessioni: "Sessions",
      titolo_compilazioni_sessione: "Session compilations",
      titolo_dettaglio_sessione: "Session Details",
      torna_alle_sessioni: "Back to Sessions",
      sessione_non_trovata: "Session not found",
      nessuna_compilazione: "No compilations found",
      paziente: "Patient",
      stato: "Status",
      cf: "Tax Code",
      questionario: "Survey",
      data: "Date",
      punteggio: "Score",
      data_inizio: "Start Date",
      data_completamento: "Completion Date",
      progresso: "Progress",
      azioni: "Actions",
      filtro_cf: "Tax Code",
      elementi_per_pagina: "Items per page",
      seleziona_elementi_per_pagina: "Select number of items per page",
      cf_solo_in_chiaro: "Filter available only for clear sessions",
      chiudi: "Close",
      in_corso: "In progress",
      progresso_compilazione: "Progress: {percentuale}%",
      visualizza_dettaglio_compilazione: "View compilation details",
      errore_caricamento_sessione: "Error loading session details",
      errore_caricamento_dettagli: "Error loading details",
      paziente_anonimo: "Anonymous patient",
      istanza_iniziata: "Started",
      istanza_in_corso: "In progress",
      istanza_completata: "Completed",
      istanza_abbandonata: "Abandoned",
      stato_in_attesa: "Pending",
      stato_in_corso: "In progress",
      stato_completate: "Completed",
      stato_annullate: "Cancelled",
      funzione_in_sviluppo: "Feature under development"
    }   ,
    RiepilogoCompilazioniTable: {
      tab_questionario: "Questionario",
      tab_data: "Data",
      tab_punteggio: "Punteggio",
      tab_azioni: "Azioni",
      visualizza_dettaglio_compilazione: "Visualizza dettaglio compilazione",
      nessuna_compilazione: "Nessuna compilazione disponibile"
    },
    CompilazioneSessione: {
      chiudi: "Chiudi",
      riepilogo_compilazioni: "Session summary",
      tab_questionario: "Questionario",
      tab_data: "Data",
      tab_punteggio: "Punteggio",
      tab_azioni: "Azioni",
      visualizza_dettaglio_compilazione: "Visualizza dettaglio compilazione",
      nessuna_compilazione: "Nessuna compilazione disponibile",
      firmata_da_alle: "Firmata da {nome} alle {ora} del {giorno}",
      firma_richiesta_warning: "Firma richiesta: invia OTP",
      otp_verifica_titolo: "OTP verification",
      otp_verifica_testo: "An OTP verification request has been sent to the patient.",
      sessione_completata: "Session completed",
      errore_invio_questionario: "Unable to send the survey",
      errore_caricamento_questionario: "Unable to load the survey",
      errore_caricamento_sessione: "Unable to load session",
      errore_avvio_sessione: "Unable to start session",
      cf_mancante: "Missing tax code",
      torna_alle_sessioni: "Back to Sessions",
      scheda_paziente: "Patient profile",
      seleziona_paziente: "Select the patient to administer the survey:",
      registra_paziente: "Register Patient",
      paziente_selezionato: "Selected patient:",
      nome_cognome: "NAME AND SURNAME",
      codice_fiscale: "TAX CODE",
      annulla_selezione: "Deselect",
      inserisci_pseudonimo: "Enter pseudonym*:",
      conferma: "Confirm",
      paziente_label: "Patient:",
      attenzione: "Attention!",
      informativa: "Information",
      consenso: "I have read the information and give my consent",
      procedi: "Proceed",
      operazione_completata: "Operation completed.",
      operazione_non_consentita: "Operation not allowed."
    }
  }
}
